export var ErrorCodeApi;
(function (ErrorCodeApi) {
    ErrorCodeApi["INTERNAL_SERVER_ERROR"] = "INTERNAL_SERVER_ERROR";
    ErrorCodeApi["NOT_IMPLEMENTED"] = "NOT_IMPLEMENTED";
    ErrorCodeApi["BAD_GATEWAY"] = "BAD_GATEWAY";
    ErrorCodeApi["SERVICE_UNAVAILABLE"] = "SERVICE_UNAVAILABLE";
    ErrorCodeApi["GATEWAY_TIMEOUT"] = "GATEWAY_TIMEOUT";
    ErrorCodeApi["SITEWIDE_SCHEDULED_MAINTENANCE"] = "SITEWIDE_SCHEDULED_MAINTENANCE";
    ErrorCodeApi["BAD_REQUEST"] = "BAD_REQUEST";
    ErrorCodeApi["UNAUTHORIZED"] = "UNAUTHORIZED";
    ErrorCodeApi["PAYMENT_REQUIRED"] = "PAYMENT_REQUIRED";
    ErrorCodeApi["FORBIDDEN"] = "FORBIDDEN";
    ErrorCodeApi["NOT_FOUND"] = "NOT_FOUND";
    ErrorCodeApi["METHOD_NOT_ALLOWED"] = "METHOD_NOT_ALLOWED";
    ErrorCodeApi["NOT_ACCEPTABLE"] = "NOT_ACCEPTABLE";
    ErrorCodeApi["CONFLICT"] = "CONFLICT";
    ErrorCodeApi["REQUEST_ENTITY_TOO_LARGE"] = "REQUEST_ENTITY_TOO_LARGE";
    ErrorCodeApi["REQUEST_URI_TOO_LONG"] = "REQUEST_URI_TOO_LONG";
    ErrorCodeApi["UNSUPPORTED_MEDIA_TYPE"] = "UNSUPPORTED_MEDIA_TYPE";
    ErrorCodeApi["TOO_MANY_REQUESTS"] = "TOO_MANY_REQUESTS";
    ErrorCodeApi["MALFORMED_JSON"] = "MALFORMED_JSON";
    ErrorCodeApi["TYPE_VALIDATION_FAILED"] = "TYPE_VALIDATION_FAILED";
    ErrorCodeApi["REQUIRED_VALIDATION_FAILED"] = "REQUIRED_VALIDATION_FAILED";
    ErrorCodeApi["ENUM_VALIDATION_FAILED"] = "ENUM_VALIDATION_FAILED";
    ErrorCodeApi["PATTERN_VALIDATION_FAILED"] = "PATTERN_VALIDATION_FAILED";
    ErrorCodeApi["CONST_VALIDATION_FAILED"] = "CONST_VALIDATION_FAILED";
    ErrorCodeApi["MAX_VALUE_VALIDATION_FAILED"] = "MAX_VALUE_VALIDATION_FAILED";
    ErrorCodeApi["MIN_VALUE_VALIDATION_FAILED"] = "MIN_VALUE_VALIDATION_FAILED";
    ErrorCodeApi["MAX_LENGTH_VALIDATION_FAILED"] = "MAX_LENGTH_VALIDATION_FAILED";
    ErrorCodeApi["MIN_LENGTH_VALIDATION_FAILED"] = "MIN_LENGTH_VALIDATION_FAILED";
    ErrorCodeApi["MAX_ITEMS_VALIDATION_FAILED"] = "MAX_ITEMS_VALIDATION_FAILED";
    ErrorCodeApi["MIN_ITEMS_VALIDATION_FAILED"] = "MIN_ITEMS_VALIDATION_FAILED";
    ErrorCodeApi["UNIQUE_ITEMS_VALIDATION_FAILED"] = "UNIQUE_ITEMS_VALIDATION_FAILED";
    ErrorCodeApi["MULTIPLE_OF_VALIDATION_FAILED"] = "MULTIPLE_OF_VALIDATION_FAILED";
    ErrorCodeApi["LOCATION_COORDINATES_VALIDATION_FAILED"] = "LOCATION_COORDINATES_VALIDATION_FAILED";
    ErrorCodeApi["COURSE_NOT_AUTHORED"] = "COURSE_NOT_AUTHORED";
    ErrorCodeApi["COURSE_DELETED"] = "COURSE_DELETED";
    ErrorCodeApi["COURSE_CLOSED"] = "COURSE_CLOSED";
    ErrorCodeApi["COURSE_PUBLISHED"] = "COURSE_PUBLISHED";
    ErrorCodeApi["COURSE_UNPUBLISHED"] = "COURSE_UNPUBLISHED";
    ErrorCodeApi["COURSE_HAS_STUDENTS"] = "COURSE_HAS_STUDENTS";
    ErrorCodeApi["PROJECT_UPGRADE_DUPLICATE"] = "PROJECT_UPGRADE_DUPLICATE";
    ErrorCodeApi["PROJECT_UPGRADE_AWARDED"] = "PROJECT_UPGRADE_AWARDED";
    ErrorCodeApi["DEPOSIT_USER_ID_INVALID"] = "DEPOSIT_USER_ID_INVALID";
    ErrorCodeApi["DEPOSIT_METHOD_INVALID"] = "DEPOSIT_METHOD_INVALID";
    ErrorCodeApi["DEPOSIT_ACTION_INVALID"] = "DEPOSIT_ACTION_INVALID";
    ErrorCodeApi["DEPOSIT_CANCEL_URL_INVALID"] = "DEPOSIT_CANCEL_URL_INVALID";
    ErrorCodeApi["DEPOSIT_INVOICE_ID_INVALID"] = "DEPOSIT_INVOICE_ID_INVALID";
    ErrorCodeApi["DEPOSIT_CURRENCY_ID_INVALID"] = "DEPOSIT_CURRENCY_ID_INVALID";
    ErrorCodeApi["DEPOSIT_AMOUNT_INVALID"] = "DEPOSIT_AMOUNT_INVALID";
    ErrorCodeApi["DEPOSIT_CONFIRM_URL_REQUIRED"] = "DEPOSIT_CONFIRM_URL_REQUIRED";
    ErrorCodeApi["DEPOSIT_CONFIRM_URL_INVALID"] = "DEPOSIT_CONFIRM_URL_INVALID";
    ErrorCodeApi["DEPOSIT_COUNTRY_CODE_REQUIRED"] = "DEPOSIT_COUNTRY_CODE_REQUIRED";
    ErrorCodeApi["DEPOSIT_CANCEL_URL_REQUIRED"] = "DEPOSIT_CANCEL_URL_REQUIRED";
    ErrorCodeApi["DEPOSIT_AUTHORIZATION_EXISTS"] = "DEPOSIT_AUTHORIZATION_EXISTS";
    ErrorCodeApi["PAYMENT_VERIFICATION_REQUIRED"] = "PAYMENT_VERIFICATION_REQUIRED";
    ErrorCodeApi["EMAIL_VERIFICATION_REQUIRED"] = "EMAIL_VERIFICATION_REQUIRED";
    ErrorCodeApi["PROFILE_INCOMPLETE"] = "PROFILE_INCOMPLETE";
    ErrorCodeApi["KYC_REQUIRED"] = "KYC_REQUIRED";
    ErrorCodeApi["ESCROWCOM_ACCOUNT_UNLINKED"] = "ESCROWCOM_ACCOUNT_UNLINKED";
    ErrorCodeApi["PHONE_VERIFICATION_REQUIRED"] = "PHONE_VERIFICATION_REQUIRED";
    ErrorCodeApi["DEPOSIT_IDEAL_BANK_INVALID"] = "DEPOSIT_IDEAL_BANK_INVALID";
    ErrorCodeApi["DEPOSIT_IDEAL_BANK_REQUIRED"] = "DEPOSIT_IDEAL_BANK_REQUIRED";
    ErrorCodeApi["DEPOSIT_BOLETO_NAME_REQUIRED"] = "DEPOSIT_BOLETO_NAME_REQUIRED";
    ErrorCodeApi["DEPOSIT_BOLETO_DOCUMENT_REQUIRED"] = "DEPOSIT_BOLETO_DOCUMENT_REQUIRED";
    ErrorCodeApi["DEPOSIT_BOLETO_PHONE_REQUIRED"] = "DEPOSIT_BOLETO_PHONE_REQUIRED";
    ErrorCodeApi["DEPOSIT_BOLETO_ADDRESS_REQUIRED"] = "DEPOSIT_BOLETO_ADDRESS_REQUIRED";
    ErrorCodeApi["DEPOSIT_BOLETO_STREET_NUMBER_REQUIRED"] = "DEPOSIT_BOLETO_STREET_NUMBER_REQUIRED";
    ErrorCodeApi["DEPOSIT_BOLETO_CITY_REQUIRED"] = "DEPOSIT_BOLETO_CITY_REQUIRED";
    ErrorCodeApi["DEPOSIT_BOLETO_STATE_REQUIRED"] = "DEPOSIT_BOLETO_STATE_REQUIRED";
    ErrorCodeApi["DEPOSIT_BOLETO_ZIP_REQUIRED"] = "DEPOSIT_BOLETO_ZIP_REQUIRED";
    ErrorCodeApi["DEPOSIT_BOLETO_ZIP_INVALID"] = "DEPOSIT_BOLETO_ZIP_INVALID";
    ErrorCodeApi["DEPOSIT_BOLETO_BIRTHDATE_REQUIRED"] = "DEPOSIT_BOLETO_BIRTHDATE_REQUIRED";
    ErrorCodeApi["DEPOSIT_FLNBLN_GATEWAY_REQUIRED"] = "DEPOSIT_FLNBLN_GATEWAY_REQUIRED";
    ErrorCodeApi["DEPOSIT_FLNBLN_GATEWAY_INVALID"] = "DEPOSIT_FLNBLN_GATEWAY_INVALID";
    ErrorCodeApi["DEPOSIT_WIRE_SENDER_NAME_REQUIRED"] = "DEPOSIT_WIRE_SENDER_NAME_REQUIRED";
    ErrorCodeApi["DEPOSIT_WIRE_SEND_DATE_REQUIRED"] = "DEPOSIT_WIRE_SEND_DATE_REQUIRED";
    ErrorCodeApi["DEPOSIT_WIRE_COMMENTS_REQUIRED"] = "DEPOSIT_WIRE_COMMENTS_REQUIRED";
    ErrorCodeApi["PAYMENT_SOURCE_TOKEN_INVALID"] = "PAYMENT_SOURCE_TOKEN_INVALID";
    ErrorCodeApi["EMAIL_ALREADY_VERIFIED"] = "EMAIL_ALREADY_VERIFIED";
    ErrorCodeApi["USER_ACCOUNT_CLOSED_OR_SUSPENDED"] = "USER_ACCOUNT_CLOSED_OR_SUSPENDED";
    ErrorCodeApi["EMAIL_VERIFICATION_CODE_MISMATCH"] = "EMAIL_VERIFICATION_CODE_MISMATCH";
    ErrorCodeApi["VIDEO_VERIFICATION_REQUEST_INVALID"] = "VIDEO_VERIFICATION_REQUEST_INVALID";
    ErrorCodeApi["BIN_NON_RECURRING"] = "BIN_NON_RECURRING";
    ErrorCodeApi["EMPLOYER_AWARD_RESTRICTION"] = "EMPLOYER_AWARD_RESTRICTION";
    ErrorCodeApi["FREELANCER_AWARD_RESTRICTION"] = "FREELANCER_AWARD_RESTRICTION";
    ErrorCodeApi["FREELANCER_ACCOUNT_UNDER_REVIEW"] = "FREELANCER_ACCOUNT_UNDER_REVIEW";
    ErrorCodeApi["MAXIMUM_AWARDED_BIDDERS_REACHED"] = "MAXIMUM_AWARDED_BIDDERS_REACHED";
    ErrorCodeApi["FREELANCER_ALREADY_AWARDED"] = "FREELANCER_ALREADY_AWARDED";
    ErrorCodeApi["PROJECT_CLOSED"] = "PROJECT_CLOSED";
    ErrorCodeApi["PROJECT_ALREADY_ACCEPTED"] = "PROJECT_ALREADY_ACCEPTED";
    ErrorCodeApi["IP_AGREEMENT_NOT_SIGNED"] = "IP_AGREEMENT_NOT_SIGNED";
    ErrorCodeApi["BID_AMOUNT_TOO_HIGH"] = "BID_AMOUNT_TOO_HIGH";
    ErrorCodeApi["BID_AMOUNT_TOO_LOW"] = "BID_AMOUNT_TOO_LOW";
    ErrorCodeApi["COMMITMENT_INTERVAL_INVALID"] = "COMMITMENT_INTERVAL_INVALID";
    ErrorCodeApi["COMMITMENT_INVALID"] = "COMMITMENT_INVALID";
    ErrorCodeApi["CURRENCY_ID_INVALID"] = "CURRENCY_ID_INVALID";
    ErrorCodeApi["DURATION_INVALID"] = "DURATION_INVALID";
    ErrorCodeApi["EMPLOYER_NOT_FOUND"] = "EMPLOYER_NOT_FOUND";
    ErrorCodeApi["FREELANCER_NOT_FOUND"] = "FREELANCER_NOT_FOUND";
    ErrorCodeApi["HIREME_BID_AMOUNT_REQUIRED"] = "HIREME_BID_AMOUNT_REQUIRED";
    ErrorCodeApi["HIREME_FREELANCER_HAS_NO_JOBS"] = "HIREME_FREELANCER_HAS_NO_JOBS";
    ErrorCodeApi["HIREME_FREELANCER_IS_SELF"] = "HIREME_FREELANCER_IS_SELF";
    ErrorCodeApi["HIREME_INITIAL_BID_REQUIRED"] = "HIREME_INITIAL_BID_REQUIRED";
    ErrorCodeApi["HIREME_PROJECT_POST_LIMIT_REACHED"] = "HIREME_PROJECT_POST_LIMIT_REACHED";
    ErrorCodeApi["JOB_ID_INVALID"] = "JOB_ID_INVALID";
    ErrorCodeApi["PROJECT_DESCRIPTION_CONTAINS_CONTACT_DETAILS"] = "PROJECT_DESCRIPTION_CONTAINS_CONTACT_DETAILS";
    ErrorCodeApi["PROJECT_DESCRIPTION_INVALID"] = "PROJECT_DESCRIPTION_INVALID";
    ErrorCodeApi["PROJECT_DESCRIPTION_LENGTH_INVALID"] = "PROJECT_DESCRIPTION_LENGTH_INVALID";
    ErrorCodeApi["PROJECT_JOBS_REQUIRED"] = "PROJECT_JOBS_REQUIRED";
    ErrorCodeApi["PROJECT_PERIOD_INVALID"] = "PROJECT_PERIOD_INVALID";
    ErrorCodeApi["PROJECT_TITLE_CONTAINS_CONTACT_DETAILS"] = "PROJECT_TITLE_CONTAINS_CONTACT_DETAILS";
    ErrorCodeApi["PROJECT_TITLE_INVALID"] = "PROJECT_TITLE_INVALID";
    ErrorCodeApi["PROJECT_TITLE_NOT_UNIQUE"] = "PROJECT_TITLE_NOT_UNIQUE";
    ErrorCodeApi["PROJECT_TYPE_INVALID"] = "PROJECT_TYPE_INVALID";
    ErrorCodeApi["FREELANCER_RESTRICTED_FROM_BIDDING"] = "FREELANCER_RESTRICTED_FROM_BIDDING";
    ErrorCodeApi["LATITUDE_INVALID"] = "LATITUDE_INVALID";
    ErrorCodeApi["LONGITUDE_INVALID"] = "LONGITUDE_INVALID";
    ErrorCodeApi["HIREME_HOURLY_RATE_BELOW_MINIMUM"] = "HIREME_HOURLY_RATE_BELOW_MINIMUM";
    ErrorCodeApi["HIREME_EMPLOYER_RESTRICTED"] = "HIREME_EMPLOYER_RESTRICTED";
    ErrorCodeApi["BID_NOT_FOUND"] = "BID_NOT_FOUND";
    ErrorCodeApi["BID_NOT_UNDER_PROJECT"] = "BID_NOT_UNDER_PROJECT";
    ErrorCodeApi["PROJECT_PENDING_INVOICE"] = "PROJECT_PENDING_INVOICE";
    ErrorCodeApi["PROJECT_PENDING_MILESTONE"] = "PROJECT_PENDING_MILESTONE";
    ErrorCodeApi["PROJECT_PENDING_DISPUTE"] = "PROJECT_PENDING_DISPUTE";
    ErrorCodeApi["PROJECT_USER_NOT_OWNER"] = "PROJECT_USER_NOT_OWNER";
    ErrorCodeApi["PROJECT_JOB_ID_INVALID"] = "PROJECT_JOB_ID_INVALID";
    ErrorCodeApi["NDA_NOT_SIGNED"] = "NDA_NOT_SIGNED";
    ErrorCodeApi["PROJECT_DELETED"] = "PROJECT_DELETED";
    ErrorCodeApi["PROJECT_NOT_ACCEPTED"] = "PROJECT_NOT_ACCEPTED";
    ErrorCodeApi["PROJECT_INACCESSIBLE"] = "PROJECT_INACCESSIBLE";
    ErrorCodeApi["PROJECT_NOT_ACTIVE"] = "PROJECT_NOT_ACTIVE";
    ErrorCodeApi["PROJECT_REJECTED"] = "PROJECT_REJECTED";
    ErrorCodeApi["PROJECT_INVITATION_BIDDER_ALREADY_INVITED"] = "PROJECT_INVITATION_BIDDER_ALREADY_INVITED";
    ErrorCodeApi["PROJECT_INVITATION_LIMIT"] = "PROJECT_INVITATION_LIMIT";
    ErrorCodeApi["PROJECT_UNPAID"] = "PROJECT_UNPAID";
    ErrorCodeApi["PROJECT_NOT_LOCAL_JOBS"] = "PROJECT_NOT_LOCAL_JOBS";
    ErrorCodeApi["EQUIPMENT_NOT_FOUND"] = "EQUIPMENT_NOT_FOUND";
    ErrorCodeApi["DATE_INVALID"] = "DATE_INVALID";
    ErrorCodeApi["PROJECT_USER_RESTRICTED"] = "PROJECT_USER_RESTRICTED";
    ErrorCodeApi["PROJECT_INVITE_NOT_SENT_TO_FREELANCER"] = "PROJECT_INVITE_NOT_SENT_TO_FREELANCER";
    ErrorCodeApi["PROJECT_NOT_FOUND"] = "PROJECT_NOT_FOUND";
    ErrorCodeApi["PROJECT_END_BIDDING_FAILED"] = "PROJECT_END_BIDDING_FAILED";
    ErrorCodeApi["PROJECT_NOT_LOCATION_SHARING"] = "PROJECT_NOT_LOCATION_SHARING";
    ErrorCodeApi["PROJECT_INVALID_LOCATION_SHARING_STATUS"] = "PROJECT_INVALID_LOCATION_SHARING_STATUS";
    ErrorCodeApi["PROJECT_HAS_PENDING_AWARD"] = "PROJECT_HAS_PENDING_AWARD";
    ErrorCodeApi["PROJECT_HAS_PENDING_MILESTONE"] = "PROJECT_HAS_PENDING_MILESTONE";
    ErrorCodeApi["PROJECT_NOT_DELETABLE"] = "PROJECT_NOT_DELETABLE";
    ErrorCodeApi["PROJECT_BOOKMARK_LIMIT_REACHED"] = "PROJECT_BOOKMARK_LIMIT_REACHED";
    ErrorCodeApi["PROJECT_BUDGET_MIN_MAX_INVALID"] = "PROJECT_BUDGET_MIN_MAX_INVALID";
    ErrorCodeApi["PROJECT_BUDGET_VALUE_MISSING"] = "PROJECT_BUDGET_VALUE_MISSING";
    ErrorCodeApi["PROJECT_BUDGET_VALUE_TYPE_INVALID"] = "PROJECT_BUDGET_VALUE_TYPE_INVALID";
    ErrorCodeApi["PROJECT_SOURCE_NOT_FOUND"] = "PROJECT_SOURCE_NOT_FOUND";
    ErrorCodeApi["PROJECT_END_STATUS_INVALID"] = "PROJECT_END_STATUS_INVALID";
    ErrorCodeApi["AUTOBILLING_ALREADY_ENABLED"] = "AUTOBILLING_ALREADY_ENABLED";
    ErrorCodeApi["AUTOBILLING_ALREADY_DISABLED"] = "AUTOBILLING_ALREADY_DISABLED";
    ErrorCodeApi["MILESTONE_DISPUTE_PENDING"] = "MILESTONE_DISPUTE_PENDING";
    ErrorCodeApi["WEEKLY_LIMIT_LESS_THAN_CURRENT_TRACKED_HOURS"] = "WEEKLY_LIMIT_LESS_THAN_CURRENT_TRACKED_HOURS";
    ErrorCodeApi["INVOICE_PAYMENT_REQUIRED"] = "INVOICE_PAYMENT_REQUIRED";
    ErrorCodeApi["ENTRY_OWNER_ACCOUNT_CLOSED"] = "ENTRY_OWNER_ACCOUNT_CLOSED";
    ErrorCodeApi["PRIZE_AWARD_NOT_ALLOWED"] = "PRIZE_AWARD_NOT_ALLOWED";
    ErrorCodeApi["CONTEST_NOT_FOUND"] = "CONTEST_NOT_FOUND";
    ErrorCodeApi["ENTRY_NOT_FOUND"] = "ENTRY_NOT_FOUND";
    ErrorCodeApi["CONTEST_SKILL_REQUIRED"] = "CONTEST_SKILL_REQUIRED";
    ErrorCodeApi["CONTEST_EXCEEDS_MAX_SKILLS"] = "CONTEST_EXCEEDS_MAX_SKILLS";
    ErrorCodeApi["CONTEST_EXTENDED_UPGRADE_REQUIRED"] = "CONTEST_EXTENDED_UPGRADE_REQUIRED";
    ErrorCodeApi["CONTEST_ACCEPTED_FILE_FORMATS_REQUIRED"] = "CONTEST_ACCEPTED_FILE_FORMATS_REQUIRED";
    ErrorCodeApi["CONTEST_DELETED"] = "CONTEST_DELETED";
    ErrorCodeApi["CONTEST_MESSAGE_NOT_FOUND"] = "CONTEST_MESSAGE_NOT_FOUND";
    ErrorCodeApi["CONTEST_USER_RESTRICTED"] = "CONTEST_USER_RESTRICTED";
    ErrorCodeApi["CONTEST_USER_NOT_OWNER"] = "CONTEST_USER_NOT_OWNER";
    ErrorCodeApi["CONTEST_INVITATION_ALREADY_SENT"] = "CONTEST_INVITATION_ALREADY_SENT";
    ErrorCodeApi["CONTEST_INVITE_NOT_SENT_TO_FREELANCER"] = "CONTEST_INVITE_NOT_SENT_TO_FREELANCER";
    ErrorCodeApi["CONTEST_INVITATION_LIMIT"] = "CONTEST_INVITATION_LIMIT";
    ErrorCodeApi["ENTRY_HASHTAG_LIMIT_EXCEEDED"] = "ENTRY_HASHTAG_LIMIT_EXCEEDED";
    ErrorCodeApi["ENTRY_REPLACE_FILES_TOO_MANY"] = "ENTRY_REPLACE_FILES_TOO_MANY";
    ErrorCodeApi["ENTRY_REPLACE_FILES_NOT_UPLOADED"] = "ENTRY_REPLACE_FILES_NOT_UPLOADED";
    ErrorCodeApi["CONTEST_NOT_ACTIVE"] = "CONTEST_NOT_ACTIVE";
    ErrorCodeApi["CONTEST_CUSTOM_JUDGING_UPGRADE_REQUIRED"] = "CONTEST_CUSTOM_JUDGING_UPGRADE_REQUIRED";
    ErrorCodeApi["CONTEST_RUBRIC_ALREADY_CREATED"] = "CONTEST_RUBRIC_ALREADY_CREATED";
    ErrorCodeApi["CONTEST_RUBRIC_NOT_FOUND"] = "CONTEST_RUBRIC_NOT_FOUND";
    ErrorCodeApi["CONTEST_RUBRIC_SUBMISSION_NOT_FOUND"] = "CONTEST_RUBRIC_SUBMISSION_NOT_FOUND";
    ErrorCodeApi["ENTRY_INVALID_ACTION"] = "ENTRY_INVALID_ACTION";
    ErrorCodeApi["ENTRY_INVALID_SELL_PRICE_BELOW_MINIMUM"] = "ENTRY_INVALID_SELL_PRICE_BELOW_MINIMUM";
    ErrorCodeApi["ENTRY_INVALID_SELL_PRICE_ABOVE_MAXIMUM"] = "ENTRY_INVALID_SELL_PRICE_ABOVE_MAXIMUM";
    ErrorCodeApi["CONTEST_LOAD_FAILED"] = "CONTEST_LOAD_FAILED";
    ErrorCodeApi["CONTEST_HANDOVER_UNDER_DISPUTE"] = "CONTEST_HANDOVER_UNDER_DISPUTE";
    ErrorCodeApi["CONTEST_HANDOVER_CONFIRMED"] = "CONTEST_HANDOVER_CONFIRMED";
    ErrorCodeApi["CONTEST_HANDOVER_CONTRACT_NOT_SIGNED"] = "CONTEST_HANDOVER_CONTRACT_NOT_SIGNED";
    ErrorCodeApi["CONTEST_HANDOVER_NO_FILES_UPLOADED"] = "CONTEST_HANDOVER_NO_FILES_UPLOADED";
    ErrorCodeApi["CONTEST_HANDOVER_FILES_NOT_CONFIRMED"] = "CONTEST_HANDOVER_FILES_NOT_CONFIRMED";
    ErrorCodeApi["CONTEST_HANDOVER_RELEASE_PRIZE_FORBIDDEN"] = "CONTEST_HANDOVER_RELEASE_PRIZE_FORBIDDEN";
    ErrorCodeApi["CONTEST_ENTRY_INVALID_ID"] = "CONTEST_ENTRY_INVALID_ID";
    ErrorCodeApi["CONTEST_HANDOVER_ENTRY_NOT_WON"] = "CONTEST_HANDOVER_ENTRY_NOT_WON";
    ErrorCodeApi["CONTEST_HANDOVER_ACCESS_DENIED"] = "CONTEST_HANDOVER_ACCESS_DENIED";
    ErrorCodeApi["CONTEST_HANDOVER_FILE_NOT_OWNER"] = "CONTEST_HANDOVER_FILE_NOT_OWNER";
    ErrorCodeApi["OFFER_PRICE_CHANGED"] = "OFFER_PRICE_CHANGED";
    ErrorCodeApi["BID_DUPLICATE"] = "BID_DUPLICATE";
    ErrorCodeApi["BID_DESCRIPTION_CONTAINS_CONTACT_DETAILS"] = "BID_DESCRIPTION_CONTAINS_CONTACT_DETAILS";
    ErrorCodeApi["BID_AWARD_PENDING"] = "BID_AWARD_PENDING";
    ErrorCodeApi["BIDDER_NOT_INVITED"] = "BIDDER_NOT_INVITED";
    ErrorCodeApi["RESTRICTED_FROM_BIDDING_PREMIUM"] = "RESTRICTED_FROM_BIDDING_PREMIUM";
    ErrorCodeApi["BID_LIMIT_EXCEEDED"] = "BID_LIMIT_EXCEEDED";
    ErrorCodeApi["FREELANCER_COLLABORATOR_OF_PROJECT"] = "FREELANCER_COLLABORATOR_OF_PROJECT";
    ErrorCodeApi["FREELANCER_NOT_ENOUGH_REVIEWS"] = "FREELANCER_NOT_ENOUGH_REVIEWS";
    ErrorCodeApi["PROJECT_LANGUAGE_CRITERIA_NOT_MET"] = "PROJECT_LANGUAGE_CRITERIA_NOT_MET";
    ErrorCodeApi["BID_HIGHLIGHT_LIMIT_EXCEEDED"] = "BID_HIGHLIGHT_LIMIT_EXCEEDED";
    ErrorCodeApi["BID_FORM_INCOMPLETE"] = "BID_FORM_INCOMPLETE";
    ErrorCodeApi["BID_ALREADY_SEALED"] = "BID_ALREADY_SEALED";
    ErrorCodeApi["BID_NOT_AWARDED"] = "BID_NOT_AWARDED";
    ErrorCodeApi["BID_UNABLE_TO_REQUEST_LOCATION_SHARING"] = "BID_UNABLE_TO_REQUEST_LOCATION_SHARING";
    ErrorCodeApi["UNLISTED_PROJECT_BIDDER_NOT_INVITED"] = "UNLISTED_PROJECT_BIDDER_NOT_INVITED";
    ErrorCodeApi["UNLISTED_PROJECT_BIDDER_NOT_PREFERRED"] = "UNLISTED_PROJECT_BIDDER_NOT_PREFERRED";
    ErrorCodeApi["RESTRICTED_FROM_BIDDING_PREMIUM_VERIFIED"] = "RESTRICTED_FROM_BIDDING_PREMIUM_VERIFIED";
    ErrorCodeApi["BID_TOO_EARLY"] = "BID_TOO_EARLY";
    ErrorCodeApi["RESTRICTED_FROM_BIDDING_PREMIUM_VERIFIED_JOB"] = "RESTRICTED_FROM_BIDDING_PREMIUM_VERIFIED_JOB";
    ErrorCodeApi["BID_EDIT_REQUEST_DUPLICATE"] = "BID_EDIT_REQUEST_DUPLICATE";
    ErrorCodeApi["BID_EDIT_REQUEST_NOT_PENDING"] = "BID_EDIT_REQUEST_NOT_PENDING";
    ErrorCodeApi["BIDDER_HAS_PENDING_PROJECT_AWARD"] = "BIDDER_HAS_PENDING_PROJECT_AWARD";
    ErrorCodeApi["SKILLS_REQUIREMENT_NOT_MET"] = "SKILLS_REQUIREMENT_NOT_MET";
    ErrorCodeApi["BID_SELECTED_SELLER_NOT_FOUND"] = "BID_SELECTED_SELLER_NOT_FOUND";
    ErrorCodeApi["BIDDER_CUSTOM_FIELDS_NOT_MET"] = "BIDDER_CUSTOM_FIELDS_NOT_MET";
    ErrorCodeApi["CHARGE_PROJECT_FEE_INSUFFICIENT_FUND"] = "CHARGE_PROJECT_FEE_INSUFFICIENT_FUND";
    ErrorCodeApi["BIDDER_FROM_SANCTIONED_NATION"] = "BIDDER_FROM_SANCTIONED_NATION";
    ErrorCodeApi["SPONSORED_BID_EXISTS"] = "SPONSORED_BID_EXISTS";
    ErrorCodeApi["MILESTONE_RELEASED"] = "MILESTONE_RELEASED";
    ErrorCodeApi["MILESTONE_IS_AUTO_INVOICED"] = "MILESTONE_IS_AUTO_INVOICED";
    ErrorCodeApi["MILESTONE_REQUEST_DESCRIPTION_TOO_LONG"] = "MILESTONE_REQUEST_DESCRIPTION_TOO_LONG";
    ErrorCodeApi["MILESTONE_AMOUNT_INVALID"] = "MILESTONE_AMOUNT_INVALID";
    ErrorCodeApi["INITIAL_PAYMENT_CANNOT_BE_RELEASED"] = "INITIAL_PAYMENT_CANNOT_BE_RELEASED";
    ErrorCodeApi["INITIAL_PAYMENT_CANNOT_BE_CANCELLED"] = "INITIAL_PAYMENT_CANNOT_BE_CANCELLED";
    ErrorCodeApi["MILESTONE_DESCRIPTION_TOO_LONG"] = "MILESTONE_DESCRIPTION_TOO_LONG";
    ErrorCodeApi["MILESTONE_DESCRIPTION_EMPTY"] = "MILESTONE_DESCRIPTION_EMPTY";
    ErrorCodeApi["MILESTONE_REQUEST_DESCRIPTION_EMPTY"] = "MILESTONE_REQUEST_DESCRIPTION_EMPTY";
    ErrorCodeApi["FREELANCER_NEGATIVE_BALANCE"] = "FREELANCER_NEGATIVE_BALANCE";
    ErrorCodeApi["WEBHOOK_DUPLICATE"] = "WEBHOOK_DUPLICATE";
    ErrorCodeApi["IDENTITY_VERIFICATION_REQUIRED"] = "IDENTITY_VERIFICATION_REQUIRED";
    ErrorCodeApi["USER_ACCOUNT_LIMITED"] = "USER_ACCOUNT_LIMITED";
    ErrorCodeApi["USER_ACCOUNT_FULL_RESTRICTION"] = "USER_ACCOUNT_FULL_RESTRICTION";
    ErrorCodeApi["USER_ACCOUNT_ATO_SERR_REQUIREMENT_NOT_MET"] = "USER_ACCOUNT_ATO_SERR_REQUIREMENT_NOT_MET";
    ErrorCodeApi["EMAIL_ALREADY_SUBSCRIBED"] = "EMAIL_ALREADY_SUBSCRIBED";
    ErrorCodeApi["DISCOVER_COLLECTION_ITEM_DUPLICATE"] = "DISCOVER_COLLECTION_ITEM_DUPLICATE";
    ErrorCodeApi["DISCOVER_COLLECTION_NOT_FOUND"] = "DISCOVER_COLLECTION_NOT_FOUND";
    ErrorCodeApi["DISCOVER_COLLECTION_DUPLICATE"] = "DISCOVER_COLLECTION_DUPLICATE";
    ErrorCodeApi["DISCOVER_COLLECTION_USER_NOT_FOUND"] = "DISCOVER_COLLECTION_USER_NOT_FOUND";
    ErrorCodeApi["DISCOVER_COLLECTION_ITEM_NOT_FOUND"] = "DISCOVER_COLLECTION_ITEM_NOT_FOUND";
    ErrorCodeApi["DISCOVER_COLLECTION_TYPE_INVALID"] = "DISCOVER_COLLECTION_TYPE_INVALID";
    ErrorCodeApi["EMAIL_ALREADY_IN_USE"] = "EMAIL_ALREADY_IN_USE";
    ErrorCodeApi["USER_NOT_FOUND"] = "USER_NOT_FOUND";
    ErrorCodeApi["USERNAME_ALREADY_IN_USE"] = "USERNAME_ALREADY_IN_USE";
    ErrorCodeApi["EMAIL_BLOCKED"] = "EMAIL_BLOCKED";
    ErrorCodeApi["USERNAME_RESERVED"] = "USERNAME_RESERVED";
    ErrorCodeApi["EMAIL_INVALID"] = "EMAIL_INVALID";
    ErrorCodeApi["USERNAME_INVALID"] = "USERNAME_INVALID";
    ErrorCodeApi["PASSWORD_INVALID"] = "PASSWORD_INVALID";
    ErrorCodeApi["FACEBOOK_ACCOUNT_ALREADY_IN_USE"] = "FACEBOOK_ACCOUNT_ALREADY_IN_USE";
    ErrorCodeApi["USER_ALREADY_FACEBOOK_LINKED"] = "USER_ALREADY_FACEBOOK_LINKED";
    ErrorCodeApi["FACEBOOK_ACCOUNT_NOT_CONNECTED"] = "FACEBOOK_ACCOUNT_NOT_CONNECTED";
    ErrorCodeApi["FACEBOOK_UNLINK_ERROR"] = "FACEBOOK_UNLINK_ERROR";
    ErrorCodeApi["EMAIL_DOMAIN_SIGNUP_TOO_MANY_REQUEST"] = "EMAIL_DOMAIN_SIGNUP_TOO_MANY_REQUEST";
    ErrorCodeApi["ARROW_LOGIN_FLN_ACCOUNT_NOT_FOUND"] = "ARROW_LOGIN_FLN_ACCOUNT_NOT_FOUND";
    ErrorCodeApi["ARROW_SIGNUP_FLN_ACCOUNT_EXISTS"] = "ARROW_SIGNUP_FLN_ACCOUNT_EXISTS";
    ErrorCodeApi["ARROW_LOGIN_FLN_ACCOUNT_NOT_LINKED"] = "ARROW_LOGIN_FLN_ACCOUNT_NOT_LINKED";
    ErrorCodeApi["ARROW_ACCOUNT_LOCKED"] = "ARROW_ACCOUNT_LOCKED";
    ErrorCodeApi["ARROW_SERVICE_UNAVAILABLE"] = "ARROW_SERVICE_UNAVAILABLE";
    ErrorCodeApi["TIME_TRACKING_SESSION_NOT_FOUND"] = "TIME_TRACKING_SESSION_NOT_FOUND";
    ErrorCodeApi["TIME_TRACKING_SESSION_FINALISED"] = "TIME_TRACKING_SESSION_FINALISED";
    ErrorCodeApi["TIME_TRACKING_SESSION_DELETED"] = "TIME_TRACKING_SESSION_DELETED";
    ErrorCodeApi["TIME_TRACKING_STOPPED"] = "TIME_TRACKING_STOPPED";
    ErrorCodeApi["MANUAL_TIME_TRACKING_NOT_ALLOWED"] = "MANUAL_TIME_TRACKING_NOT_ALLOWED";
    ErrorCodeApi["TIME_TRACKING_CANNOT_EXCEED_WEEKLY_LIMIT"] = "TIME_TRACKING_CANNOT_EXCEED_WEEKLY_LIMIT";
    ErrorCodeApi["HOURLY_CONTRACT_NOT_FOUND"] = "HOURLY_CONTRACT_NOT_FOUND";
    ErrorCodeApi["TIME_TRACKING_OUTSIDE_BILLING_CYCLE"] = "TIME_TRACKING_OUTSIDE_BILLING_CYCLE";
    ErrorCodeApi["TIME_TRACKING_SESSION_ALREADY_STARTED"] = "TIME_TRACKING_SESSION_ALREADY_STARTED";
    ErrorCodeApi["TIME_TRACKING_SESSION_ALREADY_STOPPED"] = "TIME_TRACKING_SESSION_ALREADY_STOPPED";
    ErrorCodeApi["USER_ALREADY_REVIEWED"] = "USER_ALREADY_REVIEWED";
    ErrorCodeApi["REVIEW_PERIOD_EXPIRED"] = "REVIEW_PERIOD_EXPIRED";
    ErrorCodeApi["REVIEW_USER_NEGATIVE_BALANCE"] = "REVIEW_USER_NEGATIVE_BALANCE";
    ErrorCodeApi["AUTH_USER_MISSING"] = "AUTH_USER_MISSING";
    ErrorCodeApi["AUTH_ACCOUNT_SUSPENDED"] = "AUTH_ACCOUNT_SUSPENDED";
    ErrorCodeApi["AUTH_ACCOUNT_CLOSED"] = "AUTH_ACCOUNT_CLOSED";
    ErrorCodeApi["AUTH_CAPTCHA_REQUIRED"] = "AUTH_CAPTCHA_REQUIRED";
    ErrorCodeApi["AUTH_FACEBOOK_EMAIL_EXISTS"] = "AUTH_FACEBOOK_EMAIL_EXISTS";
    ErrorCodeApi["AUTH_FACEBOOK_EMAIL_MISMATCH"] = "AUTH_FACEBOOK_EMAIL_MISMATCH";
    ErrorCodeApi["AUTH_FACEBOOK_LINK_FAILED"] = "AUTH_FACEBOOK_LINK_FAILED";
    ErrorCodeApi["AUTH_FORCE_RESET_PASSWORD"] = "AUTH_FORCE_RESET_PASSWORD";
    ErrorCodeApi["AUTH_DEVICE_TOKEN_INVALID"] = "AUTH_DEVICE_TOKEN_INVALID";
    ErrorCodeApi["AUTH_PRELOGIN_TOKEN_INVALID"] = "AUTH_PRELOGIN_TOKEN_INVALID";
    ErrorCodeApi["AUTH_PRELOGIN_TOKEN_EXPIRED"] = "AUTH_PRELOGIN_TOKEN_EXPIRED";
    ErrorCodeApi["AUTH_TOTP_INVALID"] = "AUTH_TOTP_INVALID";
    ErrorCodeApi["AUTH_TOKEN_MISMATCH"] = "AUTH_TOKEN_MISMATCH";
    ErrorCodeApi["AUTH_2FA_BLOCKED"] = "AUTH_2FA_BLOCKED";
    ErrorCodeApi["SIGNUP_CAPTCHA_REQUIRED"] = "SIGNUP_CAPTCHA_REQUIRED";
    ErrorCodeApi["SIGNUP_CAPTCHA_INVALID"] = "SIGNUP_CAPTCHA_INVALID";
    ErrorCodeApi["FACEBOOK_EMAIL_NOT_FOUND"] = "FACEBOOK_EMAIL_NOT_FOUND";
    ErrorCodeApi["USERNAME_REQUIRED"] = "USERNAME_REQUIRED";
    ErrorCodeApi["PASSWORD_REQUIRED"] = "PASSWORD_REQUIRED";
    ErrorCodeApi["AUTH_OAUTH_FAILED"] = "AUTH_OAUTH_FAILED";
    ErrorCodeApi["AUTH_APPLE_TOKEN_INVALID"] = "AUTH_APPLE_TOKEN_INVALID";
    ErrorCodeApi["AUTH_APPLE_EMAIL_EXISTS"] = "AUTH_APPLE_EMAIL_EXISTS";
    ErrorCodeApi["AUTH_APPLE_EMAIL_MISMATCH"] = "AUTH_APPLE_EMAIL_MISMATCH";
    ErrorCodeApi["AUTH_APPLE_LINK_FAILED"] = "AUTH_APPLE_LINK_FAILED";
    ErrorCodeApi["PASSWORD_INCORRECT"] = "PASSWORD_INCORRECT";
    ErrorCodeApi["AUTH_OAUTH_LINK_CONFLICT"] = "AUTH_OAUTH_LINK_CONFLICT";
    ErrorCodeApi["AUTH_APPLE_EMAIL_IS_NULL"] = "AUTH_APPLE_EMAIL_IS_NULL";
    ErrorCodeApi["AUTH_GOOGLE_LINK_FAILED"] = "AUTH_GOOGLE_LINK_FAILED";
    ErrorCodeApi["USER_RECOMMEND_OVER_LIMIT"] = "USER_RECOMMEND_OVER_LIMIT";
    ErrorCodeApi["USER_RECOMMEND_ALREADY_RECOMMENDED"] = "USER_RECOMMEND_ALREADY_RECOMMENDED";
    ErrorCodeApi["USER_RECOMMEND_NO_SELF_RECOMMEND"] = "USER_RECOMMEND_NO_SELF_RECOMMEND";
    ErrorCodeApi["USER_FOLLOW_LIMIT_REACHED"] = "USER_FOLLOW_LIMIT_REACHED";
    ErrorCodeApi["USER_FOLLOW_NO_SELF_FOLLOW"] = "USER_FOLLOW_NO_SELF_FOLLOW";
    ErrorCodeApi["USER_FOLLOW_USER_DOES_NOT_ALLOW_FOLLOWING"] = "USER_FOLLOW_USER_DOES_NOT_ALLOW_FOLLOWING";
    ErrorCodeApi["USER_FOLLOW_ALREADY_FOLLOWING"] = "USER_FOLLOW_ALREADY_FOLLOWING";
    ErrorCodeApi["MILESTONE_INVOICE_AMOUNT_MISMATCH"] = "MILESTONE_INVOICE_AMOUNT_MISMATCH";
    ErrorCodeApi["INVALID_INVOICE_FOR_PROJECT"] = "INVALID_INVOICE_FOR_PROJECT";
    ErrorCodeApi["INVOICE_NOT_UNPAID"] = "INVOICE_NOT_UNPAID";
    ErrorCodeApi["INVOICE_HAS_LINKED_MILESTONE"] = "INVOICE_HAS_LINKED_MILESTONE";
    ErrorCodeApi["INVOICE_NOT_FOUND"] = "INVOICE_NOT_FOUND";
    ErrorCodeApi["APPLICATION_NAME_NOT_UNIQUE"] = "APPLICATION_NAME_NOT_UNIQUE";
    ErrorCodeApi["GROUP_NOT_FOUND"] = "GROUP_NOT_FOUND";
    ErrorCodeApi["SEO_URL_EXISTS"] = "SEO_URL_EXISTS";
    ErrorCodeApi["SEO_URL_INVALID"] = "SEO_URL_INVALID";
    ErrorCodeApi["GROUP_MEMBER_NOT_FOUND"] = "GROUP_MEMBER_NOT_FOUND";
    ErrorCodeApi["GROUP_MEMBER_ALREADY_EXISTS"] = "GROUP_MEMBER_ALREADY_EXISTS";
    ErrorCodeApi["GROUP_MEMBER_ALREADY_REMOVED"] = "GROUP_MEMBER_ALREADY_REMOVED";
    ErrorCodeApi["GROUP_MEMBER_UPDATE_EMPTY_REQUEST"] = "GROUP_MEMBER_UPDATE_EMPTY_REQUEST";
    ErrorCodeApi["FEED_POST_CONTENT_TOO_LONG"] = "FEED_POST_CONTENT_TOO_LONG";
    ErrorCodeApi["FEED_META_NOT_FOUND"] = "FEED_META_NOT_FOUND";
    ErrorCodeApi["FEED_POST_ATTACHMENTS_TOO_MANY"] = "FEED_POST_ATTACHMENTS_TOO_MANY";
    ErrorCodeApi["FEED_ITEM_NOT_FOUND"] = "FEED_ITEM_NOT_FOUND";
    ErrorCodeApi["FEED_POST_CONTEXT_REQUIRED"] = "FEED_POST_CONTEXT_REQUIRED";
    ErrorCodeApi["FEED_POST_CONTENT_REQUIRED"] = "FEED_POST_CONTENT_REQUIRED";
    ErrorCodeApi["FEED_CONTEXT_REQUIRED"] = "FEED_CONTEXT_REQUIRED";
    ErrorCodeApi["FEED_META_ACTION_REQUIRED"] = "FEED_META_ACTION_REQUIRED";
    ErrorCodeApi["FEED_META_ACTION_INVALID"] = "FEED_META_ACTION_INVALID";
    ErrorCodeApi["FEED_META_CONTEXT_INVALID"] = "FEED_META_CONTEXT_INVALID";
    ErrorCodeApi["FEED_META_FILTER_REQUIRED"] = "FEED_META_FILTER_REQUIRED";
    ErrorCodeApi["FEED_ITEMS_ORDERING_INVALID"] = "FEED_ITEMS_ORDERING_INVALID";
    ErrorCodeApi["FEED_META_CONTEXT_TYPE_INVALID"] = "FEED_META_CONTEXT_TYPE_INVALID";
    ErrorCodeApi["ATTACHMENT_FILE_REQUIRED"] = "ATTACHMENT_FILE_REQUIRED";
    ErrorCodeApi["ATTACHMENT_FILE_TOO_LARGE"] = "ATTACHMENT_FILE_TOO_LARGE";
    ErrorCodeApi["ATTACHMENT_FILE_METADATA_REQUIRED"] = "ATTACHMENT_FILE_METADATA_REQUIRED";
    ErrorCodeApi["ATTACHMENT_FILE_ID_REQUIRED"] = "ATTACHMENT_FILE_ID_REQUIRED";
    ErrorCodeApi["ATTACHMENT_FILE_FILENAME_INVALID"] = "ATTACHMENT_FILE_FILENAME_INVALID";
    ErrorCodeApi["ATTACHMENT_FILE_FILENAME_TOO_LONG"] = "ATTACHMENT_FILE_FILENAME_TOO_LONG";
    ErrorCodeApi["ATTACHMENT_FILE_UUID_DUPLICATE"] = "ATTACHMENT_FILE_UUID_DUPLICATE";
    ErrorCodeApi["ATTACHMENT_FILE_NOT_FOUND"] = "ATTACHMENT_FILE_NOT_FOUND";
    ErrorCodeApi["ATTACHMENT_FILE_UNSUPPORTED_MIME_TYPE"] = "ATTACHMENT_FILE_UNSUPPORTED_MIME_TYPE";
    ErrorCodeApi["TEXT_ENTITY_BAD_OFFSET"] = "TEXT_ENTITY_BAD_OFFSET";
    ErrorCodeApi["TEXT_ENTITY_BAD_LENGTH"] = "TEXT_ENTITY_BAD_LENGTH";
    ErrorCodeApi["TEXT_ENTITY_TOO_MANY"] = "TEXT_ENTITY_TOO_MANY";
    ErrorCodeApi["TEXT_ENTITY_VALIDATION"] = "TEXT_ENTITY_VALIDATION";
    ErrorCodeApi["PAYMENT_ACCOUNT_INFO_INVALID"] = "PAYMENT_ACCOUNT_INFO_INVALID";
    ErrorCodeApi["PAYMENT_ACCOUNT_ID_INVALID"] = "PAYMENT_ACCOUNT_ID_INVALID";
    ErrorCodeApi["PAYMENT_CARD_EXPIRY_INVALID"] = "PAYMENT_CARD_EXPIRY_INVALID";
    ErrorCodeApi["PAYMENT_CARD_CVC_DECLINED"] = "PAYMENT_CARD_CVC_DECLINED";
    ErrorCodeApi["PAYMENT_ACCOUNT_PIN_ERROR"] = "PAYMENT_ACCOUNT_PIN_ERROR";
    ErrorCodeApi["PAYMENT_ACCOUNT_SCA_FAILED"] = "PAYMENT_ACCOUNT_SCA_FAILED";
    ErrorCodeApi["PAYMENT_AMOUNT_RESTRICTED"] = "PAYMENT_AMOUNT_RESTRICTED";
    ErrorCodeApi["PAYMENT_AGREEMENT_CANCELED"] = "PAYMENT_AGREEMENT_CANCELED";
    ErrorCodeApi["PAYMENT_ACCOUNT_RESTRICTED"] = "PAYMENT_ACCOUNT_RESTRICTED";
    ErrorCodeApi["PAYMENT_TRANSACTION_DECLINED"] = "PAYMENT_TRANSACTION_DECLINED";
    ErrorCodeApi["PAYMENT_GATEWAY_UNAVAILABLE"] = "PAYMENT_GATEWAY_UNAVAILABLE";
    ErrorCodeApi["PAYMENT_GATEWAY_ERROR"] = "PAYMENT_GATEWAY_ERROR";
    ErrorCodeApi["PAYMENT_AGREEMENT_NOT_SUPPORTED"] = "PAYMENT_AGREEMENT_NOT_SUPPORTED";
    ErrorCodeApi["PAYMENT_TEAM_BILLING_SPEND_LIMIT_REACHED"] = "PAYMENT_TEAM_BILLING_SPEND_LIMIT_REACHED";
    ErrorCodeApi["PAYMENT_AGREEMENT_ID_NOT_FOUND"] = "PAYMENT_AGREEMENT_ID_NOT_FOUND";
    ErrorCodeApi["PAYMENT_AGREEMENT_ID_NOT_CANCELLABLE"] = "PAYMENT_AGREEMENT_ID_NOT_CANCELLABLE";
    ErrorCodeApi["PAYMENT_AGREEMENT_REQUIRED_FOR_ACTIVE_SUBSCRIPTION"] = "PAYMENT_AGREEMENT_REQUIRED_FOR_ACTIVE_SUBSCRIPTION";
    ErrorCodeApi["PAYMENT_AGREEMENT_REQUIRED_FOR_ACTIVE_HOURLY_CONTRACT"] = "PAYMENT_AGREEMENT_REQUIRED_FOR_ACTIVE_HOURLY_CONTRACT";
    ErrorCodeApi["PAYMENT_AGREEMENT_REQUIRED_FOR_FAILED_INVOICE"] = "PAYMENT_AGREEMENT_REQUIRED_FOR_FAILED_INVOICE";
    ErrorCodeApi["PAYMENT_BIN_COUNTRY_BLOCKED"] = "PAYMENT_BIN_COUNTRY_BLOCKED";
    ErrorCodeApi["PAYMENT_CART_ALREADY_HAS_APPROVAL_REQUEST"] = "PAYMENT_CART_ALREADY_HAS_APPROVAL_REQUEST";
    ErrorCodeApi["PAYMENT_CART_APPROVAL_DOES_NOT_EXIST"] = "PAYMENT_CART_APPROVAL_DOES_NOT_EXIST";
    ErrorCodeApi["PAYMENT_TEAM_BILLING_CART_APPROVAL_REQUIRED"] = "PAYMENT_TEAM_BILLING_CART_APPROVAL_REQUIRED";
    ErrorCodeApi["PAYMENT_BIN_MISSING"] = "PAYMENT_BIN_MISSING";
    ErrorCodeApi["PAYMENT_BIN_BLOCKED"] = "PAYMENT_BIN_BLOCKED";
    ErrorCodeApi["CANNOT_SHARE_PROJECT_TO_BIDDER"] = "CANNOT_SHARE_PROJECT_TO_BIDDER";
    ErrorCodeApi["CANNOT_SHARE_PROJECT_WRONG_ENTERPRISE"] = "CANNOT_SHARE_PROJECT_WRONG_ENTERPRISE";
    ErrorCodeApi["CANNOT_SHARE_PROJECT_TO_COLLABORATOR"] = "CANNOT_SHARE_PROJECT_TO_COLLABORATOR";
    ErrorCodeApi["CANNOT_SHARE_PROJECT_TO_OWNER"] = "CANNOT_SHARE_PROJECT_TO_OWNER";
    ErrorCodeApi["SHARE_PROJECT_LIMIT_REACHED"] = "SHARE_PROJECT_LIMIT_REACHED";
    ErrorCodeApi["SHARE_PROJECT_DAILY_LIMIT_REACHED"] = "SHARE_PROJECT_DAILY_LIMIT_REACHED";
    ErrorCodeApi["SHARE_PROJECT_CLOSED_PROJECT"] = "SHARE_PROJECT_CLOSED_PROJECT";
    ErrorCodeApi["NPS_COMMENT_TOO_LONG"] = "NPS_COMMENT_TOO_LONG";
    ErrorCodeApi["NPS_SOURCE_TYPE_INVALID"] = "NPS_SOURCE_TYPE_INVALID";
    ErrorCodeApi["NPS_TYPE_INVALID"] = "NPS_TYPE_INVALID";
    ErrorCodeApi["METADATA_FIELD_NOT_FOUND"] = "METADATA_FIELD_NOT_FOUND";
    ErrorCodeApi["METADATA_FIELD_DISABLED"] = "METADATA_FIELD_DISABLED";
    ErrorCodeApi["METADATA_FIELD_VALUE_INVALID"] = "METADATA_FIELD_VALUE_INVALID";
    ErrorCodeApi["METADATA_FIELD_TYPE_INVALID"] = "METADATA_FIELD_TYPE_INVALID";
    ErrorCodeApi["METADATA_FIELD_VALUE_OBJECT_INVALID"] = "METADATA_FIELD_VALUE_OBJECT_INVALID";
    ErrorCodeApi["POST_NOT_FOUND"] = "POST_NOT_FOUND";
    ErrorCodeApi["POST_CONTENT_REQUIRED"] = "POST_CONTENT_REQUIRED";
    ErrorCodeApi["POST_COMMENT_FEED_NOT_MODIFIABLE"] = "POST_COMMENT_FEED_NOT_MODIFIABLE";
    ErrorCodeApi["CUSTOM_FIELD_VALIDATION_COLLECTION_TYPE_INVALID"] = "CUSTOM_FIELD_VALIDATION_COLLECTION_TYPE_INVALID";
    ErrorCodeApi["CUSTOM_FIELD_VALIDATION_VALIDATION_TYPE_INVALID"] = "CUSTOM_FIELD_VALIDATION_VALIDATION_TYPE_INVALID";
    ErrorCodeApi["NOTIFICATION_PREFERENCE_TYPE_INVALID"] = "NOTIFICATION_PREFERENCE_TYPE_INVALID";
    ErrorCodeApi["REPUTATION_DECAY_FACTORS_NOT_FOUND"] = "REPUTATION_DECAY_FACTORS_NOT_FOUND";
    ErrorCodeApi["EMAIL_CHANGE_REQUEST_SAME_ADDRESS"] = "EMAIL_CHANGE_REQUEST_SAME_ADDRESS";
    ErrorCodeApi["EMAIL_CHANGE_REQUEST_DUPLICATE"] = "EMAIL_CHANGE_REQUEST_DUPLICATE";
    ErrorCodeApi["EMAIL_CHANGE_REQUEST_NOT_FOUND"] = "EMAIL_CHANGE_REQUEST_NOT_FOUND";
    ErrorCodeApi["EMAIL_CHANGE_REQUEST_NOT_ALLOWED"] = "EMAIL_CHANGE_REQUEST_NOT_ALLOWED";
    ErrorCodeApi["ACCOUNT_REACTIVATION_ONGOING_DELETION"] = "ACCOUNT_REACTIVATION_ONGOING_DELETION";
    ErrorCodeApi["ACCOUNT_REACTIVATION_NOT_CLOSED_BY_USER"] = "ACCOUNT_REACTIVATION_NOT_CLOSED_BY_USER";
    ErrorCodeApi["ACCOUNT_REACTIVATION_ALREADY_ACTIVE"] = "ACCOUNT_REACTIVATION_ALREADY_ACTIVE";
    ErrorCodeApi["ACCOUNT_REACTIVATION_INVALID_TOKEN"] = "ACCOUNT_REACTIVATION_INVALID_TOKEN";
    ErrorCodeApi["SUPPORT_TICKET_NOT_FOUND"] = "SUPPORT_TICKET_NOT_FOUND";
    ErrorCodeApi["MEMBERSHIP_TRIAL_INELIGIBLE"] = "MEMBERSHIP_TRIAL_INELIGIBLE";
    ErrorCodeApi["MEMBERSHIP_SUBSCRIPTION_PAYMENT_FAILURE"] = "MEMBERSHIP_SUBSCRIPTION_PAYMENT_FAILURE";
    ErrorCodeApi["MEMBERSHIP_PACKAGE_DISABLED"] = "MEMBERSHIP_PACKAGE_DISABLED";
    ErrorCodeApi["MEMBERSHIP_PRICE_DISABLED"] = "MEMBERSHIP_PRICE_DISABLED";
    ErrorCodeApi["MEMBERSHIP_TRIAL_NOT_FOUND"] = "MEMBERSHIP_TRIAL_NOT_FOUND";
    ErrorCodeApi["MEMBERSHIP_PRICE_NOT_FOUND"] = "MEMBERSHIP_PRICE_NOT_FOUND";
    ErrorCodeApi["MEMBERSHIP_PACKAGE_NOT_FOUND"] = "MEMBERSHIP_PACKAGE_NOT_FOUND";
    ErrorCodeApi["MEMBERSHIP_SUBSCRIPTION_NOT_FOUND"] = "MEMBERSHIP_SUBSCRIPTION_NOT_FOUND";
    ErrorCodeApi["MEMBERSHIP_PACKAGE_DURATION_INVALID"] = "MEMBERSHIP_PACKAGE_DURATION_INVALID";
    ErrorCodeApi["MEMBERSHIP_SUBSCRIPTION_QUANTITY_INVALID"] = "MEMBERSHIP_SUBSCRIPTION_QUANTITY_INVALID";
    ErrorCodeApi["MEMBERSHIP_MAIL_EXCEPTION"] = "MEMBERSHIP_MAIL_EXCEPTION";
    ErrorCodeApi["MEMBERSHIP_RENEW_PERIOD_EXPIRED"] = "MEMBERSHIP_RENEW_PERIOD_EXPIRED";
    ErrorCodeApi["MEMBERSHIP_COUPON_REUSE"] = "MEMBERSHIP_COUPON_REUSE";
    ErrorCodeApi["MEMBERSHIP_COUPON_UNAVAILABLE"] = "MEMBERSHIP_COUPON_UNAVAILABLE";
    ErrorCodeApi["MEMBERSHIP_REQUEST_ALREADY_PROCESSED"] = "MEMBERSHIP_REQUEST_ALREADY_PROCESSED";
    ErrorCodeApi["MEMBERSHIP_PERIOD_NOT_FOUND"] = "MEMBERSHIP_PERIOD_NOT_FOUND";
    ErrorCodeApi["MEMBERSHIP_RENEWAL_ALREADY_ACTIVE"] = "MEMBERSHIP_RENEWAL_ALREADY_ACTIVE";
    ErrorCodeApi["MEMBERSHIP_RENEWAL_NOT_FOUND"] = "MEMBERSHIP_RENEWAL_NOT_FOUND";
    ErrorCodeApi["MEMBERSHIP_RENEWAL_ALREADY_INACTIVE"] = "MEMBERSHIP_RENEWAL_ALREADY_INACTIVE";
    ErrorCodeApi["USER_ACCOUNT_CLOSURE_RESTRICTED"] = "USER_ACCOUNT_CLOSURE_RESTRICTED";
    ErrorCodeApi["USER_ACCOUNT_CLOSURE_NOT_ALLOWED"] = "USER_ACCOUNT_CLOSURE_NOT_ALLOWED";
    ErrorCodeApi["PHONE_CANNOT_USE_NUMBER"] = "PHONE_CANNOT_USE_NUMBER";
    ErrorCodeApi["PHONE_COMPLETE_ID_VERIFICATION_REQUIRED"] = "PHONE_COMPLETE_ID_VERIFICATION_REQUIRED";
    ErrorCodeApi["PHONE_INVALID_NUMBER"] = "PHONE_INVALID_NUMBER";
    ErrorCodeApi["PHONE_INVALID_VERIFICATION"] = "PHONE_INVALID_VERIFICATION";
    ErrorCodeApi["PHONE_INVALID_VERIFICATION_CODE"] = "PHONE_INVALID_VERIFICATION_CODE";
    ErrorCodeApi["PHONE_NUMBER_ALREADY_USED"] = "PHONE_NUMBER_ALREADY_USED";
    ErrorCodeApi["PHONE_NUMBER_MISMATCH"] = "PHONE_NUMBER_MISMATCH";
    ErrorCodeApi["PHONE_MAXIMUM_NUMBER_OF_ATTEMPTS_REACHED"] = "PHONE_MAXIMUM_NUMBER_OF_ATTEMPTS_REACHED";
    ErrorCodeApi["PHONE_SAME_NUMBER"] = "PHONE_SAME_NUMBER";
    ErrorCodeApi["PHONE_NOT_FOUND"] = "PHONE_NOT_FOUND";
    ErrorCodeApi["USER_HAS_ALREADY_REACTED"] = "USER_HAS_ALREADY_REACTED";
    ErrorCodeApi["USER_HAS_NOT_REACTED"] = "USER_HAS_NOT_REACTED";
    ErrorCodeApi["QUOTATION_CURRENCY_NOT_FOUND"] = "QUOTATION_CURRENCY_NOT_FOUND";
    ErrorCodeApi["QUOTATION_PROJECT_INACTIVE"] = "QUOTATION_PROJECT_INACTIVE";
    ErrorCodeApi["QUOTATION_PROJECT_NOT_FOUND"] = "QUOTATION_PROJECT_NOT_FOUND";
    ErrorCodeApi["QUOTATION_BID_RETRACTED"] = "QUOTATION_BID_RETRACTED";
    ErrorCodeApi["QUOTATION_NOT_FOUND"] = "QUOTATION_NOT_FOUND";
    ErrorCodeApi["QUOTATION_NOT_DRAFT"] = "QUOTATION_NOT_DRAFT";
    ErrorCodeApi["QUOTATION_ITEM_ALREADY_DELETED"] = "QUOTATION_ITEM_ALREADY_DELETED";
    ErrorCodeApi["QUOTATION_WRONG_DRAFT_VERSION"] = "QUOTATION_WRONG_DRAFT_VERSION";
    ErrorCodeApi["QUOTATION_ITEM_IDS_INCONSISTENT"] = "QUOTATION_ITEM_IDS_INCONSISTENT";
    ErrorCodeApi["QUOTATION_ITEM_CLOSED"] = "QUOTATION_ITEM_CLOSED";
    ErrorCodeApi["QUOTATION_ITEM_MUTABLE"] = "QUOTATION_ITEM_MUTABLE";
    ErrorCodeApi["QUOTATION_UPDATE_ACCEPTING_AND_REJECTING"] = "QUOTATION_UPDATE_ACCEPTING_AND_REJECTING";
    ErrorCodeApi["QUOTATION_IS_INVALID"] = "QUOTATION_IS_INVALID";
    ErrorCodeApi["QUOTATION_VERSION_IS_INVALID"] = "QUOTATION_VERSION_IS_INVALID";
    ErrorCodeApi["QUOTATION_VERSION_INCONSISTENT"] = "QUOTATION_VERSION_INCONSISTENT";
    ErrorCodeApi["QUOTATION_ID_CONFLICT"] = "QUOTATION_ID_CONFLICT";
    ErrorCodeApi["QUOTATION_DRAFT_EXISTS"] = "QUOTATION_DRAFT_EXISTS";
    ErrorCodeApi["QUOTATION_BID_NOT_FOUND"] = "QUOTATION_BID_NOT_FOUND";
    ErrorCodeApi["QUOTATION_FUND_INSUFFICIENT"] = "QUOTATION_FUND_INSUFFICIENT";
    ErrorCodeApi["QUOTATION_ITEM_AMOUNT_TOO_LOW"] = "QUOTATION_ITEM_AMOUNT_TOO_LOW";
    ErrorCodeApi["QUOTATION_NOT_APPROVED"] = "QUOTATION_NOT_APPROVED";
    ErrorCodeApi["QUOTATION_INCORRECT_CONTEXT"] = "QUOTATION_INCORRECT_CONTEXT";
    ErrorCodeApi["QUOTATION_UPFRONT_FUNDING_AMOUNT_TOO_HIGH"] = "QUOTATION_UPFRONT_FUNDING_AMOUNT_TOO_HIGH";
    ErrorCodeApi["QUOTATION_THREAD_NOT_FOUND"] = "QUOTATION_THREAD_NOT_FOUND";
    ErrorCodeApi["QUOTATION_THREAD_TYPE_INVALID"] = "QUOTATION_THREAD_TYPE_INVALID";
    ErrorCodeApi["QUOTATION_THREAD_CONTEXT_NOT_ASSIGNABLE"] = "QUOTATION_THREAD_CONTEXT_NOT_ASSIGNABLE";
    ErrorCodeApi["QUOTATION_THREAD_NOT_EDITABLE"] = "QUOTATION_THREAD_NOT_EDITABLE";
    ErrorCodeApi["QUOTATION_CONTEXT_TYPE_INVALID"] = "QUOTATION_CONTEXT_TYPE_INVALID";
    ErrorCodeApi["QUOTATION_EXPIRED"] = "QUOTATION_EXPIRED";
    ErrorCodeApi["QUOTATION_REJECTED"] = "QUOTATION_REJECTED";
    ErrorCodeApi["QUOTATION_CANCELLED"] = "QUOTATION_CANCELLED";
    ErrorCodeApi["HIREME_QUOTATION_INVALID"] = "HIREME_QUOTATION_INVALID";
    ErrorCodeApi["QUOTATION_APPROVED"] = "QUOTATION_APPROVED";
    ErrorCodeApi["QUOTATION_AMOUNT_BELOW_MINIMUM_BUDGET"] = "QUOTATION_AMOUNT_BELOW_MINIMUM_BUDGET";
    ErrorCodeApi["QUOTATION_LIMIT_REACHED"] = "QUOTATION_LIMIT_REACHED";
    ErrorCodeApi["QUOTATION_EXPIRY_DATE_CANNOT_BE_IN_PAST"] = "QUOTATION_EXPIRY_DATE_CANNOT_BE_IN_PAST";
    ErrorCodeApi["PROJECT_QUOTATION_LIMIT_REACHED"] = "PROJECT_QUOTATION_LIMIT_REACHED";
    ErrorCodeApi["QUOTATION_CONTEXT_NOT_ASSIGNABLE"] = "QUOTATION_CONTEXT_NOT_ASSIGNABLE";
    ErrorCodeApi["QUOTATION_DURATION_NOT_ASSIGNABLE"] = "QUOTATION_DURATION_NOT_ASSIGNABLE";
    ErrorCodeApi["QUOTATION_INVALID_STATUS"] = "QUOTATION_INVALID_STATUS";
    ErrorCodeApi["QUOTATION_PARENT_TEMPLATE_NOT_FOUND"] = "QUOTATION_PARENT_TEMPLATE_NOT_FOUND";
    ErrorCodeApi["CHILD_QUOTATION_MORE_THAN_ONE_PENDING"] = "CHILD_QUOTATION_MORE_THAN_ONE_PENDING";
    ErrorCodeApi["QUOTATION_MISUSING_HELPER_FUNCTIONS"] = "QUOTATION_MISUSING_HELPER_FUNCTIONS";
    ErrorCodeApi["QUOTATION_LOGO_NOT_FOUND"] = "QUOTATION_LOGO_NOT_FOUND";
    ErrorCodeApi["QUOTATION_LOGO_CANNOT_BE_UPDATED"] = "QUOTATION_LOGO_CANNOT_BE_UPDATED";
    ErrorCodeApi["QUOTATION_LOGO_CREATOR_MISMATCH"] = "QUOTATION_LOGO_CREATOR_MISMATCH";
    ErrorCodeApi["QUOTATION_ONLY_ONE_HOURLY_ITEM_ALLOWED"] = "QUOTATION_ONLY_ONE_HOURLY_ITEM_ALLOWED";
    ErrorCodeApi["QUOTATION_ITEM_NOT_FOUND"] = "QUOTATION_ITEM_NOT_FOUND";
    ErrorCodeApi["QUOTATION_ITEM_INVALID_BILLING_FREQUENCY"] = "QUOTATION_ITEM_INVALID_BILLING_FREQUENCY";
    ErrorCodeApi["PROJECT_TITLE_EDIT_REQUEST_DUPLICATE"] = "PROJECT_TITLE_EDIT_REQUEST_DUPLICATE";
    ErrorCodeApi["PROJECT_TITLE_EDIT_REQUEST_NOT_PENDING"] = "PROJECT_TITLE_EDIT_REQUEST_NOT_PENDING";
    ErrorCodeApi["SEARCH_SAVED_FILTERS_DUPLICATE"] = "SEARCH_SAVED_FILTERS_DUPLICATE";
    ErrorCodeApi["SEARCH_SAVED_FILTERS_LIMIT_REACHED"] = "SEARCH_SAVED_FILTERS_LIMIT_REACHED";
    ErrorCodeApi["SEARCH_SAVED_FILTERS_NOT_FOUND"] = "SEARCH_SAVED_FILTERS_NOT_FOUND";
    ErrorCodeApi["CONTRACT_NOT_FOUND"] = "CONTRACT_NOT_FOUND";
    ErrorCodeApi["CONTRACT_ALREADY_SIGNED"] = "CONTRACT_ALREADY_SIGNED";
    ErrorCodeApi["CONTRACT_VERIFICATION_FAILED"] = "CONTRACT_VERIFICATION_FAILED";
    ErrorCodeApi["CONTRACT_CONTEXT_NOT_FOUND"] = "CONTRACT_CONTEXT_NOT_FOUND";
    ErrorCodeApi["CONTRACT_INVALID_DOWNLOAD"] = "CONTRACT_INVALID_DOWNLOAD";
    ErrorCodeApi["CONTRACT_TEMPLATE_NOT_FOUND"] = "CONTRACT_TEMPLATE_NOT_FOUND";
    ErrorCodeApi["CONTRACT_SIGNEE_ROLE_NOT_FOUND"] = "CONTRACT_SIGNEE_ROLE_NOT_FOUND";
    ErrorCodeApi["POOL_NOT_FOUND"] = "POOL_NOT_FOUND";
    ErrorCodeApi["ENTERPRISE_LOGO_FILE_NOT_FOUND"] = "ENTERPRISE_LOGO_FILE_NOT_FOUND";
    ErrorCodeApi["ENTERPRISE_AVATAR_FILE_NOT_FOUND"] = "ENTERPRISE_AVATAR_FILE_NOT_FOUND";
    ErrorCodeApi["PROJECT_QUESTION_NOT_FOUND"] = "PROJECT_QUESTION_NOT_FOUND";
    ErrorCodeApi["AGENT_INVALID_STATE"] = "AGENT_INVALID_STATE";
    ErrorCodeApi["AGENT_NOT_FOUND"] = "AGENT_NOT_FOUND";
    ErrorCodeApi["AGENT_SESSION_INVALID_STATE"] = "AGENT_SESSION_INVALID_STATE";
    ErrorCodeApi["AGENT_SESSION_NOT_FOUND"] = "AGENT_SESSION_NOT_FOUND";
    ErrorCodeApi["SESSION_SOURCE_INVALID"] = "SESSION_SOURCE_INVALID";
    ErrorCodeApi["SUPPORT_TYPE_MISMATCH"] = "SUPPORT_TYPE_MISMATCH";
    ErrorCodeApi["SUPPORT_TYPE_NOT_FOUND"] = "SUPPORT_TYPE_NOT_FOUND";
    ErrorCodeApi["AGENT_OWNER_INVALID"] = "AGENT_OWNER_INVALID";
    ErrorCodeApi["SUPPORT_RESOLVE_REASON_EXISTS"] = "SUPPORT_RESOLVE_REASON_EXISTS";
    ErrorCodeApi["SUPPORT_TAG_EXISTS"] = "SUPPORT_TAG_EXISTS";
    ErrorCodeApi["SUPPORT_SESSION_THREAD_NOT_FOUND"] = "SUPPORT_SESSION_THREAD_NOT_FOUND";
    ErrorCodeApi["SERVICE_OFFERING_NOT_FOUND"] = "SERVICE_OFFERING_NOT_FOUND";
    ErrorCodeApi["SERVICE_OFFERING_IS_INVALID"] = "SERVICE_OFFERING_IS_INVALID";
    ErrorCodeApi["SERVICE_OFFERING_ATTACHMENT_NOT_FOUND"] = "SERVICE_OFFERING_ATTACHMENT_NOT_FOUND";
    ErrorCodeApi["INVALID_SERVICE_OFFERING_JOB_ID"] = "INVALID_SERVICE_OFFERING_JOB_ID";
    ErrorCodeApi["SERVICE_OFFERING_IS_NOT_ACTIVE"] = "SERVICE_OFFERING_IS_NOT_ACTIVE";
    ErrorCodeApi["MULTIPLE_CREATOR_IDS_WITH_INVALID_STATUS"] = "MULTIPLE_CREATOR_IDS_WITH_INVALID_STATUS";
    ErrorCodeApi["USER_LOGO_NOT_FOUND"] = "USER_LOGO_NOT_FOUND";
    ErrorCodeApi["INVITATION_TOKEN_INVALID"] = "INVITATION_TOKEN_INVALID";
    ErrorCodeApi["INVITATION_INVALID"] = "INVITATION_INVALID";
    ErrorCodeApi["INVITATION_LINK_CLOSED"] = "INVITATION_LINK_CLOSED";
    ErrorCodeApi["INVITATION_POOL_NOT_ALLOWED"] = "INVITATION_POOL_NOT_ALLOWED";
    ErrorCodeApi["SALES_TAX_NOT_FOUND"] = "SALES_TAX_NOT_FOUND";
    ErrorCodeApi["SALES_TAX_COUNTRY_DUPLICATE"] = "SALES_TAX_COUNTRY_DUPLICATE";
    ErrorCodeApi["MESSAGING_THREAD_DUPLICATE"] = "MESSAGING_THREAD_DUPLICATE";
    ErrorCodeApi["CURRENCY_NOT_FOUND"] = "CURRENCY_NOT_FOUND";
    ErrorCodeApi["USER_NOT_IN_PFP"] = "USER_NOT_IN_PFP";
    ErrorCodeApi["PFP_SKILL_NOT_FOUND"] = "PFP_SKILL_NOT_FOUND";
    ErrorCodeApi["PFP_SKILL_INVALID"] = "PFP_SKILL_INVALID";
    ErrorCodeApi["PFP_SKILL_DUPLICATE"] = "PFP_SKILL_DUPLICATE";
    ErrorCodeApi["TRANSLATIONS_FILTER_INVALID_LIMIT"] = "TRANSLATIONS_FILTER_INVALID_LIMIT";
    ErrorCodeApi["TAX_NUMBER_INVALID"] = "TAX_NUMBER_INVALID";
    ErrorCodeApi["TAX_TYPE_NOT_SUPPORTED"] = "TAX_TYPE_NOT_SUPPORTED";
    ErrorCodeApi["TAX_NUMBER_DUPLICATE"] = "TAX_NUMBER_DUPLICATE";
    ErrorCodeApi["TAX_SUBTYPE_INVALID"] = "TAX_SUBTYPE_INVALID";
    ErrorCodeApi["TAX_DEACTIVATE_NOT_ALLOWED"] = "TAX_DEACTIVATE_NOT_ALLOWED";
    ErrorCodeApi["TAX_NUMBER_DOES_NOT_EXIST"] = "TAX_NUMBER_DOES_NOT_EXIST";
    ErrorCodeApi["US_TAX_MATCH_REJECTED"] = "US_TAX_MATCH_REJECTED";
    ErrorCodeApi["US_TAX_MATCH_COMMUNICATION_ERROR"] = "US_TAX_MATCH_COMMUNICATION_ERROR";
    ErrorCodeApi["TAX_NAME_INVALID"] = "TAX_NAME_INVALID";
    ErrorCodeApi["TAX_STATEMENT_ERROR"] = "TAX_STATEMENT_ERROR";
    ErrorCodeApi["TAX_OPT_OUT_NOT_ALLOWED"] = "TAX_OPT_OUT_NOT_ALLOWED";
    ErrorCodeApi["TAX_OPT_OUT_INVALID_OPTION"] = "TAX_OPT_OUT_INVALID_OPTION";
    ErrorCodeApi["TAX_OPT_OUT_EXTRA_DETAILS_REQUIRED"] = "TAX_OPT_OUT_EXTRA_DETAILS_REQUIRED";
    ErrorCodeApi["TAX_OPT_OUT_NOT_FOUND"] = "TAX_OPT_OUT_NOT_FOUND";
    ErrorCodeApi["TAX_OPT_OUT_DUPLICATE"] = "TAX_OPT_OUT_DUPLICATE";
    ErrorCodeApi["TAX_OPT_OUT_REVERT_NOT_ALLOWED"] = "TAX_OPT_OUT_REVERT_NOT_ALLOWED";
    ErrorCodeApi["APPLICATION_CAPTCHA_INVALID"] = "APPLICATION_CAPTCHA_INVALID";
    ErrorCodeApi["APPLICATION_EMAIL_INVALID"] = "APPLICATION_EMAIL_INVALID";
    ErrorCodeApi["APPLICATION_DUPLICATE"] = "APPLICATION_DUPLICATE";
    ErrorCodeApi["APPLICATION_ATTACHMENT_TOO_BIG"] = "APPLICATION_ATTACHMENT_TOO_BIG";
    ErrorCodeApi["APPLICATION_ATTACHMENT_INVALID"] = "APPLICATION_ATTACHMENT_INVALID";
    ErrorCodeApi["CONTENT_CUSTOMIZATION_INVALID"] = "CONTENT_CUSTOMIZATION_INVALID";
    ErrorCodeApi["CONTENT_CUSTOMIZATION_FILE_NOT_FOUND"] = "CONTENT_CUSTOMIZATION_FILE_NOT_FOUND";
    ErrorCodeApi["CONTENT_CUSTOMIZATION_FILE_EXCEEDS_LIMIT"] = "CONTENT_CUSTOMIZATION_FILE_EXCEEDS_LIMIT";
    ErrorCodeApi["CONTENT_CUSTOMIZATION_ALREADY_EXISTS"] = "CONTENT_CUSTOMIZATION_ALREADY_EXISTS";
    ErrorCodeApi["CONTENT_CUSTOMIZATION_NOT_FOUND"] = "CONTENT_CUSTOMIZATION_NOT_FOUND";
    ErrorCodeApi["OPERATING_AREA_NOT_FOUND"] = "OPERATING_AREA_NOT_FOUND";
    ErrorCodeApi["EQUIPMENT_GROUP_NOT_FOUND"] = "EQUIPMENT_GROUP_NOT_FOUND";
    ErrorCodeApi["USER_CUSTOM_EMAIL_LIMIT_REACHED"] = "USER_CUSTOM_EMAIL_LIMIT_REACHED";
    ErrorCodeApi["USER_CUSTOM_EMAIL_TEMPLATE_DATA_INVALID"] = "USER_CUSTOM_EMAIL_TEMPLATE_DATA_INVALID";
    ErrorCodeApi["USER_CUSTOM_EMAIL_RECIPIENT_INVALID"] = "USER_CUSTOM_EMAIL_RECIPIENT_INVALID";
    ErrorCodeApi["LINKED_EXTERNAL_PROJECT_UPDATE_NOT_ALLOWED"] = "LINKED_EXTERNAL_PROJECT_UPDATE_NOT_ALLOWED";
    ErrorCodeApi["LINKED_EXTERNAL_PROJECT_INVALID"] = "LINKED_EXTERNAL_PROJECT_INVALID";
    ErrorCodeApi["LINKED_EXTERNAL_PROJECT_ALREADY_EXISTS"] = "LINKED_EXTERNAL_PROJECT_ALREADY_EXISTS";
    ErrorCodeApi["WIRE_ACCOUNT_VALIDATION_FAIL"] = "WIRE_ACCOUNT_VALIDATION_FAIL";
    ErrorCodeApi["CORPORATE_TEAM_REGISTRATION_DUPLICATE"] = "CORPORATE_TEAM_REGISTRATION_DUPLICATE";
    ErrorCodeApi["CORPORATE_TEAM_REGISTRATION_NOT_ALLOWED"] = "CORPORATE_TEAM_REGISTRATION_NOT_ALLOWED";
    ErrorCodeApi["CORPORATE_TEAM_REGISTRATION_INVALID"] = "CORPORATE_TEAM_REGISTRATION_INVALID";
    ErrorCodeApi["BID_PITCH_NOT_FOUND"] = "BID_PITCH_NOT_FOUND";
    ErrorCodeApi["USER_DOCUMENT_SUBMISSION_DUPLICATE"] = "USER_DOCUMENT_SUBMISSION_DUPLICATE";
    ErrorCodeApi["USER_DOCUMENT_SUBMISSION_NOT_FOUND"] = "USER_DOCUMENT_SUBMISSION_NOT_FOUND";
    ErrorCodeApi["DOCUMENT_TYPE_NOT_FOUND"] = "DOCUMENT_TYPE_NOT_FOUND";
    ErrorCodeApi["DOCUMENT_TYPE_FILE_NOT_FOUND"] = "DOCUMENT_TYPE_FILE_NOT_FOUND";
    ErrorCodeApi["DOCUMENT_TYPE_FIELD_NOT_FOUND"] = "DOCUMENT_TYPE_FIELD_NOT_FOUND";
    ErrorCodeApi["VERIFICATION_PROCESS_TYPE_NOT_FOUND"] = "VERIFICATION_PROCESS_TYPE_NOT_FOUND";
    ErrorCodeApi["USER_VERIFICATION_PROCESS_NOT_FOUND"] = "USER_VERIFICATION_PROCESS_NOT_FOUND";
    ErrorCodeApi["USER_VERIFICATION_PROCESS_ALREADY_ACTIVE"] = "USER_VERIFICATION_PROCESS_ALREADY_ACTIVE";
    ErrorCodeApi["USER_DOCUMENT_SUBMISSION_ALREADY_ACTIVE"] = "USER_DOCUMENT_SUBMISSION_ALREADY_ACTIVE";
    ErrorCodeApi["CARD_AUTHENTICATION_REQUIRED"] = "CARD_AUTHENTICATION_REQUIRED";
    ErrorCodeApi["DELIVERY_ITEMS_BELONG_TO_OTHER_PROJECT"] = "DELIVERY_ITEMS_BELONG_TO_OTHER_PROJECT";
    ErrorCodeApi["DELIVERY_ITEMS_INVALID"] = "DELIVERY_ITEMS_INVALID";
    ErrorCodeApi["PROJECT_HAS_ACTIVE_BIDS"] = "PROJECT_HAS_ACTIVE_BIDS";
    ErrorCodeApi["PAYOUT_LIMIT_EXEMPTION_DUPLICATE"] = "PAYOUT_LIMIT_EXEMPTION_DUPLICATE";
    ErrorCodeApi["PAYOUT_LIMIT_EXEMPTION_NOT_FOUND"] = "PAYOUT_LIMIT_EXEMPTION_NOT_FOUND";
    ErrorCodeApi["PAYMENT_SHARING_INVALID_DATE_TIME_RANGE"] = "PAYMENT_SHARING_INVALID_DATE_TIME_RANGE";
    ErrorCodeApi["BLACKLISTED_WORD_FOUND"] = "BLACKLISTED_WORD_FOUND";
    ErrorCodeApi["USER_AVAILABILITY_NOT_FOUND"] = "USER_AVAILABILITY_NOT_FOUND";
    ErrorCodeApi["USER_AVAILABILITY_INVALID_DATE_RANGE"] = "USER_AVAILABILITY_INVALID_DATE_RANGE";
    ErrorCodeApi["RECRUITER_UPGRADE_DUPLICATE"] = "RECRUITER_UPGRADE_DUPLICATE";
    ErrorCodeApi["FREE_RECRUITER_UPGRADE_NOT_ALLOWED"] = "FREE_RECRUITER_UPGRADE_NOT_ALLOWED";
    ErrorCodeApi["NEXT_PROJECT_RECOMMENDATIONS_INVALID_PROJECT"] = "NEXT_PROJECT_RECOMMENDATIONS_INVALID_PROJECT";
    ErrorCodeApi["NEXT_PROJECT_RECOMMENDATIONS_INVALID_OPENAI_RESPONSE_FORMAT"] = "NEXT_PROJECT_RECOMMENDATIONS_INVALID_OPENAI_RESPONSE_FORMAT";
    ErrorCodeApi["PROFILE_LIMIT_REACHED"] = "PROFILE_LIMIT_REACHED";
    ErrorCodeApi["DEFAULT_PROFILE_ALREADY_EXISTS"] = "DEFAULT_PROFILE_ALREADY_EXISTS";
    ErrorCodeApi["PROFILE_NAME_ALREADY_EXISTS"] = "PROFILE_NAME_ALREADY_EXISTS";
    ErrorCodeApi["SUGGESTED_MESSAGE_CURRENT_USER_NOT_SUPPORT_AGENT"] = "SUGGESTED_MESSAGE_CURRENT_USER_NOT_SUPPORT_AGENT";
    ErrorCodeApi["SUGGESTED_MESSAGE_WRONG_CONTEXT_TYPE"] = "SUGGESTED_MESSAGE_WRONG_CONTEXT_TYPE";
    ErrorCodeApi["SUGGESTED_MESSAGE_THREAD_NOT_FOUND"] = "SUGGESTED_MESSAGE_THREAD_NOT_FOUND";
    ErrorCodeApi["SUGGESTED_MESSAGE_ENTERPRISE_NOT_SUPPORTED"] = "SUGGESTED_MESSAGE_ENTERPRISE_NOT_SUPPORTED";
    ErrorCodeApi["SUGGESTED_MESSAGE_SUPPORT_TYPE_NOT_SUPPORTED"] = "SUGGESTED_MESSAGE_SUPPORT_TYPE_NOT_SUPPORTED";
    ErrorCodeApi["PROJECT_SEO_DELOITTE_AUTH_REQUIRED"] = "PROJECT_SEO_DELOITTE_AUTH_REQUIRED";
    ErrorCodeApi["PCB_USER_IS_ALREADY_BANNED"] = "PCB_USER_IS_ALREADY_BANNED";
    ErrorCodeApi["PCB_USER_IS_ALREADY_UNBANNED"] = "PCB_USER_IS_ALREADY_UNBANNED";
    ErrorCodeApi["AI_PROMPT_INVALID_TEMPLATE"] = "AI_PROMPT_INVALID_TEMPLATE";
    ErrorCodeApi["AI_PROMPT_NOT_FOUND"] = "AI_PROMPT_NOT_FOUND";
    ErrorCodeApi["PREFERRED_AGENT_UNSUPPORTED_SUPPORT_TYPE"] = "PREFERRED_AGENT_UNSUPPORTED_SUPPORT_TYPE";
    ErrorCodeApi["PREFERRED_AGENT_ASSIGNMENT_NOT_FOUND"] = "PREFERRED_AGENT_ASSIGNMENT_NOT_FOUND";
    ErrorCodeApi["PREFERRED_AGENT_LOADSHIFT_ASSIGNED"] = "PREFERRED_AGENT_LOADSHIFT_ASSIGNED";
    ErrorCodeApi["PROJECT_COLLABORATION_GROUP_CHAT_INVITATION_ERROR"] = "PROJECT_COLLABORATION_GROUP_CHAT_INVITATION_ERROR";
    ErrorCodeApi["FINANCIAL_REPORTING_RECORD_ALREADY_EXISTS"] = "FINANCIAL_REPORTING_RECORD_ALREADY_EXISTS";
    ErrorCodeApi["SHOWCASE_CANNOT_FETCH_MIGRATED_IDS_FOR_USER"] = "SHOWCASE_CANNOT_FETCH_MIGRATED_IDS_FOR_USER";
    ErrorCodeApi["SHOWCASE_CANNOT_FETCH_SHOWCASE_IDS_FOR_USER"] = "SHOWCASE_CANNOT_FETCH_SHOWCASE_IDS_FOR_USER";
    ErrorCodeApi["SHOWCASE_FAILED_TO_ADD_SHOWCASE_ITEM_JOBS"] = "SHOWCASE_FAILED_TO_ADD_SHOWCASE_ITEM_JOBS";
    ErrorCodeApi["SHOWCASE_ERROR_DELETING_SHOWCASE"] = "SHOWCASE_ERROR_DELETING_SHOWCASE";
    ErrorCodeApi["SHOWCASE_SAMPLE_TEXT_TOO_LONG"] = "SHOWCASE_SAMPLE_TEXT_TOO_LONG";
    ErrorCodeApi["SHOWCASE_SAMPLE_TEXT_INVALID"] = "SHOWCASE_SAMPLE_TEXT_INVALID";
    ErrorCodeApi["RECEIVER_ALREADY_IN_CALL"] = "RECEIVER_ALREADY_IN_CALL";
    ErrorCodeApi["INVALID_VIDEOCHAT_ID"] = "INVALID_VIDEOCHAT_ID";
    ErrorCodeApi["CALLER_ALREADY_IN_CALL"] = "CALLER_ALREADY_IN_CALL";
    ErrorCodeApi["CHALLENGE_ELEMENT_LINKED_SOURCE_ALREADY_EXISTS"] = "CHALLENGE_ELEMENT_LINKED_SOURCE_ALREADY_EXISTS";
    ErrorCodeApi["DOCUMENT_NOT_FOUND"] = "DOCUMENT_NOT_FOUND";
    ErrorCodeApi["DOCUMENT_OPERATION_FAILED"] = "DOCUMENT_OPERATION_FAILED";
    ErrorCodeApi["VECTOR_SEARCH_FAILED"] = "VECTOR_SEARCH_FAILED";
    ErrorCodeApi["EMBEDDINGS_NOT_RETURNED"] = "EMBEDDINGS_NOT_RETURNED";
    ErrorCodeApi["DATA_VECTORIZE_FAILED"] = "DATA_VECTORIZE_FAILED";
    ErrorCodeApi["NO_DECOMPOSED_QUERY_RETURNED"] = "NO_DECOMPOSED_QUERY_RETURNED";
    ErrorCodeApi["PROTOTYPER_LIMIT_REACHED"] = "PROTOTYPER_LIMIT_REACHED";
    ErrorCodeApi["ABN_SERVICE_FAILED"] = "ABN_SERVICE_FAILED";
})(ErrorCodeApi || (ErrorCodeApi = {}));
export const ErrorDefaultsMapApi = {
    [ErrorCodeApi.INTERNAL_SERVER_ERROR]: {
        http_code: 500,
        old_code: 'UNKNOWN_ERROR',
        detail: 'An unknown error occurred. Please try again or contact support.',
    },
    [ErrorCodeApi.NOT_IMPLEMENTED]: {
        http_code: 501,
        old_code: 'UNKNOWN_ERROR',
        detail: 'An unknown error occurred. Please try again or contact support.',
    },
    [ErrorCodeApi.BAD_GATEWAY]: {
        http_code: 502,
        old_code: 'UNKNOWN_ERROR',
        detail: 'An unknown error occurred. Please try again or contact support.',
    },
    [ErrorCodeApi.SERVICE_UNAVAILABLE]: {
        http_code: 503,
        old_code: 'UNKNOWN_ERROR',
        detail: 'An unknown error occurred. Please try again or contact support.',
    },
    [ErrorCodeApi.GATEWAY_TIMEOUT]: {
        http_code: 504,
        old_code: 'UNKNOWN_ERROR',
        detail: 'An unknown error occurred. Please try again or contact support.',
    },
    [ErrorCodeApi.SITEWIDE_SCHEDULED_MAINTENANCE]: {
        http_code: 503,
        old_code: 'UNKNOWN_ERROR',
        detail: 'Freelancer.com is temporarily unavailable for scheduled maintenance. We expect to be back in a few minutes. Thank you for your patience. If you have any questions please get in contact with us at support@freelancer.com.',
    },
    [ErrorCodeApi.BAD_REQUEST]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'Invalid request',
    },
    [ErrorCodeApi.UNAUTHORIZED]: {
        http_code: 401,
        old_code: 'NOT_AUTHENTICATED',
        detail: 'You must be authenticated to perform this request.',
    },
    [ErrorCodeApi.PAYMENT_REQUIRED]: {
        http_code: 402,
        old_code: 'BAD_REQUEST',
        detail: 'The user does not have sufficient funds or payment is required.',
    },
    [ErrorCodeApi.FORBIDDEN]: {
        http_code: 403,
        old_code: 'PERMISSION_DENIED',
        detail: 'The user does not have sufficient permissions to perform this request.',
    },
    [ErrorCodeApi.NOT_FOUND]: {
        http_code: 404,
        old_code: 'NOT_FOUND',
        detail: 'The requested resource does not exist.',
    },
    [ErrorCodeApi.METHOD_NOT_ALLOWED]: {
        http_code: 405,
        old_code: 'BAD_REQUEST',
        detail: 'The requested method is not supported for this resource.',
    },
    [ErrorCodeApi.NOT_ACCEPTABLE]: {
        http_code: 406,
        old_code: 'BAD_REQUEST',
        detail: 'The requested media type is not supported by this endpoint.',
    },
    [ErrorCodeApi.CONFLICT]: {
        http_code: 409,
        old_code: 'BAD_REQUEST',
        detail: 'The requested operation conflicts with the current state of the resource.',
    },
    [ErrorCodeApi.BID_DUPLICATE]: {
        http_code: 409,
        old_code: 'DUPLICATE_BID',
        detail: 'You have already bid on that project.',
    },
    [ErrorCodeApi.BID_TOO_EARLY]: {
        http_code: 400,
        old_code: 'BID_TOO_EARLY',
        detail: 'You have submitted a bid too early, please try again later.',
    },
    [ErrorCodeApi.REQUEST_ENTITY_TOO_LARGE]: {
        http_code: 413,
        old_code: 'BAD_REQUEST',
        detail: 'The request entity is too large.',
    },
    [ErrorCodeApi.REQUEST_URI_TOO_LONG]: {
        http_code: 414,
        old_code: 'BAD_REQUEST',
        detail: 'The request URI is too long.',
    },
    [ErrorCodeApi.UNSUPPORTED_MEDIA_TYPE]: {
        http_code: 415,
        old_code: 'BAD_REQUEST',
        detail: 'This endpoint does not support the submitted media type.',
    },
    [ErrorCodeApi.TOO_MANY_REQUESTS]: {
        http_code: 429,
        old_code: 'RATE_LIMITED',
        detail: 'You have performed too many requests of this type, please try again later.',
    },
    [ErrorCodeApi.MALFORMED_JSON]: {
        http_code: 400,
        old_code: 'BAD_JSON',
        detail: 'Unable to decode required JSON for this request.',
    },
    [ErrorCodeApi.TYPE_VALIDATION_FAILED]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'Parameter type does not match the expected type.',
    },
    [ErrorCodeApi.REQUIRED_VALIDATION_FAILED]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'One or more required parameters are missing.',
    },
    [ErrorCodeApi.ENUM_VALIDATION_FAILED]: {
        http_code: 400,
        old_code: 'BAD_ENUM',
        detail: 'Parameter value is not one of the valid enum members.',
    },
    [ErrorCodeApi.PATTERN_VALIDATION_FAILED]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'Parameter value does not match the regular expression used to validate this parameter.',
    },
    [ErrorCodeApi.CONST_VALIDATION_FAILED]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'Parameter value does not equal the expected value.',
    },
    [ErrorCodeApi.MAX_VALUE_VALIDATION_FAILED]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'Parameter value is greater than the maximum allowed value.',
    },
    [ErrorCodeApi.MIN_VALUE_VALIDATION_FAILED]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'Parameter value is less than the minimum allowed value.',
    },
    [ErrorCodeApi.MAX_LENGTH_VALIDATION_FAILED]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'Parameter value length is greater than the maximum allowed length.',
    },
    [ErrorCodeApi.MIN_LENGTH_VALIDATION_FAILED]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'Parameter value length is less than the minimum allowed length.',
    },
    [ErrorCodeApi.MAX_ITEMS_VALIDATION_FAILED]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'Parameter has more items than the maximum allowed number of items.',
    },
    [ErrorCodeApi.MIN_ITEMS_VALIDATION_FAILED]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'Parameter has less items than the minimum allowed number of items.',
    },
    [ErrorCodeApi.UNIQUE_ITEMS_VALIDATION_FAILED]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'Parameter values in this array must be unique.',
    },
    [ErrorCodeApi.MULTIPLE_OF_VALIDATION_FAILED]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'Parameter must be a multiple of some value.',
    },
    [ErrorCodeApi.LOCATION_COORDINATES_VALIDATION_FAILED]: {
        http_code: 400,
        old_code: 'INVALID_LOCATION',
        detail: 'Parameter must be a valid location coordinate.',
    },
    [ErrorCodeApi.COURSE_NOT_AUTHORED]: {
        http_code: 403,
        old_code: 'PERMISSION_DENIED',
        detail: 'The requested operation cannot be performed because you are not the owner of the course.',
    },
    [ErrorCodeApi.COURSE_DELETED]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'The requested operation cannot be performed on a deleted course.',
    },
    [ErrorCodeApi.COURSE_CLOSED]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'The requested operation cannot be performed on a closed course.',
    },
    [ErrorCodeApi.COURSE_PUBLISHED]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'The requested operation cannot be performed on a published course.',
    },
    [ErrorCodeApi.COURSE_UNPUBLISHED]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'The requested operation cannot be performed on an draft course.',
    },
    [ErrorCodeApi.COURSE_HAS_STUDENTS]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'The requested operation cannot be performed on a course that has enrolled students.',
    },
    [ErrorCodeApi.PROJECT_UPGRADE_DUPLICATE]: {
        http_code: 400,
        old_code: 'PROJECT_UPGRADE_DUPLICATE_UPGRADE',
        detail: 'The project already has the requested upgrade.',
    },
    [ErrorCodeApi.PROJECT_UPGRADE_AWARDED]: {
        http_code: 400,
        old_code: 'FREELANCER_ALREADY_AWARDED',
        detail: 'The project upgrade cannot be applied as the project has already been awarded.',
    },
    [ErrorCodeApi.DEPOSIT_USER_ID_INVALID]: {
        http_code: 400,
        old_code: 'DEPOSIT_USER_ID_INVALID',
        detail: 'User ID should be a number.',
    },
    [ErrorCodeApi.DEPOSIT_METHOD_INVALID]: {
        http_code: 400,
        old_code: 'DEPOSIT_METHOD_INVALID',
        detail: 'Deposit method invalid.',
    },
    [ErrorCodeApi.DEPOSIT_ACTION_INVALID]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'Deposit action invalid.',
    },
    [ErrorCodeApi.DEPOSIT_CANCEL_URL_INVALID]: {
        http_code: 400,
        old_code: 'DEPOSIT_CANCEL_URL_INVALID',
        detail: 'Invalid cancel URL.',
    },
    [ErrorCodeApi.DEPOSIT_INVOICE_ID_INVALID]: {
        http_code: 400,
        old_code: 'DEPOSIT_INVOICE_INVALID',
        detail: 'Invoice with given ID does not exist.',
    },
    [ErrorCodeApi.DEPOSIT_CURRENCY_ID_INVALID]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'Currency value should be numeric.',
    },
    [ErrorCodeApi.DEPOSIT_AMOUNT_INVALID]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'Amount value should be numeric.',
    },
    [ErrorCodeApi.DEPOSIT_CONFIRM_URL_REQUIRED]: {
        http_code: 400,
        old_code: 'DEPOSIT_SETUP_FAIL',
        detail: 'Confirmation url is required.',
    },
    [ErrorCodeApi.DEPOSIT_CONFIRM_URL_INVALID]: {
        http_code: 400,
        old_code: 'DEPOSIT_SETUP_FAIL',
        detail: 'Confirmation url is invalid.',
    },
    [ErrorCodeApi.DEPOSIT_COUNTRY_CODE_REQUIRED]: {
        http_code: 400,
        old_code: 'DEPOSIT_SETUP_FAIL',
        detail: 'Country code is required.',
    },
    [ErrorCodeApi.DEPOSIT_CANCEL_URL_REQUIRED]: {
        http_code: 400,
        old_code: 'DEPOSIT_CANCEL_URL_INVALID',
        detail: 'Cancel url is required.',
    },
    [ErrorCodeApi.DEPOSIT_AUTHORIZATION_EXISTS]: {
        http_code: 400,
        old_code: 'DEPOSIT_ALREADY_BILLING_AGREEMENT',
        detail: 'Billing agreement already exists.',
    },
    [ErrorCodeApi.PAYMENT_VERIFICATION_REQUIRED]: {
        http_code: 400,
        old_code: 'UNVERIFIED_PAYMENT',
        detail: 'AutomaticPayment: Payment source not verified.',
    },
    [ErrorCodeApi.DEPOSIT_IDEAL_BANK_INVALID]: {
        http_code: 400,
        old_code: 'DEPOSIT_SETUP_FAIL',
        detail: 'Invalid bank specified for ideal method',
    },
    [ErrorCodeApi.DEPOSIT_IDEAL_BANK_REQUIRED]: {
        http_code: 400,
        old_code: 'DEPOSIT_SETUP_FAIL',
        detail: 'Bank is required for ideal method',
    },
    [ErrorCodeApi.DEPOSIT_BOLETO_NAME_REQUIRED]: {
        http_code: 400,
        old_code: 'DEPOSIT_SETUP_FAIL',
        detail: 'Name is required',
    },
    [ErrorCodeApi.DEPOSIT_BOLETO_DOCUMENT_REQUIRED]: {
        http_code: 400,
        old_code: 'DEPOSIT_SETUP_FAIL',
        detail: 'Document is required',
    },
    [ErrorCodeApi.DEPOSIT_BOLETO_PHONE_REQUIRED]: {
        http_code: 400,
        old_code: 'DEPOSIT_SETUP_FAIL',
        detail: 'Phone is required',
    },
    [ErrorCodeApi.DEPOSIT_BOLETO_ADDRESS_REQUIRED]: {
        http_code: 400,
        old_code: 'DEPOSIT_SETUP_FAIL',
        detail: 'Address is required',
    },
    [ErrorCodeApi.DEPOSIT_BOLETO_STREET_NUMBER_REQUIRED]: {
        http_code: 400,
        old_code: 'DEPOSIT_SETUP_FAIL',
        detail: 'Street number required',
    },
    [ErrorCodeApi.DEPOSIT_BOLETO_CITY_REQUIRED]: {
        http_code: 400,
        old_code: 'DEPOSIT_SETUP_FAIL',
        detail: 'City required',
    },
    [ErrorCodeApi.DEPOSIT_BOLETO_STATE_REQUIRED]: {
        http_code: 400,
        old_code: 'DEPOSIT_SETUP_FAIL',
        detail: 'State required',
    },
    [ErrorCodeApi.DEPOSIT_BOLETO_ZIP_REQUIRED]: {
        http_code: 400,
        old_code: 'DEPOSIT_SETUP_FAIL',
        detail: 'Zip required',
    },
    [ErrorCodeApi.DEPOSIT_BOLETO_ZIP_INVALID]: {
        http_code: 400,
        old_code: 'DEPOSIT_SETUP_FAIL',
        detail: 'Invalid zip',
    },
    [ErrorCodeApi.DEPOSIT_BOLETO_BIRTHDATE_REQUIRED]: {
        http_code: 400,
        old_code: 'DEPOSIT_SETUP_FAIL',
        detail: 'Birthday required',
    },
    [ErrorCodeApi.DEPOSIT_FLNBLN_GATEWAY_REQUIRED]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'Gateway required',
    },
    [ErrorCodeApi.DEPOSIT_FLNBLN_GATEWAY_INVALID]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'Invalid gateway',
    },
    [ErrorCodeApi.DEPOSIT_WIRE_SENDER_NAME_REQUIRED]: {
        http_code: 400,
        old_code: 'DEPOSIT_CONFIRM_FAIL',
        detail: 'Sender name required',
    },
    [ErrorCodeApi.DEPOSIT_WIRE_SEND_DATE_REQUIRED]: {
        http_code: 400,
        old_code: 'DEPOSIT_CONFIRM_FAIL',
        detail: 'Sender date required',
    },
    [ErrorCodeApi.DEPOSIT_WIRE_COMMENTS_REQUIRED]: {
        http_code: 400,
        old_code: 'DEPOSIT_CONFIRM_FAIL',
        detail: 'Comments required',
    },
    [ErrorCodeApi.PAYMENT_SOURCE_TOKEN_INVALID]: {
        http_code: 400,
        old_code: 'DEPOSIT_METHOD_INVALID',
        detail: 'Invalid payment source token.',
    },
    [ErrorCodeApi.BIN_NON_RECURRING]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'We are not supporting this card type for verification',
    },
    [ErrorCodeApi.EMPLOYER_AWARD_RESTRICTION]: {
        http_code: 403,
        old_code: 'USER_RESTRICTED_FROM_AWARDING',
        detail: 'You currently have a restriction that prevents you from awarding a project',
    },
    [ErrorCodeApi.FREELANCER_AWARD_RESTRICTION]: {
        http_code: 403,
        old_code: 'FREELANCER_RESTRICTED_FROM_BEING_AWARDED',
        detail: 'The freelancer currently has a restriction that prevents them from being awarded a new project',
    },
    [ErrorCodeApi.EMAIL_VERIFICATION_REQUIRED]: {
        http_code: 403,
        old_code: 'EMAIL_VERIFICATION_REQUIRED',
        detail: 'User has to verify email address before taking this action',
    },
    [ErrorCodeApi.PROFILE_INCOMPLETE]: {
        http_code: 403,
        old_code: 'PROFILE_INCOMPLETE',
        detail: 'User has to complete the profile before taking this action',
    },
    [ErrorCodeApi.HIREME_FREELANCER_IS_SELF]: {
        http_code: 400,
        old_code: 'HIREME_SAME_SELLER_BUYER',
        detail: 'User cannot hire himself.',
    },
    [ErrorCodeApi.PROJECT_TYPE_INVALID]: {
        http_code: 400,
        old_code: 'HIREME_INVALID_PROJECT_TYPE',
        detail: 'Unknown project type',
    },
    [ErrorCodeApi.CURRENCY_ID_INVALID]: {
        http_code: 400,
        old_code: 'HIREME_INVALID_CURRENCY_ID',
        detail: 'Invalid currency ID',
    },
    [ErrorCodeApi.BID_AMOUNT_TOO_LOW]: {
        http_code: 400,
        old_code: 'HIREME_BID_AMOUNT_TOO_SMALL',
        detail: 'Budget is smaller than the minimum budget',
    },
    [ErrorCodeApi.BID_AMOUNT_TOO_HIGH]: {
        http_code: 400,
        old_code: 'HIREME_BID_AMOUNT_TOO_BIG',
        detail: 'Budget is larger than the maximum budget',
    },
    [ErrorCodeApi.PROJECT_PERIOD_INVALID]: {
        http_code: 400,
        old_code: 'HIREME_INVALID_PERIOD',
        detail: 'Project period is incorrect for fixed type project',
    },
    [ErrorCodeApi.COMMITMENT_INTERVAL_INVALID]: {
        http_code: 400,
        old_code: 'HIREME_INVALID_COMMITMENT_INTERVAL',
        detail: 'Wrong commitment interval for hourly project',
    },
    [ErrorCodeApi.COMMITMENT_INVALID]: {
        http_code: 400,
        old_code: 'HIREME_INVALID_COMMITMENT',
        detail: 'Wrong commitment on project',
    },
    [ErrorCodeApi.DURATION_INVALID]: {
        http_code: 400,
        old_code: 'HIREME_INVALID_DURATION',
        detail: 'Wrong duration on project',
    },
    [ErrorCodeApi.JOB_ID_INVALID]: {
        http_code: 400,
        old_code: 'HIREME_INVALID_JOB_ID',
        detail: 'Job ID can not be found',
    },
    [ErrorCodeApi.PROJECT_JOBS_REQUIRED]: {
        http_code: 400,
        old_code: 'HIREME_PROJECT_NO_JOBS',
        detail: 'Skills for posting a project have not been provided',
    },
    [ErrorCodeApi.HIREME_FREELANCER_HAS_NO_JOBS]: {
        http_code: 400,
        old_code: 'HIREME_FREELANCER_HAS_NO_JOBS',
        detail: 'The freelancer has no skills',
    },
    [ErrorCodeApi.HIREME_PROJECT_POST_LIMIT_REACHED]: {
        http_code: 400,
        old_code: 'HIREME_PROJECT_POST_LIMIT_EXCEEDED',
        detail: 'Limit of posting hire-me projects have been exceeded',
    },
    [ErrorCodeApi.PROJECT_TITLE_CONTAINS_CONTACT_DETAILS]: {
        http_code: 400,
        old_code: 'HIREME_CONTACT_DETAILS_IN_PROJECT_TITLE',
        detail: 'Contact details are not allowed in project title',
    },
    [ErrorCodeApi.HIREME_EMPLOYER_RESTRICTED]: {
        http_code: 409,
        old_code: 'HIREME_EMPLOYER_RESTRICTED',
        detail: 'Cannot hire an Employer user with no bid history',
    },
    [ErrorCodeApi.PROJECT_TITLE_INVALID]: {
        http_code: 400,
        old_code: 'HIREME_EMPTY_PROJECT_TITLE',
        detail: 'The project title cannot be empty',
    },
    [ErrorCodeApi.PROJECT_DESCRIPTION_CONTAINS_CONTACT_DETAILS]: {
        http_code: 400,
        old_code: 'HIREME_CONTACT_DETAILS_IN_PROJECT_DESCRIPTION',
        detail: 'Contact details are not allowed in project description',
    },
    [ErrorCodeApi.PROJECT_DESCRIPTION_INVALID]: {
        http_code: 400,
        old_code: 'HIREME_EMPTY_PROJECT_DESCRIPTION',
        detail: 'The project description cannot be empty',
    },
    [ErrorCodeApi.HIREME_INITIAL_BID_REQUIRED]: {
        http_code: 400,
        old_code: 'HIREME_INITIAL_BID_MISSING',
        detail: 'Hireme project needs initial bid with bidder id and amount',
    },
    [ErrorCodeApi.HIREME_BID_AMOUNT_REQUIRED]: {
        http_code: 400,
        old_code: 'HIREME_BID_MISSING_AMOUNT',
        detail: 'Budget for a hire-me project is required',
    },
    [ErrorCodeApi.PROJECT_TITLE_NOT_UNIQUE]: {
        http_code: 400,
        old_code: 'HIREME_DUPLICATE_PROJECT_TITLE',
        detail: 'Duplicate project title',
    },
    [ErrorCodeApi.PROJECT_DESCRIPTION_LENGTH_INVALID]: {
        http_code: 400,
        old_code: 'HIREME_INVALID_PROJECT_DESCRIPTION_LENGTH',
        detail: 'Invalid project description length',
    },
    [ErrorCodeApi.FREELANCER_NOT_FOUND]: {
        http_code: 400,
        old_code: 'HIREME_SELLER_LOAD_FAILED',
        detail: 'Failed on fetching the freelancer info',
    },
    [ErrorCodeApi.LATITUDE_INVALID]: {
        http_code: 400,
        old_code: 'LATITUDE_INVALID',
        detail: 'Latitude must be between -90 and 90',
    },
    [ErrorCodeApi.LONGITUDE_INVALID]: {
        http_code: 400,
        old_code: 'LONGITUDE_INVALID',
        detail: 'Longitude must be between -180 and 180',
    },
    [ErrorCodeApi.FREELANCER_RESTRICTED_FROM_BIDDING]: {
        http_code: 400,
        old_code: 'RESTRICTED_FROM_BIDDING',
        detail: 'Freelancer is restricted from bidding',
    },
    [ErrorCodeApi.EMPLOYER_NOT_FOUND]: {
        http_code: 400,
        old_code: 'HIREME_BUYER_LOAD_FAILED',
        detail: 'Failed on fetching the employer info',
    },
    [ErrorCodeApi.BID_NOT_FOUND]: {
        http_code: 404,
        old_code: 'INVALID_BID',
        detail: 'Bid not found',
    },
    [ErrorCodeApi.BID_NOT_UNDER_PROJECT]: {
        http_code: 400,
        old_code: 'INVALID_REQUEST',
        detail: 'Bid is not under this project',
    },
    [ErrorCodeApi.PROJECT_PENDING_INVOICE]: {
        http_code: 400,
        old_code: 'INVALID_REQUEST',
        detail: 'Project has an outstanding invoice',
    },
    [ErrorCodeApi.PROJECT_PENDING_MILESTONE]: {
        http_code: 400,
        old_code: 'INVALID_REQUEST',
        detail: 'Project has pending milestone payments',
    },
    [ErrorCodeApi.PROJECT_PENDING_DISPUTE]: {
        http_code: 400,
        old_code: 'INVALID_REQUEST',
        detail: 'There is an active dispute on this project',
    },
    [ErrorCodeApi.PROJECT_END_STATUS_INVALID]: {
        http_code: 400,
        old_code: 'INVALID_REQUEST',
        detail: 'Unrecognized complete status',
    },
    [ErrorCodeApi.AUTOBILLING_ALREADY_ENABLED]: {
        http_code: 403,
        old_code: 'PERMISSION_DENIED',
        detail: 'Auto billing is already enabled',
    },
    [ErrorCodeApi.AUTOBILLING_ALREADY_DISABLED]: {
        http_code: 403,
        old_code: 'PERMISSION_DENIED',
        detail: 'Auto billing is already disabled',
    },
    [ErrorCodeApi.MILESTONE_DISPUTE_PENDING]: {
        http_code: 403,
        old_code: 'PERMISSION_DENIED',
        detail: 'You need to resolve the dispute before enabling auto billing',
    },
    [ErrorCodeApi.ENTRY_OWNER_ACCOUNT_CLOSED]: {
        http_code: 400,
        old_code: 'ACCOUNT_CLOSED_OR_SUSPENDED',
        detail: "You cannot perform this action on an entry while its owner's account is closed or suspended",
    },
    [ErrorCodeApi.PRIZE_AWARD_NOT_ALLOWED]: {
        http_code: 403,
        old_code: 'CREATE_PRIZE_NOT_ALLOWED',
        detail: 'You are not allowed to transfer or withdraw funds. Please contact support for more details',
    },
    [ErrorCodeApi.CONTEST_NOT_FOUND]: {
        http_code: 404,
        old_code: 'NOT_FOUND',
        detail: 'There is no contest with the given ID',
    },
    [ErrorCodeApi.ENTRY_NOT_FOUND]: {
        http_code: 404,
        old_code: 'NOT_FOUND',
        detail: 'There is no entry with the given ID',
    },
    [ErrorCodeApi.CONTEST_SKILL_REQUIRED]: {
        http_code: 400,
        old_code: 'CONTEST_SKILL_REQUIRED',
        detail: 'You need to enter at least one skill',
    },
    [ErrorCodeApi.CONTEST_EXCEEDS_MAX_SKILLS]: {
        http_code: 400,
        old_code: 'CONTEST_EXCEEDS_MAX_SKILLS',
        detail: 'You can only have ten skills at most',
    },
    [ErrorCodeApi.CONTEST_ACCEPTED_FILE_FORMATS_REQUIRED]: {
        http_code: 400,
        old_code: 'CONTEST_ACCEPTED_FILE_FORMATS_REQUIRED',
        detail: 'You need to enter at least one file format',
    },
    [ErrorCodeApi.CONTEST_EXTENDED_UPGRADE_REQUIRED]: {
        http_code: 400,
        old_code: 'CONTEST_NEED_EXTENDED_UPGRADE',
        detail: 'You need to use Extended upgrade in order to update the contest',
    },
    [ErrorCodeApi.CONTEST_DELETED]: {
        http_code: 400,
        old_code: 'CONTEST_DELETED',
        detail: 'The contest with the given ID has been deleted',
    },
    [ErrorCodeApi.CONTEST_MESSAGE_NOT_FOUND]: {
        http_code: 404,
        old_code: 'CONTEST_MESSAGE_NOT_FOUND',
        detail: 'The contest message with the given ID does not exist',
    },
    [ErrorCodeApi.CONTEST_USER_RESTRICTED]: {
        http_code: 403,
        old_code: 'CONTEST_USER_RESTRICTED',
        detail: "You can't perform this action because your account has been restricted from contests",
    },
    [ErrorCodeApi.ENTRY_HASHTAG_LIMIT_EXCEEDED]: {
        http_code: 400,
        old_code: 'ENTRY_ID_HASHTAG_LIMIT_EXCEEDED',
        detail: 'You may only refer to a maximum of 10 entries in each comment',
    },
    [ErrorCodeApi.PROJECT_USER_NOT_OWNER]: {
        http_code: 403,
        old_code: 'PROJECT_NOT_OWNED_BY_USER',
        detail: 'User is not the owner of the project',
    },
    [ErrorCodeApi.CONTEST_USER_NOT_OWNER]: {
        http_code: 403,
        old_code: 'CONTEST_NOT_OWNED_BY_USER',
        detail: 'User is not the owner of the contest',
    },
    [ErrorCodeApi.PROJECT_JOB_ID_INVALID]: {
        http_code: 400,
        old_code: 'INVALID_PROJECT_JOB_ID',
        detail: 'Invalid Job ID for the project',
    },
    [ErrorCodeApi.KYC_REQUIRED]: {
        http_code: 403,
        old_code: 'KYC_REQUIRED',
        detail: 'You must complete KYC to perform this action',
    },
    [ErrorCodeApi.ESCROWCOM_ACCOUNT_UNLINKED]: {
        http_code: 403,
        old_code: 'ESCROWCOM_ACCOUNT_UNLINKED',
        detail: 'You must have a linked Escrow.com account to perform this action',
    },
    [ErrorCodeApi.BID_DESCRIPTION_CONTAINS_CONTACT_DETAILS]: {
        http_code: 400,
        old_code: 'BID_DESCRIPTION_CONTAINS_EMAIL',
        detail: 'You are not allowed to post contact details in bid description.',
    },
    [ErrorCodeApi.PHONE_VERIFICATION_REQUIRED]: {
        http_code: 403,
        old_code: 'PHONE_VERIFICATION_REQUIRED',
        detail: 'User has to verify phone number before taking this action',
    },
    [ErrorCodeApi.NDA_NOT_SIGNED]: {
        http_code: 403,
        old_code: 'NDA_NOT_SIGNED',
        detail: 'You must sign the NDA to work on this project.',
    },
    [ErrorCodeApi.BID_AWARD_PENDING]: {
        http_code: 400,
        old_code: 'BID_AWARD_PENDING',
        detail: 'The project has already been awarded to you. To continue with bid retraction, decline the project first.',
    },
    [ErrorCodeApi.PROJECT_NOT_LOCAL_JOBS]: {
        http_code: 400,
        old_code: 'INVALID_PROJECT',
        detail: 'Project is not a local jobs.',
    },
    [ErrorCodeApi.BID_UNABLE_TO_REQUEST_LOCATION_SHARING]: {
        http_code: 400,
        old_code: 'INVALID_REQUEST',
        detail: 'You can only request for location sharing once.',
    },
    [ErrorCodeApi.FREELANCER_ACCOUNT_UNDER_REVIEW]: {
        http_code: 403,
        old_code: 'FREELANCER_ACCOUNT_UNDER_REVIEW',
        detail: "This freelancer's account is under review. Please choose another freelancer to award this project to.",
    },
    [ErrorCodeApi.BIDDER_NOT_INVITED]: {
        http_code: 403,
        old_code: 'BIDDER_NOT_INVITED',
        detail: 'You must have been invited by the project owner to be able to place bids on this project.',
    },
    [ErrorCodeApi.MILESTONE_RELEASED]: {
        http_code: 400,
        old_code: 'MILESTONE_RELEASED',
        detail: 'The Milestone Payment has already released.',
    },
    [ErrorCodeApi.PROJECT_DELETED]: {
        http_code: 400,
        old_code: 'PROJECT_DELETED',
        detail: 'The specified project has been deleted.',
    },
    [ErrorCodeApi.PROJECT_NOT_ACCEPTED]: {
        http_code: 403,
        old_code: 'PROJECT_NOT_ACCEPTED',
        detail: 'The action is not allowed, as the project has not been accepted.',
    },
    [ErrorCodeApi.MAXIMUM_AWARDED_BIDDERS_REACHED]: {
        http_code: 403,
        old_code: 'MAXIMUM_AWARDED_BIDDERS_REACHED',
        detail: 'You have already reached the maximum awarded bidders for this project.',
    },
    [ErrorCodeApi.RESTRICTED_FROM_BIDDING_PREMIUM]: {
        http_code: 403,
        old_code: 'RESTRICTED_FROM_BIDDING_PREMIUM',
        detail: 'You must have more reviews, be Verified by Freelancer or be on a Plus, Professional or Premier membership to bid on this project.',
    },
    [ErrorCodeApi.RESTRICTED_FROM_BIDDING_PREMIUM_VERIFIED]: {
        http_code: 403,
        old_code: 'RESTRICTED_FROM_BIDDING_PREMIUM_VERIFIED',
        detail: 'You must be Verified by Freelancer to bid on this project.',
    },
    [ErrorCodeApi.RESTRICTED_FROM_BIDDING_PREMIUM_VERIFIED_JOB]: {
        http_code: 403,
        old_code: 'RESTRICTED_FROM_BIDDING_PREMIUM_VERIFIED_JOB',
        detail: 'You must be Verified by Freelancer to bid on this project.',
    },
    [ErrorCodeApi.FREELANCER_ALREADY_AWARDED]: {
        http_code: 400,
        old_code: 'FREELANCER_ALREADY_AWARDED',
        detail: 'This freelancer has already been awarded.',
    },
    [ErrorCodeApi.BID_EDIT_REQUEST_DUPLICATE]: {
        http_code: 409,
        old_code: 'BID_EDIT_REQUEST_DUPLICATE',
        detail: "You have already submitted a request to change the bid. Please wait for employer's response.",
    },
    [ErrorCodeApi.BID_EDIT_REQUEST_NOT_PENDING]: {
        http_code: 400,
        old_code: 'BID_EDIT_REQUEST_NOT_PENDING',
        detail: 'You can only accept or decline a pending status bid edit request.',
    },
    [ErrorCodeApi.BIDDER_HAS_PENDING_PROJECT_AWARD]: {
        http_code: 400,
        old_code: 'MUST_RESPOND_TO_EXISTING_PROJECT_AWARD',
        detail: 'You must reply to your awarded projects to be able to bid on this project.',
    },
    [ErrorCodeApi.BID_LIMIT_EXCEEDED]: {
        http_code: 400,
        old_code: 'BID_LIMIT_EXCEEDED',
        detail: 'You have used all of your bids.',
    },
    [ErrorCodeApi.PROJECT_INACCESSIBLE]: {
        http_code: 403,
        old_code: 'RESTRICTED_FROM_BIDDING',
        detail: 'You do not have access to this project.',
    },
    [ErrorCodeApi.PROJECT_REJECTED]: {
        http_code: 400,
        old_code: 'INVALID_PROJECT',
        detail: 'The specified project has been rejected.',
    },
    [ErrorCodeApi.FREELANCER_COLLABORATOR_OF_PROJECT]: {
        http_code: 403,
        old_code: 'RESTRICTED_FROM_BIDDING',
        detail: 'You can not bid on a project that you are a collaborator of.',
    },
    [ErrorCodeApi.FREELANCER_NEGATIVE_BALANCE]: {
        http_code: 403,
        old_code: 'RESTRICTED_FROM_BIDDING',
        detail: 'Your freelancer account has been temporarily suspended, please deposit funds to clear your negative balance.',
    },
    [ErrorCodeApi.FREELANCER_NOT_ENOUGH_REVIEWS]: {
        http_code: 400,
        old_code: 'RESTRICTED_FROM_BIDDING_ON_FEATURED',
        detail: 'You must have at least 5 reviews to place a bid on this project.',
    },
    [ErrorCodeApi.PROJECT_ALREADY_ACCEPTED]: {
        http_code: 400,
        old_code: 'INVALID_PROJECT',
        detail: 'This project has already been accepted.',
    },
    [ErrorCodeApi.PROJECT_CLOSED]: {
        http_code: 400,
        old_code: 'PROJECT_CLOSED',
        detail: 'This project is already closed. You cannot award it to a freelancer.',
    },
    [ErrorCodeApi.WEBHOOK_DUPLICATE]: {
        http_code: 409,
        old_code: 'WEBHOOK_DUPLICATE',
        detail: 'There is an existing webhook already associated with the application. Deactivate the webhook or create a new application.',
    },
    [ErrorCodeApi.PROJECT_NOT_ACTIVE]: {
        http_code: 400,
        old_code: 'PROJECT_NOT_ACTIVE',
        detail: 'This project is currently not in an active state. You may not place, update, or retract your bid on this project.',
    },
    [ErrorCodeApi.IDENTITY_VERIFICATION_REQUIRED]: {
        http_code: 400,
        old_code: 'MILESTONE_RELEASE_RESTRICTED',
        detail: "Identity verification required for account security reasons. You can continue to work and receive payments, but you won't be able to transfer or withdraw funds. To verify your identity, visit the Verification Center.",
    },
    [ErrorCodeApi.WEEKLY_LIMIT_LESS_THAN_CURRENT_TRACKED_HOURS]: {
        http_code: 400,
        old_code: 'WEEKLY_LIMIT_LESS_THAN_CURRENT_TRACKED_HOURS',
        detail: 'Weekly limit must not be less than the current number of hrs tracked.',
    },
    [ErrorCodeApi.INVOICE_PAYMENT_REQUIRED]: {
        http_code: 402,
        old_code: 'INVOICE_PAYMENT_REQUIRED',
        detail: 'All unpaid failed invoices without milestones must be paid before autobilling can be enabled.',
    },
    [ErrorCodeApi.PROJECT_LANGUAGE_CRITERIA_NOT_MET]: {
        http_code: 400,
        old_code: 'PROJECT_LANGUAGE_CRITERIA_NOT_MET',
        detail: 'This project is in a different language. To bid on this project you must update your language settings by selecting which languages you wish to browse projects in.',
    },
    [ErrorCodeApi.EMAIL_ALREADY_VERIFIED]: {
        http_code: 400,
        old_code: 'EMAIL_ALREADY_VERIFIED',
        detail: 'You have already verified your email address for this account.',
    },
    [ErrorCodeApi.USER_ACCOUNT_CLOSED_OR_SUSPENDED]: {
        http_code: 400,
        old_code: 'ACCOUNT_CLOSED_OR_SUSPENDED',
        detail: 'This action cannot be performed with an inactive account. Please contact support for additional details.',
    },
    [ErrorCodeApi.EMAIL_VERIFICATION_CODE_MISMATCH]: {
        http_code: 400,
        old_code: 'EMAIL_VERIFICATION_CODE_MISMATCH',
        detail: 'The verification code you entered does not match the one we sent to your email address.',
    },
    [ErrorCodeApi.VIDEO_VERIFICATION_REQUEST_INVALID]: {
        http_code: 400,
        old_code: 'VIDEO_VERIFICATION_REQUEST_INVALID',
        detail: 'The video verification request is invalid.',
    },
    [ErrorCodeApi.IP_AGREEMENT_NOT_SIGNED]: {
        http_code: 403,
        old_code: 'IP_AGREEMENT_NOT_SIGNED',
        detail: 'You must sign the IP Agreement to work on this project.',
    },
    [ErrorCodeApi.MILESTONE_IS_AUTO_INVOICED]: {
        http_code: 400,
        old_code: 'MILESTONE_REQUEST_REJECTED',
        detail: 'You cannot request release of a milestone associated with an automatic invoice.',
    },
    [ErrorCodeApi.DISCOVER_COLLECTION_ITEM_DUPLICATE]: {
        http_code: 409,
        old_code: 'DISCOVER_COLLECTION_ITEM_DUPLICATE',
        detail: 'This item already exists in the collection. You may not have more than one of the same item in a collection.',
    },
    [ErrorCodeApi.DISCOVER_COLLECTION_NOT_FOUND]: {
        http_code: 404,
        old_code: 'DISCOVER_COLLECTION_NOT_FOUND',
        detail: 'Collection not found',
    },
    [ErrorCodeApi.DISCOVER_COLLECTION_DUPLICATE]: {
        http_code: 409,
        old_code: 'DISCOVER_COLLECTION_DUPLICATE',
        detail: 'You already have a collection with this name. You may not have more than one collection with the same name.',
    },
    [ErrorCodeApi.DISCOVER_COLLECTION_USER_NOT_FOUND]: {
        http_code: 404,
        old_code: 'DISCOVER_COLLECTION_USER_NOT_FOUND',
        detail: 'This user account does not exist.',
    },
    [ErrorCodeApi.DISCOVER_COLLECTION_ITEM_NOT_FOUND]: {
        http_code: 404,
        old_code: 'DISCOVER_COLLECTION_ITEM_NOT_FOUND',
        detail: 'Collection item not found',
    },
    [ErrorCodeApi.DISCOVER_COLLECTION_TYPE_INVALID]: {
        http_code: 400,
        old_code: 'DISCOVER_COLLECTION_TYPE_INVALID',
        detail: 'The requested collection type is not valid',
    },
    [ErrorCodeApi.EMAIL_ALREADY_SUBSCRIBED]: {
        http_code: 400,
        old_code: 'EMAIL_ALREADY_SUBSCRIBED',
        detail: 'The email address has already been subscribed.',
    },
    [ErrorCodeApi.BID_HIGHLIGHT_LIMIT_EXCEEDED]: {
        http_code: 409,
        old_code: 'PROJECT_MAX_HIGHLIGHTS',
        detail: 'Only 5 highlight bids allowed for each project.',
    },
    [ErrorCodeApi.EMAIL_ALREADY_IN_USE]: {
        http_code: 409,
        old_code: 'EMAIL_TAKEN',
        detail: 'This email already exists, please choose another',
    },
    [ErrorCodeApi.USER_NOT_FOUND]: {
        http_code: 404,
        old_code: 'USER_NOT_FOUND',
        detail: 'The user does not exist.',
    },
    [ErrorCodeApi.USERNAME_ALREADY_IN_USE]: {
        http_code: 409,
        old_code: 'USERNAME_TAKEN',
        detail: 'This username is already registered. Please choose another one.',
    },
    [ErrorCodeApi.EMAIL_BLOCKED]: {
        http_code: 400,
        old_code: 'EMAIL_BLOCKED',
        detail: 'Please use a valid email address.',
    },
    [ErrorCodeApi.USERNAME_RESERVED]: {
        http_code: 400,
        old_code: 'RESERVED_USERNAME',
        detail: 'Username is reserved. Please choose a different username.',
    },
    [ErrorCodeApi.EMAIL_INVALID]: {
        http_code: 400,
        old_code: 'INVALID_EMAIL',
        detail: 'Please use a valid email address',
    },
    [ErrorCodeApi.USERNAME_INVALID]: {
        http_code: 400,
        old_code: 'INVALID_USERNAME',
        detail: 'Invalid username. Must be letters and numbers with length from 3 to 16',
    },
    [ErrorCodeApi.PASSWORD_INVALID]: {
        http_code: 400,
        old_code: 'INVALID_PASSWORD',
        detail: 'Invalid password. Must be at least 6 characters',
    },
    [ErrorCodeApi.FACEBOOK_ACCOUNT_ALREADY_IN_USE]: {
        http_code: 409,
        old_code: 'FACEBOOK_LINKING_FAILED',
        detail: 'Your Facebook account is already linked to another Freelancer account.',
    },
    [ErrorCodeApi.USER_ALREADY_FACEBOOK_LINKED]: {
        http_code: 409,
        old_code: 'FACEBOOK_LINKING_FAILED',
        detail: 'Your Freelancer account is already linked to Facebook.',
    },
    [ErrorCodeApi.FACEBOOK_ACCOUNT_NOT_CONNECTED]: {
        http_code: 400,
        old_code: 'FACEBOOK_ACCOUNT_NOT_CONNECTED',
        detail: 'There is no Facebook account connected to your Freelancer account.',
    },
    [ErrorCodeApi.FACEBOOK_UNLINK_ERROR]: {
        http_code: 500,
        old_code: 'FACEBOOK_UNLINK_ERROR',
        detail: 'Unable to unlink Facebook account from your Freelancer account.',
    },
    [ErrorCodeApi.EMAIL_DOMAIN_SIGNUP_TOO_MANY_REQUEST]: {
        http_code: 429,
        old_code: 'TOO_MANY_REQUESTS',
        detail: "Rate limit exceeded. Try again in a few moments. If you think that you've reached this page in error, please contact Support.",
    },
    [ErrorCodeApi.ARROW_LOGIN_FLN_ACCOUNT_NOT_FOUND]: {
        http_code: 404,
        old_code: 'EXTERNAL_AW_LINK_EXISTING_AW',
        detail: 'A Freelancer account under the same email address does not exist.',
    },
    [ErrorCodeApi.ARROW_SIGNUP_FLN_ACCOUNT_EXISTS]: {
        http_code: 409,
        old_code: 'EXTERNAL_AW_LINK_EXISTING_FLN',
        detail: 'A Freelancer account under the same email address already exists.',
    },
    [ErrorCodeApi.ARROW_LOGIN_FLN_ACCOUNT_NOT_LINKED]: {
        http_code: 401,
        old_code: 'EXTERNAL_AW_LINK_EXISTING_BOTH',
        detail: "The Freelancer account isn't linked to your Arrow account.",
    },
    [ErrorCodeApi.ARROW_ACCOUNT_LOCKED]: {
        http_code: 409,
        old_code: 'EXTERNAL_AW_USER_LOCKED',
        detail: 'You have attempted to log in too many times, and your account has been locked.',
    },
    [ErrorCodeApi.ARROW_SERVICE_UNAVAILABLE]: {
        http_code: 503,
        old_code: 'EXTERNAL_AW_UNAVAILABLE',
        detail: 'An unknown error accessing Arrow.com services.',
    },
    [ErrorCodeApi.TIME_TRACKING_SESSION_NOT_FOUND]: {
        http_code: 404,
        old_code: 'TIME_TRACKING_SESSION_NOT_FOUND',
        detail: 'Time tracking session does not exist.',
    },
    [ErrorCodeApi.TIME_TRACKING_SESSION_FINALISED]: {
        http_code: 400,
        old_code: 'TIME_TRACKING_SESSION_FINALISED',
        detail: 'Finalised time tracking sessions cannot be deleted.',
    },
    [ErrorCodeApi.TIME_TRACKING_SESSION_DELETED]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'Time tracking session is already deleted.',
    },
    [ErrorCodeApi.TIME_TRACKING_STOPPED]: {
        http_code: 400,
        old_code: 'TIME_TRACKING_STOPPED',
        detail: 'Time tracking has been stopped for this project. You will not be able to track hours until it is started again.',
    },
    [ErrorCodeApi.MANUAL_TIME_TRACKING_NOT_ALLOWED]: {
        http_code: 400,
        old_code: 'MANUAL_TIME_TRACKING_NOT_ALLOWED',
        detail: 'Manual time tracking is not allowed on this project. You will not be able to track hours manually.',
    },
    [ErrorCodeApi.TIME_TRACKING_CANNOT_EXCEED_WEEKLY_LIMIT]: {
        http_code: 400,
        old_code: 'TIME_TRACKING_CANNOT_EXCEED_WEEKLY_LIMIT',
        detail: 'You cannot track manual hours exceeding your weekly limit.',
    },
    [ErrorCodeApi.TIME_TRACKING_SESSION_ALREADY_STARTED]: {
        http_code: 400,
        old_code: 'TIME_TRACKING_SESSION_ALREADY_STARTED',
        detail: 'You already have an active time tracking session started.',
    },
    [ErrorCodeApi.TIME_TRACKING_SESSION_ALREADY_STOPPED]: {
        http_code: 400,
        old_code: 'TIME_TRACKING_SESSION_ALREADY_STOPPED',
        detail: 'You cannot stop time tracking on a stopped session.',
    },
    [ErrorCodeApi.HOURLY_CONTRACT_NOT_FOUND]: {
        http_code: 400,
        old_code: 'HOURLY_CONTRACT_NOT_FOUND',
        detail: 'This project does not have an associated hourly contract. You cannot track hours on a non-hourly project.',
    },
    [ErrorCodeApi.TIME_TRACKING_OUTSIDE_BILLING_CYCLE]: {
        http_code: 400,
        old_code: 'TIME_TRACKING_OUTSIDE_BILLING_CYCLE',
        detail: 'You cannot track hours before or after the current billing cycle.',
    },
    [ErrorCodeApi.PROJECT_INVITATION_BIDDER_ALREADY_INVITED]: {
        http_code: 400,
        old_code: 'FREELANCER_ALREADY_INVITED',
        detail: 'You have already invited this freelancer to this project.',
    },
    [ErrorCodeApi.CONTEST_INVITATION_ALREADY_SENT]: {
        http_code: 400,
        old_code: 'FREELANCER_ALREADY_INVITED',
        detail: 'You have already invited this freelancer to this contest.',
    },
    [ErrorCodeApi.PROJECT_INVITE_NOT_SENT_TO_FREELANCER]: {
        http_code: 400,
        old_code: 'BIDDER_NOT_INVITED',
        detail: 'There was a problem inviting the freelancer to this project.',
    },
    [ErrorCodeApi.CONTEST_INVITE_NOT_SENT_TO_FREELANCER]: {
        http_code: 400,
        old_code: 'BIDDER_NOT_INVITED',
        detail: 'There was a problem inviting the freelancer to this contest.',
    },
    [ErrorCodeApi.PROJECT_INVITATION_LIMIT]: {
        http_code: 400,
        old_code: 'INVITATION_LIMIT_REACHED',
        detail: 'You reached the limit of invitations for this project.',
    },
    [ErrorCodeApi.CONTEST_INVITATION_LIMIT]: {
        http_code: 400,
        old_code: 'INVITATION_LIMIT_REACHED',
        detail: 'You reached the limit of invitations for this contest.',
    },
    [ErrorCodeApi.BID_FORM_INCOMPLETE]: {
        http_code: 400,
        old_code: 'BID_FIELDS_MISSING',
        detail: 'Unable to create your bid. Bid amount, period, and milestone percentage are required.',
    },
    [ErrorCodeApi.MILESTONE_REQUEST_DESCRIPTION_TOO_LONG]: {
        http_code: 400,
        old_code: 'MILESTONE_REQUEST_DESCRIPTION_INVALID_LENGTH',
        detail: 'Milestone request description exceeds maximum length of 255.',
    },
    [ErrorCodeApi.MILESTONE_REQUEST_DESCRIPTION_EMPTY]: {
        http_code: 400,
        old_code: 'MILESTONE_REQUEST_DESCRIPTION_INVALID_LENGTH',
        detail: 'Milestone request description cannot be empty.',
    },
    [ErrorCodeApi.MILESTONE_DESCRIPTION_TOO_LONG]: {
        http_code: 400,
        old_code: 'INVALID_MILESTONE_DESCRIPTION',
        detail: 'Milestone description exceeds maximum length of 255.',
    },
    [ErrorCodeApi.MILESTONE_DESCRIPTION_EMPTY]: {
        http_code: 400,
        old_code: 'INVALID_MILESTONE_DESCRIPTION',
        detail: 'Milestone description cannot be empty.',
    },
    [ErrorCodeApi.USER_ACCOUNT_LIMITED]: {
        http_code: 400,
        old_code: 'MILESTONE_RELEASE_RESTRICTED',
        detail: "Your account has been limited for account security reasons. You can continue to work and receive payments, but you won't be able to transfer or withdraw funds.",
    },
    [ErrorCodeApi.USER_ACCOUNT_FULL_RESTRICTION]: {
        http_code: 400,
        old_code: 'MILESTONE_RELEASE_RESTRICTED',
        detail: "A restriction on your account has been assigned as a penalty. You can continue your project but you won't be able to transfer or release funds.",
    },
    [ErrorCodeApi.PROJECT_UNPAID]: {
        http_code: 400,
        old_code: 'REVIEW_PROJECT_UNPAID',
        detail: 'You can only review a user for fully paid projects.',
    },
    [ErrorCodeApi.EQUIPMENT_NOT_FOUND]: {
        http_code: 404,
        old_code: 'NOT_FOUND',
        detail: 'Equipment ID specified does not exist.',
    },
    [ErrorCodeApi.DATE_INVALID]: {
        http_code: 400,
        old_code: 'INVALID_REQUEST',
        detail: 'Date specified is invalid.',
    },
    [ErrorCodeApi.PROJECT_USER_RESTRICTED]: {
        http_code: 403,
        old_code: 'PROJECT_USER_RESTRICTED',
        detail: 'You are currently restricted from posting projects.',
    },
    [ErrorCodeApi.USER_ALREADY_REVIEWED]: {
        http_code: 400,
        old_code: 'REVIEW_ALREADY_RATED_USER',
        detail: 'You already rated this user.',
    },
    [ErrorCodeApi.BID_ALREADY_SEALED]: {
        http_code: 409,
        old_code: 'BID_ALREADY_SEALED',
        detail: 'Bid already has sealed upgrade.',
    },
    [ErrorCodeApi.BID_NOT_AWARDED]: {
        http_code: 400,
        old_code: 'BID_IS_NOT_AWARDED',
        detail: 'Bid has not been awarded by the employer.',
    },
    [ErrorCodeApi.SPONSORED_BID_EXISTS]: {
        http_code: 409,
        old_code: 'SPONSORED_BID_EXISTS',
        detail: 'Sponsored bid already exists for this project.',
    },
    [ErrorCodeApi.AUTH_USER_MISSING]: {
        http_code: 401,
        old_code: 'MISSING_USER',
        detail: 'Incorrect username or password provided.',
    },
    [ErrorCodeApi.AUTH_ACCOUNT_SUSPENDED]: {
        http_code: 401,
        old_code: 'ACCOUNT_CLOSED_OR_SUSPENDED',
        detail: 'This account has been suspended. Please contact support for more assistance.',
    },
    [ErrorCodeApi.AUTH_ACCOUNT_CLOSED]: {
        http_code: 401,
        old_code: 'ACCOUNT_CLOSED_OR_SUSPENDED',
        detail: 'This account has been closed. Please contact support for more assistance.',
    },
    [ErrorCodeApi.AUTH_CAPTCHA_REQUIRED]: {
        http_code: 403,
        old_code: 'CAPTCHA_REQUIRED',
        detail: 'For security reasons, please complete the CAPTCHA to log in',
    },
    [ErrorCodeApi.AUTH_FACEBOOK_EMAIL_EXISTS]: {
        http_code: 401,
        old_code: 'FACEBOOK_EMAIL_TAKEN',
        detail: 'Your Facebook email matches an account on Freelancer.',
    },
    [ErrorCodeApi.AUTH_FACEBOOK_EMAIL_MISMATCH]: {
        http_code: 401,
        old_code: 'FACEBOOK_LINKING_FAILED',
        detail: 'Your Facebook email does not match the current Freelancer user.',
    },
    [ErrorCodeApi.AUTH_FACEBOOK_LINK_FAILED]: {
        http_code: 500,
        old_code: 'FACEBOOK_LINKING_FAILED',
        detail: 'Failed to link Facebook to your Freelancer account.',
    },
    [ErrorCodeApi.AUTH_FORCE_RESET_PASSWORD]: {
        http_code: 401,
        old_code: 'AUTH_FORCE_RESET_PASSWORD',
        detail: 'You must reset your password.',
    },
    [ErrorCodeApi.AUTH_DEVICE_TOKEN_INVALID]: {
        http_code: 401,
        old_code: 'AUTH_DEVICE_TOKEN_INVALID',
        detail: 'There was a problem logging into your acount. Please try logging in again or contact support.',
    },
    [ErrorCodeApi.AUTH_PRELOGIN_TOKEN_INVALID]: {
        http_code: 401,
        old_code: 'AUTH_PRELOGIN_TOKEN_INVALID',
        detail: 'There was a problem logging into your acount. Please try logging in again or contact support.',
    },
    [ErrorCodeApi.AUTH_PRELOGIN_TOKEN_EXPIRED]: {
        http_code: 401,
        old_code: 'AUTH_PRELOGIN_TOKEN_EXPIRED',
        detail: 'Your login attempt has expired. Please try logging in again.',
    },
    [ErrorCodeApi.AUTH_TOTP_INVALID]: {
        http_code: 401,
        old_code: 'AUTH_TOTP_INVALID',
        detail: 'The one-time password entered is incorrect.',
    },
    [ErrorCodeApi.AUTH_TOKEN_MISMATCH]: {
        http_code: 401,
        old_code: 'AUTH_TOKEN_MISMATCH',
        detail: 'There was a problem logging into your acount. Please try logging in again or contact support.',
    },
    [ErrorCodeApi.AUTH_2FA_BLOCKED]: {
        http_code: 401,
        old_code: 'AUTH_2FA_BLOCKED',
        detail: 'We have detected your login from an unknown device. Please check your email to continue.',
    },
    [ErrorCodeApi.SIGNUP_CAPTCHA_REQUIRED]: {
        http_code: 403,
        old_code: 'CAPTCHA_REQUIRED',
        detail: 'For security reasons, CAPTCHA is required to make this request.',
    },
    [ErrorCodeApi.SIGNUP_CAPTCHA_INVALID]: {
        http_code: 403,
        old_code: 'INVALID_CAPTCHA',
        detail: 'The captcha repsonse is invalid. Please try again.',
    },
    [ErrorCodeApi.FACEBOOK_EMAIL_NOT_FOUND]: {
        http_code: 404,
        old_code: 'FACEBOOK_EMAIL_NOT_FOUND',
        detail: 'Failed to get email from Facebook.',
    },
    [ErrorCodeApi.USERNAME_REQUIRED]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'Missing required parameter: username.',
    },
    [ErrorCodeApi.PASSWORD_REQUIRED]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'Missing required parameter: password.',
    },
    [ErrorCodeApi.AUTH_OAUTH_FAILED]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'There was a problem logging into your acount. Please try logging in again or contact support.',
    },
    [ErrorCodeApi.AUTH_APPLE_TOKEN_INVALID]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'There was a problem logging into your acount. Please try logging in again or contact support.',
    },
    [ErrorCodeApi.AUTH_APPLE_EMAIL_EXISTS]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'Your Apple email matches an existing account on Freelancer.',
    },
    [ErrorCodeApi.AUTH_APPLE_EMAIL_MISMATCH]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'Your Apple email does not match the current Freelancer user.',
    },
    [ErrorCodeApi.AUTH_APPLE_LINK_FAILED]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'Failed to link Apple account to your Freelancer account.',
    },
    [ErrorCodeApi.AUTH_OAUTH_LINK_CONFLICT]: {
        http_code: 409,
        old_code: 'CONFLICT',
        detail: 'This account is already linked to another OAuth service.',
    },
    [ErrorCodeApi.AUTH_APPLE_EMAIL_IS_NULL]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: "Failed to get the email linked to your apple account. Please revoke app's access to Apple ID in settings and try again.",
    },
    [ErrorCodeApi.PASSWORD_INCORRECT]: {
        http_code: 403,
        old_code: 'UNAUTHORIZED',
        detail: 'Incorrect password provided.',
    },
    [ErrorCodeApi.AUTH_GOOGLE_LINK_FAILED]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'Failed to link Google account to your Freelancer account.',
    },
    [ErrorCodeApi.USER_RECOMMEND_OVER_LIMIT]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'You have exceeded your limit for recommending users.',
    },
    [ErrorCodeApi.USER_RECOMMEND_ALREADY_RECOMMENDED]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'You have already recommended this user.',
    },
    [ErrorCodeApi.USER_RECOMMEND_NO_SELF_RECOMMEND]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'You cannot recommend your own user account.',
    },
    [ErrorCodeApi.USER_FOLLOW_LIMIT_REACHED]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'You have exceeded your limit for following users.',
    },
    [ErrorCodeApi.USER_FOLLOW_NO_SELF_FOLLOW]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'You cannot follow your own user account.',
    },
    [ErrorCodeApi.USER_FOLLOW_USER_DOES_NOT_ALLOW_FOLLOWING]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'This user does not allow users to follow them.',
    },
    [ErrorCodeApi.USER_FOLLOW_ALREADY_FOLLOWING]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'You are already following this user.',
    },
    [ErrorCodeApi.MILESTONE_INVOICE_AMOUNT_MISMATCH]: {
        http_code: 400,
        old_code: 'MILESTONE_INVOICE_AMOUNT_MISMATCH',
        detail: 'The milestone draft amount should be the same as the invoice amount when an  invoice id is given.',
    },
    [ErrorCodeApi.INVALID_INVOICE_FOR_PROJECT]: {
        http_code: 400,
        old_code: 'INVALID_INVOICE_FOR_PROJECT',
        detail: 'This invoice is not for the specified project.',
    },
    [ErrorCodeApi.INVOICE_NOT_UNPAID]: {
        http_code: 400,
        old_code: 'INVOICE_NOT_UNPAID',
        detail: 'The invoice status is invalid.',
    },
    [ErrorCodeApi.INVOICE_HAS_LINKED_MILESTONE]: {
        http_code: 400,
        old_code: 'INVOICE_HAS_LINKED_MILESTONE',
        detail: 'There is already a milestone created for the given invoice.',
    },
    [ErrorCodeApi.INVOICE_NOT_FOUND]: {
        http_code: 404,
        old_code: 'NOT_FOUND',
        detail: 'Invoice not found.',
    },
    [ErrorCodeApi.APPLICATION_NAME_NOT_UNIQUE]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'An OAuth application with that name already exists.',
    },
    [ErrorCodeApi.REVIEW_PERIOD_EXPIRED]: {
        http_code: 405,
        old_code: 'REVIEW_PERIOD_EXPIRED',
        detail: 'The period to review this user has already expired.',
    },
    [ErrorCodeApi.HIREME_HOURLY_RATE_BELOW_MINIMUM]: {
        http_code: 405,
        old_code: 'BID_AMOUNT_INVALID',
        detail: "The project's hourly rate is below the hourly minimum wage of the freelancer.",
    },
    [ErrorCodeApi.PAYMENT_ACCOUNT_INFO_INVALID]: {
        http_code: 400,
        old_code: 'UNKNOWN_ERROR',
        detail: 'Incorrect or invalid account information.',
    },
    [ErrorCodeApi.PAYMENT_ACCOUNT_ID_INVALID]: {
        http_code: 400,
        old_code: 'UNKNOWN_ERROR',
        detail: 'Incorrect or invalid card information.',
    },
    [ErrorCodeApi.PAYMENT_CARD_EXPIRY_INVALID]: {
        http_code: 400,
        old_code: 'UNKNOWN_ERROR',
        detail: 'Card expired or incorrect expiry date.',
    },
    [ErrorCodeApi.PAYMENT_CARD_CVC_DECLINED]: {
        http_code: 400,
        old_code: 'UNKNOWN_ERROR',
        detail: 'CVV/CVC declined.',
    },
    [ErrorCodeApi.PAYMENT_ACCOUNT_PIN_ERROR]: {
        http_code: 400,
        old_code: 'UNKNOWN_ERROR',
        detail: 'Invalid PIN or tries exceeded.',
    },
    [ErrorCodeApi.PAYMENT_ACCOUNT_SCA_FAILED]: {
        http_code: 400,
        old_code: 'UNKNOWN_ERROR',
        detail: 'Strong customer authentication failed.',
    },
    [ErrorCodeApi.PAYMENT_AMOUNT_RESTRICTED]: {
        http_code: 400,
        old_code: 'UNKNOWN_ERROR',
        detail: 'Low balance or amount/frequency limitation error.',
    },
    [ErrorCodeApi.PAYMENT_AGREEMENT_CANCELED]: {
        http_code: 400,
        old_code: 'UNKNOWN_ERROR',
        detail: 'Billing agreement canceled.',
    },
    [ErrorCodeApi.PAYMENT_ACCOUNT_RESTRICTED]: {
        http_code: 400,
        old_code: 'UNKNOWN_ERROR',
        detail: 'Account/Card does not support the transaction.',
    },
    [ErrorCodeApi.PAYMENT_TRANSACTION_DECLINED]: {
        http_code: 400,
        old_code: 'UNKNOWN_ERROR',
        detail: 'Payment transaction declined.',
    },
    [ErrorCodeApi.PAYMENT_GATEWAY_UNAVAILABLE]: {
        http_code: 400,
        old_code: 'UNKNOWN_ERROR',
        detail: 'Payment gateway/bank temporarily unavailable.',
    },
    [ErrorCodeApi.PAYMENT_GATEWAY_ERROR]: {
        http_code: 400,
        old_code: 'UNKNOWN_ERROR',
        detail: 'Payment gateway/bank error.',
    },
    [ErrorCodeApi.PAYMENT_AGREEMENT_NOT_SUPPORTED]: {
        http_code: 400,
        old_code: 'UNKNOWN_ERROR',
        detail: 'Billing agreement not supported.',
    },
    [ErrorCodeApi.PAYMENT_TEAM_BILLING_SPEND_LIMIT_REACHED]: {
        http_code: 400,
        old_code: 'UNKNOWN_ERROR',
        detail: 'Spend limit reached.',
    },
    [ErrorCodeApi.PAYMENT_TEAM_BILLING_CART_APPROVAL_REQUIRED]: {
        http_code: 403,
        old_code: 'UNKNOWN_ERROR',
        detail: 'Deposit for the cart requires approval.',
    },
    [ErrorCodeApi.GROUP_NOT_FOUND]: {
        http_code: 404,
        old_code: 'NOT_FOUND',
        detail: 'Group not found.',
    },
    [ErrorCodeApi.SEO_URL_EXISTS]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'This SEO url already exists.',
    },
    [ErrorCodeApi.SEO_URL_INVALID]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'Seo url has invalid characters.',
    },
    [ErrorCodeApi.GROUP_MEMBER_NOT_FOUND]: {
        http_code: 404,
        old_code: 'NOT_FOUND',
        detail: 'Group Member not found.',
    },
    [ErrorCodeApi.GROUP_MEMBER_ALREADY_EXISTS]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'This User is already a Group Member.',
    },
    [ErrorCodeApi.GROUP_MEMBER_ALREADY_REMOVED]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'This Group member is already removed from the Group.',
    },
    [ErrorCodeApi.GROUP_MEMBER_UPDATE_EMPTY_REQUEST]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'You need to specify at least one field to update group member.',
    },
    [ErrorCodeApi.UNLISTED_PROJECT_BIDDER_NOT_INVITED]: {
        http_code: 403,
        old_code: 'NOT_INVITED_NOT_PREFERRED',
        detail: 'You must be invited by a Recruiter to be able to place a bid on this project.',
    },
    [ErrorCodeApi.UNLISTED_PROJECT_BIDDER_NOT_PREFERRED]: {
        http_code: 403,
        old_code: 'UNLISTED_NOT_PREFERRED',
        detail: 'You must be a Preferred Freelancer to be able to place a bid on this project.',
    },
    [ErrorCodeApi.CANNOT_SHARE_PROJECT_TO_BIDDER]: {
        http_code: 409,
        old_code: 'FAILED_TO_ADD_EXISTING_USER',
        detail: 'You cannot invite a bidder as project collaborator.',
    },
    [ErrorCodeApi.CANNOT_SHARE_PROJECT_WRONG_ENTERPRISE]: {
        http_code: 409,
        old_code: 'FAILED_TO_ADD_EXISTING_USER',
        detail: 'You cannot invite a user that does not belong to your enterprise as project collaborator.',
    },
    [ErrorCodeApi.CANNOT_SHARE_PROJECT_TO_COLLABORATOR]: {
        http_code: 409,
        old_code: 'FAILED_TO_ADD_EXISTING_USER',
        detail: 'You cannot invite an existing collaborator as a new collaborator.',
    },
    [ErrorCodeApi.PROJECT_NOT_FOUND]: {
        http_code: 404,
        old_code: 'NOT_FOUND',
        detail: 'The project does not exist.',
    },
    [ErrorCodeApi.NPS_COMMENT_TOO_LONG]: {
        http_code: 400,
        old_code: 'NPS_COMMENT_TOO_LONG',
        detail: 'NPS comment has exceeded maximum length of 1000.',
    },
    [ErrorCodeApi.NPS_SOURCE_TYPE_INVALID]: {
        http_code: 400,
        old_code: 'NPS_SOURCE_TYPE_INVALID',
        detail: 'NPS source type is invalid.',
    },
    [ErrorCodeApi.NPS_TYPE_INVALID]: {
        http_code: 400,
        old_code: 'NPS_TYPE_INVALID',
        detail: 'NPS type is invalid.',
    },
    [ErrorCodeApi.PROJECT_END_BIDDING_FAILED]: {
        http_code: 400,
        old_code: 'PROJECT_END_BIDDING_FAILED',
        detail: 'Failed to end the bidding.',
    },
    [ErrorCodeApi.PROJECT_NOT_LOCATION_SHARING]: {
        http_code: 400,
        old_code: 'INVALID_REQUEST',
        detail: 'You must be sharing your location to the employer to be able to update your location sharing status.',
    },
    [ErrorCodeApi.PROJECT_INVALID_LOCATION_SHARING_STATUS]: {
        http_code: 400,
        old_code: 'INVALID_REQUEST',
        detail: 'The location sharing status you specified is invalid.',
    },
    [ErrorCodeApi.PROJECT_HAS_PENDING_AWARD]: {
        http_code: 403,
        old_code: 'PROJECT_HAS_PENDING_AWARD',
        detail: 'Project has a pending award.',
    },
    [ErrorCodeApi.PROJECT_HAS_PENDING_MILESTONE]: {
        http_code: 403,
        old_code: 'PROJECT_HAS_PENDING_MILESTONE',
        detail: 'Project has a pending milestone.',
    },
    [ErrorCodeApi.PROJECT_NOT_DELETABLE]: {
        http_code: 403,
        old_code: 'PROJECT_NOT_DELETABLE',
        detail: 'A project must be in open, frozen or closed state to be deleted.',
    },
    [ErrorCodeApi.SKILLS_REQUIREMENT_NOT_MET]: {
        http_code: 403,
        old_code: 'SKILLS_REQUIREMENT_NOT_MET',
        detail: 'You must have the required skills to bid on this project.',
    },
    [ErrorCodeApi.BIDDER_CUSTOM_FIELDS_NOT_MET]: {
        http_code: 403,
        old_code: 'PERMISSION_DENIED',
        detail: 'You must have the required custom fields to bid on this project.',
    },
    [ErrorCodeApi.MILESTONE_AMOUNT_INVALID]: {
        http_code: 400,
        old_code: 'INVALID_MILESTONE_AMOUNT',
        detail: 'Milestone amount must be greater than zero.',
    },
    [ErrorCodeApi.FEED_POST_CONTENT_TOO_LONG]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'Post content is too long.',
    },
    [ErrorCodeApi.FEED_POST_ATTACHMENTS_TOO_MANY]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'Maximum number of post attachments exceeded.',
    },
    [ErrorCodeApi.FEED_POST_CONTEXT_REQUIRED]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'You need to specify feed_context_type and feed_context_id.',
    },
    [ErrorCodeApi.FEED_POST_CONTENT_REQUIRED]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'Either content or attachments required.',
    },
    [ErrorCodeApi.FEED_CONTEXT_REQUIRED]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'Missing either context or ids.',
    },
    [ErrorCodeApi.FEED_META_ACTION_REQUIRED]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'Missing action parameter.',
    },
    [ErrorCodeApi.FEED_META_ACTION_INVALID]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'Invalid action on feed meta.',
    },
    [ErrorCodeApi.FEED_META_CONTEXT_INVALID]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'Context type and id must be specified together.',
    },
    [ErrorCodeApi.FEED_META_CONTEXT_TYPE_INVALID]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'Unknown context type on feed meta.',
    },
    [ErrorCodeApi.FEED_META_FILTER_REQUIRED]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'Filter is required when getting feed meta.',
    },
    [ErrorCodeApi.FEED_ITEMS_ORDERING_INVALID]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'Unknown ordering for feed items specified.',
    },
    [ErrorCodeApi.FEED_META_NOT_FOUND]: {
        http_code: 404,
        old_code: 'NOT_FOUND',
        detail: 'Feed meta not found.',
    },
    [ErrorCodeApi.POST_NOT_FOUND]: {
        http_code: 404,
        old_code: 'NOT_FOUND',
        detail: 'Post not found.',
    },
    [ErrorCodeApi.POST_CONTENT_REQUIRED]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'Missing Post message or attachment.',
    },
    [ErrorCodeApi.POST_COMMENT_FEED_NOT_MODIFIABLE]: {
        http_code: 403,
        old_code: 'PERMISSION_DENIED',
        detail: 'Post comment feed can not be modified once set.',
    },
    [ErrorCodeApi.FEED_ITEM_NOT_FOUND]: {
        http_code: 404,
        old_code: 'NOT_FOUND',
        detail: 'Feed item not found.',
    },
    [ErrorCodeApi.ATTACHMENT_FILE_REQUIRED]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'Must provide a file to upload.',
    },
    [ErrorCodeApi.ATTACHMENT_FILE_TOO_LARGE]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'Attachment file is too large.',
    },
    [ErrorCodeApi.ATTACHMENT_FILE_METADATA_REQUIRED]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'Must provide a file metadata.',
    },
    [ErrorCodeApi.ATTACHMENT_FILE_ID_REQUIRED]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'File id is not defined.',
    },
    [ErrorCodeApi.ATTACHMENT_FILE_FILENAME_INVALID]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'Invalid character in filename.',
    },
    [ErrorCodeApi.ATTACHMENT_FILE_FILENAME_TOO_LONG]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'File name is too long.',
    },
    [ErrorCodeApi.ATTACHMENT_FILE_UUID_DUPLICATE]: {
        http_code: 409,
        old_code: 'BAD_REQUEST',
        detail: 'File id must be universally unique.',
    },
    [ErrorCodeApi.ATTACHMENT_FILE_NOT_FOUND]: {
        http_code: 404,
        old_code: 'NOT_FOUND',
        detail: 'Attachment file does not exist.',
    },
    [ErrorCodeApi.ATTACHMENT_FILE_UNSUPPORTED_MIME_TYPE]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'Attachment File mime type is not supported.',
    },
    [ErrorCodeApi.METADATA_FIELD_NOT_FOUND]: {
        http_code: 400,
        old_code: 'METADATA_FIELD_NOT_FOUND',
        detail: 'Failed on fetching the field type for requested metadata field.',
    },
    [ErrorCodeApi.METADATA_FIELD_DISABLED]: {
        http_code: 400,
        old_code: 'METADATA_FIELD_DISABLED',
        detail: 'The requested metadata field is disabled.',
    },
    [ErrorCodeApi.METADATA_FIELD_VALUE_INVALID]: {
        http_code: 400,
        old_code: 'METADATA_FIELD_VALUE_INVALID',
        detail: 'Metadata field value is invalid.',
    },
    [ErrorCodeApi.METADATA_FIELD_VALUE_OBJECT_INVALID]: {
        http_code: 400,
        old_code: 'METADATA_FIELD_VALUE_OBJECT_INVALID',
        detail: 'Metadata field value has invalid parent object.',
    },
    [ErrorCodeApi.METADATA_FIELD_TYPE_INVALID]: {
        http_code: 400,
        old_code: 'METADATA_FIELD_TYPE_INVALID',
        detail: 'Metadata field value is invalid.',
    },
    [ErrorCodeApi.INITIAL_PAYMENT_CANNOT_BE_RELEASED]: {
        http_code: 403,
        old_code: 'PERMISSION_DENIED',
        detail: 'The initial payment cannot be released.',
    },
    [ErrorCodeApi.INITIAL_PAYMENT_CANNOT_BE_CANCELLED]: {
        http_code: 403,
        old_code: 'PERMISSION_DENIED',
        detail: 'The initial payment cannot be cancelled.',
    },
    [ErrorCodeApi.CUSTOM_FIELD_VALIDATION_COLLECTION_TYPE_INVALID]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'The collection type is invalid for custom field validations for the requested operation.',
    },
    [ErrorCodeApi.CUSTOM_FIELD_VALIDATION_VALIDATION_TYPE_INVALID]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'The validation type is invalid for custom field validations for the requested operation.',
    },
    [ErrorCodeApi.BID_SELECTED_SELLER_NOT_FOUND]: {
        http_code: 404,
        old_code: 'NOT_FOUND',
        detail: 'Selected seller does not exist for bid.',
    },
    [ErrorCodeApi.PROJECT_BOOKMARK_LIMIT_REACHED]: {
        http_code: 400,
        old_code: 'PROJECT_BOOKMARK_LIMIT_REACHED',
        detail: 'User has reached their project bookmark limit.',
    },
    [ErrorCodeApi.NOTIFICATION_PREFERENCE_TYPE_INVALID]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'Invalid notification preference type.',
    },
    [ErrorCodeApi.REPUTATION_DECAY_FACTORS_NOT_FOUND]: {
        http_code: 404,
        old_code: 'NOT_FOUND',
        detail: 'Reputation decay factor not found.',
    },
    [ErrorCodeApi.EMAIL_CHANGE_REQUEST_SAME_ADDRESS]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'New email is the same as the current email.',
    },
    [ErrorCodeApi.EMAIL_CHANGE_REQUEST_DUPLICATE]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'There is already a pending change request with the provided email.',
    },
    [ErrorCodeApi.EMAIL_CHANGE_REQUEST_NOT_FOUND]: {
        http_code: 404,
        old_code: 'NOT_FOUND',
        detail: 'Email change request does not exist.',
    },
    [ErrorCodeApi.EMAIL_CHANGE_REQUEST_NOT_ALLOWED]: {
        http_code: 403,
        old_code: 'FORBIDDEN',
        detail: 'Email change not allowed for this user.',
    },
    [ErrorCodeApi.ACCOUNT_REACTIVATION_ONGOING_DELETION]: {
        http_code: 409,
        old_code: 'CONFLICT',
        detail: 'Unable to reactivate account as there already is a deletion request pending for the account.',
    },
    [ErrorCodeApi.ACCOUNT_REACTIVATION_NOT_CLOSED_BY_USER]: {
        http_code: 403,
        old_code: 'FORBIDDEN',
        detail: 'Unable to reactivate account because account closure was initiated by an administrator, rather than user-initiated.',
    },
    [ErrorCodeApi.ACCOUNT_REACTIVATION_ALREADY_ACTIVE]: {
        http_code: 409,
        old_code: 'CONFLICT',
        detail: 'User account is already active.',
    },
    [ErrorCodeApi.ACCOUNT_REACTIVATION_INVALID_TOKEN]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'Invalid account reactivation request token provided.',
    },
    [ErrorCodeApi.SUPPORT_TICKET_NOT_FOUND]: {
        http_code: 404,
        old_code: 'NOT_FOUND',
        detail: 'Support ticket does not exist.',
    },
    [ErrorCodeApi.MEMBERSHIP_TRIAL_INELIGIBLE]: {
        http_code: 400,
        old_code: 'INVALID_REQUEST',
        detail: 'User is no longer eligible for this trial.',
    },
    [ErrorCodeApi.MEMBERSHIP_SUBSCRIPTION_PAYMENT_FAILURE]: {
        http_code: 409,
        old_code: 'PAYMENT_FAILURE',
        detail: 'Subscription payment failure.',
    },
    [ErrorCodeApi.MEMBERSHIP_PACKAGE_DISABLED]: {
        http_code: 403,
        old_code: 'PACKAGE_DISABLED',
        detail: 'Membership package is disabled.',
    },
    [ErrorCodeApi.MEMBERSHIP_PRICE_DISABLED]: {
        http_code: 403,
        old_code: 'PRICE_DISABLED',
        detail: 'Membership price is disabled.',
    },
    [ErrorCodeApi.MEMBERSHIP_TRIAL_NOT_FOUND]: {
        http_code: 404,
        old_code: 'TRIAL_NOT_FOUND',
        detail: 'Membership trial not found.',
    },
    [ErrorCodeApi.MEMBERSHIP_PRICE_NOT_FOUND]: {
        http_code: 404,
        old_code: 'PRICE_NOT_FOUND',
        detail: 'Membership price not found.',
    },
    [ErrorCodeApi.MEMBERSHIP_PACKAGE_NOT_FOUND]: {
        http_code: 404,
        old_code: 'PACKAGE_NOT_FOUND',
        detail: 'Membership package not found.',
    },
    [ErrorCodeApi.MEMBERSHIP_SUBSCRIPTION_NOT_FOUND]: {
        http_code: 404,
        old_code: 'SUBSCRIPTION_NOT_FOUND',
        detail: 'Membership subscription not found.',
    },
    [ErrorCodeApi.MEMBERSHIP_PACKAGE_DURATION_INVALID]: {
        http_code: 400,
        old_code: 'INVALID_PACKAGE_DURATION',
        detail: 'Invalid package duration supplied.',
    },
    [ErrorCodeApi.MEMBERSHIP_SUBSCRIPTION_QUANTITY_INVALID]: {
        http_code: 400,
        old_code: 'INVALID_SUBSCRIPTION_QUANTITY',
        detail: 'Invalid subscription quantity supplied.',
    },
    [ErrorCodeApi.MEMBERSHIP_MAIL_EXCEPTION]: {
        http_code: 400,
        old_code: 'MAIL_EXCEPTION',
        detail: 'Attempted to send mail with invalid parameters.',
    },
    [ErrorCodeApi.MEMBERSHIP_RENEW_PERIOD_EXPIRED]: {
        http_code: 400,
        old_code: 'RENEW_PERIOD_EXPIRED',
        detail: 'Renew period expired.',
    },
    [ErrorCodeApi.MEMBERSHIP_COUPON_REUSE]: {
        http_code: 400,
        old_code: 'COUPON_REUSE',
        detail: 'Coupon already used.',
    },
    [ErrorCodeApi.MEMBERSHIP_COUPON_UNAVAILABLE]: {
        http_code: 400,
        old_code: 'COUPON_UNAVAILABLE',
        detail: 'Coupon is not available.',
    },
    [ErrorCodeApi.MEMBERSHIP_REQUEST_ALREADY_PROCESSED]: {
        http_code: 409,
        old_code: 'REQUEST_ALREADY_PROCESSED',
        detail: 'A previous request is already being processed.',
    },
    [ErrorCodeApi.MEMBERSHIP_PERIOD_NOT_FOUND]: {
        http_code: 404,
        old_code: 'PERIOD_NOT_FOUND',
        detail: 'Period does not exist.',
    },
    [ErrorCodeApi.MEMBERSHIP_RENEWAL_ALREADY_ACTIVE]: {
        http_code: 400,
        old_code: 'RENEWAL_ALREADY_ACTIVE',
        detail: 'Active renewal already exists for this period.',
    },
    [ErrorCodeApi.MEMBERSHIP_RENEWAL_NOT_FOUND]: {
        http_code: 404,
        old_code: 'RENEWAL_NOT_FOUND',
        detail: 'Cannot find a renewal with that id.',
    },
    [ErrorCodeApi.MEMBERSHIP_RENEWAL_ALREADY_INACTIVE]: {
        http_code: 400,
        old_code: 'RENEWAL_ALREADY_INACTIVE',
        detail: 'Cannot cancel renewal as it is already inactive.',
    },
    [ErrorCodeApi.USER_ACCOUNT_CLOSURE_RESTRICTED]: {
        http_code: 403,
        old_code: 'USER_ACCOUNT_CLOSURE_RESTRICTED',
        detail: 'User is restricted from closing account.',
    },
    [ErrorCodeApi.USER_ACCOUNT_CLOSURE_NOT_ALLOWED]: {
        http_code: 403,
        old_code: 'USER_ACCOUNT_CLOSURE_NOT_ALLOWED',
        detail: 'Cannot close account.',
    },
    [ErrorCodeApi.CANNOT_SHARE_PROJECT_TO_OWNER]: {
        http_code: 409,
        old_code: 'COLLABORATOR_CANNOT_BE_OWNER',
        detail: 'Project owner cannot be added as a project collaborator.',
    },
    [ErrorCodeApi.TEXT_ENTITY_BAD_OFFSET]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'The offset of a TextEntity can not be less than 0.',
    },
    [ErrorCodeApi.TEXT_ENTITY_BAD_LENGTH]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'The length of a TextEntity can not be less than 1.',
    },
    [ErrorCodeApi.TEXT_ENTITY_TOO_MANY]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'Maximum number of text entities exceeded.',
    },
    [ErrorCodeApi.TEXT_ENTITY_VALIDATION]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'The given text segments could not be found in the text.',
    },
    [ErrorCodeApi.PHONE_CANNOT_USE_NUMBER]: {
        http_code: 400,
        old_code: 'CANNOT_USE_PHONE_NUMBER',
        detail: 'Cannot use phone number.',
    },
    [ErrorCodeApi.PHONE_COMPLETE_ID_VERIFICATION_REQUIRED]: {
        http_code: 409,
        old_code: 'MUST_COMPLETE_ID_VERIFICATION',
        detail: 'User is required to complete ID verification.',
    },
    [ErrorCodeApi.PHONE_INVALID_NUMBER]: {
        http_code: 400,
        old_code: 'INVALID_PHONE_NUMBER',
        detail: 'Invalid phone number.',
    },
    [ErrorCodeApi.PHONE_INVALID_VERIFICATION]: {
        http_code: 400,
        old_code: 'INVALID_VERIFICATION',
        detail: 'Invalid phone verification request.',
    },
    [ErrorCodeApi.PHONE_INVALID_VERIFICATION_CODE]: {
        http_code: 400,
        old_code: 'INVALID_VERIFICATION_CODE',
        detail: 'Invalid verification code.',
    },
    [ErrorCodeApi.PHONE_NUMBER_ALREADY_USED]: {
        http_code: 409,
        old_code: 'PHONE_NUMBER_ALREADY_USED',
        detail: 'Phone number is already in use.',
    },
    [ErrorCodeApi.PHONE_NUMBER_MISMATCH]: {
        http_code: 409,
        old_code: 'PHONE_NUMBER_MISMATCH',
        detail: 'Phone number does not match the verified number.',
    },
    [ErrorCodeApi.PHONE_MAXIMUM_NUMBER_OF_ATTEMPTS_REACHED]: {
        http_code: 429,
        old_code: 'PHONE_VERIFICATION_MAX_ATTEMPTS',
        detail: 'User has reached the maximum allowable number of daily attempts for phone verification.',
    },
    [ErrorCodeApi.PHONE_SAME_NUMBER]: {
        http_code: 409,
        old_code: 'PHONE_NUMBER_SAME',
        detail: 'New number is the same as the current phone number.',
    },
    [ErrorCodeApi.PHONE_NOT_FOUND]: {
        http_code: 404,
        old_code: 'NOT_FOUND',
        detail: 'The requested security phone does not exist.',
    },
    [ErrorCodeApi.USER_HAS_ALREADY_REACTED]: {
        http_code: 400,
        old_code: 'USER_HAS_ALREADY_REACTED',
        detail: 'You have already reacted on this context.',
    },
    [ErrorCodeApi.USER_HAS_NOT_REACTED]: {
        http_code: 400,
        old_code: 'USER_HAS_NOT_REACTED',
        detail: 'You have not reacted on this context yet.',
    },
    [ErrorCodeApi.ENTRY_REPLACE_FILES_TOO_MANY]: {
        http_code: 400,
        old_code: 'INVALID_REQUEST',
        detail: 'Maximum number of files exceeded.',
    },
    [ErrorCodeApi.ENTRY_REPLACE_FILES_NOT_UPLOADED]: {
        http_code: 404,
        old_code: 'ENTRY_FILE_NOT_FOUND',
        detail: 'Replacement files do not exist in file server.',
    },
    [ErrorCodeApi.SEARCH_SAVED_FILTERS_DUPLICATE]: {
        http_code: 400,
        old_code: 'SEARCH_SAVED_FILTERS_DUPLICATE',
        detail: 'User already has a saved search with the given name.',
    },
    [ErrorCodeApi.SEARCH_SAVED_FILTERS_LIMIT_REACHED]: {
        http_code: 400,
        old_code: 'SEARCH_SAVED_FILTERS_LIMIT_REACHED',
        detail: 'User has reached the maximum allowable saved searches.',
    },
    [ErrorCodeApi.SEARCH_SAVED_FILTERS_NOT_FOUND]: {
        http_code: 404,
        old_code: 'SEARCH_SAVED_FILTERS_NOT_FOUND',
        detail: 'The saved search with the given ID does not exist.',
    },
    [ErrorCodeApi.QUOTATION_CURRENCY_NOT_FOUND]: {
        http_code: 400,
        old_code: 'QUOTATION_CURRENCY_NOT_FOUND',
        detail: 'The provided currency ID does not exist.',
    },
    [ErrorCodeApi.QUOTATION_PROJECT_INACTIVE]: {
        http_code: 400,
        old_code: 'QUOTATION_PROJECT_INACTIVE',
        detail: 'A quotation cannot be attached to an inactive project.',
    },
    [ErrorCodeApi.QUOTATION_PROJECT_NOT_FOUND]: {
        http_code: 400,
        old_code: 'QUOTATION_PROJECT_NOT_FOUND',
        detail: 'The provided project ID does not exist.',
    },
    [ErrorCodeApi.QUOTATION_BID_NOT_FOUND]: {
        http_code: 400,
        old_code: 'QUOTATION_BID_NOT_FOUND',
        detail: 'The provided bid ID does not exist.',
    },
    [ErrorCodeApi.QUOTATION_BID_RETRACTED]: {
        http_code: 400,
        old_code: 'QUOTATION_BID_RETRACTED',
        detail: 'A quotation cannot be attached to a retracted bid.',
    },
    [ErrorCodeApi.QUOTATION_ITEM_ALREADY_DELETED]: {
        http_code: 400,
        old_code: 'QUOTATION_ITEM_ALREADY_DELETED',
        detail: 'The provided quotation item has already been deleted.',
    },
    [ErrorCodeApi.QUOTATION_NOT_FOUND]: {
        http_code: 404,
        old_code: 'QUOTATION_NOT_FOUND',
        detail: 'The provided Quotation ID does not exist.',
    },
    [ErrorCodeApi.QUOTATION_ITEM_NOT_FOUND]: {
        http_code: 404,
        old_code: 'QUOTATION_ITEM_NOT_FOUND',
        detail: 'The provided quotation item ID does not exist.',
    },
    [ErrorCodeApi.QUOTATION_CONTEXT_TYPE_INVALID]: {
        http_code: 400,
        old_code: 'QUOTATION_CONTEXT_TYPE_INVALID',
        detail: 'The quotation has invalid context type.',
    },
    [ErrorCodeApi.HIREME_QUOTATION_INVALID]: {
        http_code: 400,
        old_code: 'HIREME_QUOTATION_INVALID',
        detail: 'A valid quotation ID and quotation version ID must be provided.',
    },
    [ErrorCodeApi.QUOTATION_ITEM_CLOSED]: {
        http_code: 400,
        old_code: 'QUOTATION_ITEM_CLOSED',
        detail: 'Quotation items cannot be updated if they have been marked as `Complete` or `Invalid`.',
    },
    [ErrorCodeApi.QUOTATION_ITEM_MUTABLE]: {
        http_code: 400,
        old_code: 'QUOTATION_ITEM_MUTABLE',
        detail: 'Quotation items created in the current draft are mutable and should be updated via a `PUT` request.',
    },
    [ErrorCodeApi.QUOTATION_NOT_DRAFT]: {
        http_code: 400,
        old_code: 'QUOTATION_NOT_DRAFT',
        detail: 'The quotation is not a draft.',
    },
    [ErrorCodeApi.QUOTATION_ONLY_ONE_HOURLY_ITEM_ALLOWED]: {
        http_code: 400,
        old_code: 'QUOTATION_ONLY_ONE_HOURLY_ITEM_ALLOWED',
        detail: 'A quotation can only have one hourly item.',
    },
    [ErrorCodeApi.QUOTATION_ITEM_INVALID_BILLING_FREQUENCY]: {
        http_code: 400,
        old_code: 'QUOTATION_ITEM_INVALID_BILLING_FREQUENCY',
        detail: 'The billing frequency is invalid for the quotation item.',
    },
    [ErrorCodeApi.QUOTATION_WRONG_DRAFT_VERSION]: {
        http_code: 400,
        old_code: 'QUOTATION_WRONG_DRAFT_VERSION',
        detail: 'Quotation Item Version can only be updated mutably if it was created in the current draft Quotation version.',
    },
    [ErrorCodeApi.QUOTATION_ITEM_IDS_INCONSISTENT]: {
        http_code: 400,
        old_code: 'QUOTATION_ITEM_IDS_INCONSISTENT',
        detail: 'Provided quotation_item and quotation_item_version IDs do not map to the same Quotation item.',
    },
    [ErrorCodeApi.QUOTATION_UPDATE_ACCEPTING_AND_REJECTING]: {
        http_code: 400,
        old_code: 'QUOTATION_UPDATE_ACCEPTING_AND_REJECTING',
        detail: 'A draft quotation cannot be simultaneously accepted and rejected.',
    },
    [ErrorCodeApi.QUOTATION_IS_INVALID]: {
        http_code: 400,
        old_code: 'QUOTATION_IS_INVALID',
        detail: 'The quotation is marked as invalid.',
    },
    [ErrorCodeApi.QUOTATION_VERSION_IS_INVALID]: {
        http_code: 400,
        old_code: 'QUOTATION_VERSION_IS_INVALID',
        detail: 'The quotation version is marked as invalid.',
    },
    [ErrorCodeApi.QUOTATION_VERSION_INCONSISTENT]: {
        http_code: 400,
        old_code: 'QUOTATION_VERSION_INCONSISTENT',
        detail: 'The latest quotation version has a different id than the id given.',
    },
    [ErrorCodeApi.QUOTATION_ID_CONFLICT]: {
        http_code: 400,
        old_code: 'QUOTATION_ID_CONFLICT',
        detail: 'The provided quotation_id and quotation_version_id do not map to the same Quotation object.',
    },
    [ErrorCodeApi.QUOTATION_DRAFT_EXISTS]: {
        http_code: 400,
        old_code: 'QUOTATION_DRAFT_EXISTS',
        detail: 'Cannot create a new quotation revision when any previous versions are in a draft state.',
    },
    [ErrorCodeApi.QUOTATION_FUND_INSUFFICIENT]: {
        http_code: 400,
        old_code: 'QUOTATION_FUND_INSUFFICIENT',
        detail: 'Insufficient remaining quotation fund.',
    },
    [ErrorCodeApi.QUOTATION_ITEM_AMOUNT_TOO_LOW]: {
        http_code: 400,
        old_code: 'QUOTATION_ITEM_AMOUNT_TOO_LOW',
        detail: 'Cannot release the amount with given item as the item amount is too low.',
    },
    [ErrorCodeApi.QUOTATION_NOT_APPROVED]: {
        http_code: 400,
        old_code: 'QUOTATION_NOT_APPROVED',
        detail: 'The required action cannot be done as the provided quotation is not approved.',
    },
    [ErrorCodeApi.QUOTATION_INCORRECT_CONTEXT]: {
        http_code: 400,
        old_code: 'QUOTATION_INCORRECT_CONTEXT',
        detail: 'The required action cannot be done as the provided quotation is attached to an incorrect context.',
    },
    [ErrorCodeApi.QUOTATION_UPFRONT_FUNDING_AMOUNT_TOO_HIGH]: {
        http_code: 400,
        old_code: 'QUOTATION_UPFRONT_FUNDING_AMOUNT_TOO_HIGH',
        detail: 'Cannot update upfront fund to be greater than total quote price.',
    },
    [ErrorCodeApi.QUOTATION_THREAD_NOT_FOUND]: {
        http_code: 400,
        old_code: 'QUOTATION_THREAD_NOT_FOUND',
        detail: 'The provided thread ID does not exist.',
    },
    [ErrorCodeApi.QUOTATION_THREAD_TYPE_INVALID]: {
        http_code: 400,
        old_code: 'QUOTATION_THREAD_TYPE_INVALID',
        detail: 'Cannot create a quotation attached to the given thread type.',
    },
    [ErrorCodeApi.QUOTATION_THREAD_CONTEXT_NOT_ASSIGNABLE]: {
        http_code: 400,
        old_code: 'QUOTATION_THREAD_CONTEXT_NOT_ASSIGNABLE',
        detail: 'A quotation can only be assigned to a thread.',
    },
    [ErrorCodeApi.QUOTATION_THREAD_NOT_EDITABLE]: {
        http_code: 400,
        old_code: 'QUOTATION_THREAD_NOT_EDITABLE',
        detail: 'A quotation attached to a thread cannot be revised once it has been submitted.',
    },
    [ErrorCodeApi.QUOTATION_REJECTED]: {
        http_code: 400,
        old_code: 'QUOTATION_REJECTED',
        detail: 'Cannot update a rejected quotation.',
    },
    [ErrorCodeApi.QUOTATION_CANCELLED]: {
        http_code: 400,
        old_code: 'QUOTATION_CANCELLED',
        detail: 'Cannot update a cancelled quotation.',
    },
    [ErrorCodeApi.QUOTATION_EXPIRED]: {
        http_code: 400,
        old_code: 'QUOTATION_EXPIRED',
        detail: 'An expired quotation cannot be actioned upon.',
    },
    [ErrorCodeApi.QUOTATION_APPROVED]: {
        http_code: 400,
        old_code: 'QUOTATION_APPROVED',
        detail: 'An approved quotation cannot be cancelled.',
    },
    [ErrorCodeApi.QUOTATION_AMOUNT_BELOW_MINIMUM_BUDGET]: {
        http_code: 400,
        old_code: 'QUOTATION_AMOUNT_BELOW_MINIMUM_BUDGET',
        detail: 'A quotation cannot have a total amount less than the minimum budget.',
    },
    [ErrorCodeApi.QUOTATION_LIMIT_REACHED]: {
        http_code: 400,
        old_code: 'QUOTATION_LIMIT_REACHED',
        detail: 'You have reached the limit for pending quotations.',
    },
    [ErrorCodeApi.QUOTATION_EXPIRY_DATE_CANNOT_BE_IN_PAST]: {
        http_code: 400,
        old_code: 'QUOTATION_EXPIRY_DATE_CANNOT_BE_IN_PAST',
        detail: 'Cannot submit quotation with expiry date in the past.',
    },
    [ErrorCodeApi.QUOTATION_CONTEXT_NOT_ASSIGNABLE]: {
        http_code: 400,
        old_code: 'QUOTATION_CONTEXT_NOT_ASSIGNABLE',
        detail: 'The provided context cannot be manually assigned after quotation creation.',
    },
    [ErrorCodeApi.PROJECT_QUOTATION_LIMIT_REACHED]: {
        http_code: 400,
        old_code: 'PROJECT_QUOTATION_LIMIT_REACHED',
        detail: 'You have reached the limit for pending quotations for this project.',
    },
    [ErrorCodeApi.QUOTATION_DURATION_NOT_ASSIGNABLE]: {
        http_code: 400,
        old_code: 'QUOTATION_DURATION_NOT_ASSIGNABLE',
        detail: 'Cannot assign quotation duration.',
    },
    [ErrorCodeApi.QUOTATION_INVALID_STATUS]: {
        http_code: 400,
        old_code: 'QUOTATION_INVALID_STATUS',
        detail: 'Invalid quotation status.',
    },
    [ErrorCodeApi.QUOTATION_PARENT_TEMPLATE_NOT_FOUND]: {
        http_code: 404,
        old_code: 'QUOTATION_PARENT_TEMPLATE_NOT_FOUND',
        detail: 'Parent template quote not found.',
    },
    [ErrorCodeApi.CHILD_QUOTATION_MORE_THAN_ONE_PENDING]: {
        http_code: 403,
        old_code: 'CHILD_QUOTATION_MORE_THAN_ONE_PENDING',
        detail: 'There already exists a pending quote with the same parent_template_version_id.',
    },
    [ErrorCodeApi.QUOTATION_MISUSING_HELPER_FUNCTIONS]: {
        http_code: 400,
        old_code: 'QUOTATION_MISUSING_HELPER_FUNCTIONS',
        detail: 'Helper functions misused.',
    },
    [ErrorCodeApi.QUOTATION_LOGO_CANNOT_BE_UPDATED]: {
        http_code: 400,
        old_code: 'QUOTATION_LOGO_CANNOT_BE_UPDATED',
        detail: 'Quotation status does not allow logo to be updated.',
    },
    [ErrorCodeApi.QUOTATION_LOGO_CREATOR_MISMATCH]: {
        http_code: 403,
        old_code: 'QUOTATION_LOGO_CREATOR_MISMATCH',
        detail: 'Quotation logo creator id does not match the quotation creator id.',
    },
    [ErrorCodeApi.QUOTATION_LOGO_NOT_FOUND]: {
        http_code: 404,
        old_code: 'QUOTATION_LOGO_NOT_FOUND',
        detail: 'The provided quotation logo does not exist.',
    },
    [ErrorCodeApi.PROJECT_TITLE_EDIT_REQUEST_DUPLICATE]: {
        http_code: 409,
        old_code: 'USER_HAS_ALREADY_REQUESTED_FOR_PROJECT_DUPLICATE',
        detail: 'User already has a request for project title change.',
    },
    [ErrorCodeApi.PROJECT_TITLE_EDIT_REQUEST_NOT_PENDING]: {
        http_code: 409,
        old_code: 'PROJECT_TITLE_EDIT_REQUEST_NOT_PENDING',
        detail: 'You can only accept or decline a pending status project title edit request.',
    },
    [ErrorCodeApi.SHARE_PROJECT_LIMIT_REACHED]: {
        http_code: 429,
        old_code: 'SHARE_PROJECT_LIMIT_REACHED',
        detail: 'You have reached the limit in adding collaborators.',
    },
    [ErrorCodeApi.SHARE_PROJECT_DAILY_LIMIT_REACHED]: {
        http_code: 429,
        old_code: 'SHARE_PROJECT_DAILY_LIMIT_REACHED',
        detail: 'You have reached the daily limit in adding collaborators. Please try again in 24 hours.',
    },
    [ErrorCodeApi.CONTRACT_NOT_FOUND]: {
        http_code: 404,
        old_code: 'CONTRACT_NOT_FOUND',
        detail: 'The contract does not exist.',
    },
    [ErrorCodeApi.CONTRACT_ALREADY_SIGNED]: {
        http_code: 400,
        old_code: 'CONTRACT_ALREADY_SIGNED',
        detail: 'The contract has already been signed.',
    },
    [ErrorCodeApi.CONTRACT_VERIFICATION_FAILED]: {
        http_code: 500,
        old_code: 'CONTRACT_VERIFICATION_FAILED',
        detail: "We're sorry, an unexpected error occurred when updating the contract. The draft contract has not been saved.",
    },
    [ErrorCodeApi.CONTRACT_CONTEXT_NOT_FOUND]: {
        http_code: 404,
        old_code: 'CONTRACT_CONTEXT_NOT_FOUND',
        detail: 'The provided contract context does not exist.',
    },
    [ErrorCodeApi.CONTRACT_INVALID_DOWNLOAD]: {
        http_code: 400,
        old_code: 'CONTRACT_INVALID_DOWNLOAD',
        detail: "We're sorry, there are some issues accessing the requested contract.",
    },
    [ErrorCodeApi.CONTRACT_TEMPLATE_NOT_FOUND]: {
        http_code: 404,
        old_code: 'CONTRACT_TEMPLATE_NOT_FOUND',
        detail: 'The provided contract template does not exist.',
    },
    [ErrorCodeApi.CONTRACT_SIGNEE_ROLE_NOT_FOUND]: {
        http_code: 404,
        old_code: 'CONTRACT_SIGNEE_ROLE_NOT_FOUND',
        detail: 'Contract signee role does not exist for the provided user on this contract template.',
    },
    [ErrorCodeApi.POOL_NOT_FOUND]: {
        http_code: 404,
        old_code: 'POOL_NOT_FOUND',
        detail: 'At least one of the given pools cannot be found',
    },
    [ErrorCodeApi.ENTERPRISE_LOGO_FILE_NOT_FOUND]: {
        http_code: 404,
        old_code: 'NOT_FOUND',
        detail: 'Enterprise logo file does not exist.',
    },
    [ErrorCodeApi.ENTERPRISE_AVATAR_FILE_NOT_FOUND]: {
        http_code: 404,
        old_code: 'NOT_FOUND',
        detail: 'Enterprise avatar file does not exist.',
    },
    [ErrorCodeApi.PROJECT_QUESTION_NOT_FOUND]: {
        http_code: 404,
        old_code: 'NOT_FOUND',
        detail: 'Project questions cannot be found.',
    },
    [ErrorCodeApi.AGENT_NOT_FOUND]: {
        http_code: 404,
        old_code: 'NOT_FOUND',
        detail: 'Support agent could not be found.',
    },
    [ErrorCodeApi.AGENT_INVALID_STATE]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'Unsupported action against support agent.',
    },
    [ErrorCodeApi.AGENT_SESSION_INVALID_STATE]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'Unsupported action against support agent session.',
    },
    [ErrorCodeApi.AGENT_SESSION_NOT_FOUND]: {
        http_code: 404,
        old_code: 'NOT_FOUND',
        detail: 'Support agent session could not be found.',
    },
    [ErrorCodeApi.SESSION_SOURCE_INVALID]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'Support session source id, type, or both were invalid.',
    },
    [ErrorCodeApi.SUPPORT_TYPE_NOT_FOUND]: {
        http_code: 404,
        old_code: 'NOT_FOUND',
        detail: 'Support type could not be found.',
    },
    [ErrorCodeApi.AGENT_OWNER_INVALID]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'Support agent owner type is invalid.',
    },
    [ErrorCodeApi.SUPPORT_TYPE_MISMATCH]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'Resource support types are not compatible.',
    },
    [ErrorCodeApi.SUPPORT_RESOLVE_REASON_EXISTS]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'Support resolve reason already exists.',
    },
    [ErrorCodeApi.SUPPORT_TAG_EXISTS]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'Support tag already exists.',
    },
    [ErrorCodeApi.SERVICE_OFFERING_NOT_FOUND]: {
        http_code: 404,
        old_code: 'BAD_REQUEST',
        detail: 'The service offering is not found.',
    },
    [ErrorCodeApi.SERVICE_OFFERING_IS_INVALID]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'The service offering requested is invalid or the request is invalid to be performed.',
    },
    [ErrorCodeApi.SERVICE_OFFERING_ATTACHMENT_NOT_FOUND]: {
        http_code: 404,
        old_code: 'BAD_REQUEST',
        detail: 'Did not find temp file matching the uuid under service_offering_attachments context.',
    },
    [ErrorCodeApi.INVALID_SERVICE_OFFERING_JOB_ID]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'The service offering job ids are not valid.',
    },
    [ErrorCodeApi.SERVICE_OFFERING_IS_NOT_ACTIVE]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'The service offering cannot be hidden as it is not active.',
    },
    [ErrorCodeApi.MULTIPLE_CREATOR_IDS_WITH_INVALID_STATUS]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'Multiple creator ids with status other than ACTIVE is not a valid combination.',
    },
    [ErrorCodeApi.USER_LOGO_NOT_FOUND]: {
        http_code: 404,
        old_code: 'USER_LOGO_NOT_FOUND',
        detail: "The user's logo does not exist.",
    },
    [ErrorCodeApi.CONTEST_NOT_ACTIVE]: {
        http_code: 400,
        old_code: 'CONTEST_NOT_ACTIVE',
        detail: 'Contest is draft or awarded.',
    },
    [ErrorCodeApi.CONTEST_CUSTOM_JUDGING_UPGRADE_REQUIRED]: {
        http_code: 400,
        old_code: 'CONTEST_CUSTOM_JUDGING_UPGRADE_REQUIRED',
        detail: "Contest doesn't have the Custom Judging upgrade.",
    },
    [ErrorCodeApi.CONTEST_RUBRIC_ALREADY_CREATED]: {
        http_code: 400,
        old_code: 'CONTEST_RUBRIC_ALREADY_CREATED',
        detail: 'Contest already has a rubric created.',
    },
    [ErrorCodeApi.CONTEST_RUBRIC_NOT_FOUND]: {
        http_code: 404,
        old_code: 'CONTEST_RUBRIC_NOT_FOUND',
        detail: 'The rubric could not be found.',
    },
    [ErrorCodeApi.CONTEST_RUBRIC_SUBMISSION_NOT_FOUND]: {
        http_code: 404,
        old_code: 'CONTEST_RUBRIC_SUBMISSION_NOT_FOUND',
        detail: 'The submission could not be found.',
    },
    [ErrorCodeApi.ENTRY_INVALID_ACTION]: {
        http_code: 400,
        old_code: 'ENTRY_INVALID_ACTION',
        detail: 'Action cannot be performed on this entry.',
    },
    [ErrorCodeApi.ENTRY_INVALID_SELL_PRICE_BELOW_MINIMUM]: {
        http_code: 400,
        old_code: 'ENTRY_INVALID_SELL_PRICE',
        detail: 'The provided sell price is below the minimum allowed value.',
    },
    [ErrorCodeApi.ENTRY_INVALID_SELL_PRICE_ABOVE_MAXIMUM]: {
        http_code: 400,
        old_code: 'ENTRY_INVALID_SELL_PRICE',
        detail: 'The provided sell price is above the maximum allowed value.',
    },
    [ErrorCodeApi.CONTEST_LOAD_FAILED]: {
        http_code: 500,
        old_code: 'CONTEST_LOAD_FAILED',
        detail: 'Failed to load contest.',
    },
    [ErrorCodeApi.SHARE_PROJECT_CLOSED_PROJECT]: {
        http_code: 400,
        old_code: 'SHARE_PROJECT_CLOSED_PROJECT',
        detail: 'You cannot add a collaborator on a closed project.',
    },
    [ErrorCodeApi.INVITATION_TOKEN_INVALID]: {
        http_code: 400,
        old_code: 'INVITATION_TOKEN_INVALID',
        detail: 'The invitation token is invalid.',
    },
    [ErrorCodeApi.INVITATION_INVALID]: {
        http_code: 400,
        old_code: 'INVITATION_INVALID',
        detail: 'The invitation is no longer valid.',
    },
    [ErrorCodeApi.INVITATION_LINK_CLOSED]: {
        http_code: 400,
        old_code: 'INVITATION_LINK_CLOSED',
        detail: 'The invitation link is closed.',
    },
    [ErrorCodeApi.INVITATION_POOL_NOT_ALLOWED]: {
        http_code: 403,
        old_code: 'INVITATION_POOL_NOT_ALLOWED',
        detail: 'The invitee entity has no pools in common with the context entity.',
    },
    [ErrorCodeApi.TAX_NUMBER_INVALID]: {
        http_code: 400,
        old_code: 'TAX_NUMBER_INVALID',
        detail: 'The tax number entered is invalid.',
    },
    [ErrorCodeApi.TAX_TYPE_NOT_SUPPORTED]: {
        http_code: 400,
        old_code: 'TAX_TYPE_NOT_SUPPORTED ',
        detail: 'Tax type is not supported for this region.',
    },
    [ErrorCodeApi.TAX_NUMBER_DUPLICATE]: {
        http_code: 409,
        old_code: 'TAX_NUMBER_DUPLICATE',
        detail: 'Tax number already exists.',
    },
    [ErrorCodeApi.TAX_SUBTYPE_INVALID]: {
        http_code: 400,
        old_code: 'TAX_SUBTYPE_INVALID',
        detail: 'Invalid subtype provided for tax type.',
    },
    [ErrorCodeApi.TAX_DEACTIVATE_NOT_ALLOWED]: {
        http_code: 400,
        old_code: 'TAX_DEACTIVATE_NOT_ALLOWED',
        detail: 'You are not allowed to delete this tax type.',
    },
    [ErrorCodeApi.TAX_NUMBER_DOES_NOT_EXIST]: {
        http_code: 404,
        old_code: 'TAX_NUMBER_DOES_NOT_EXIST',
        detail: 'Tax number does not exist.',
    },
    [ErrorCodeApi.US_TAX_MATCH_REJECTED]: {
        http_code: 403,
        old_code: 'US_TAX_MATCH_REJECTED',
        detail: 'We were unable to verify your TIN against IRS records.',
    },
    [ErrorCodeApi.US_TAX_MATCH_COMMUNICATION_ERROR]: {
        http_code: 500,
        old_code: 'US_TAX_MATCH_COMMUNICATION_ERROR',
        detail: 'We were unable to communicate with our service to verify your TIN.',
    },
    [ErrorCodeApi.TAX_NAME_INVALID]: {
        http_code: 400,
        old_code: 'TAX_NAME_INVALID',
        detail: 'Invalid name provided for tax type.',
    },
    [ErrorCodeApi.TAX_STATEMENT_ERROR]: {
        http_code: 400,
        old_code: 'TAX_STATEMENT_ERROR',
        detail: 'Unable to upload tax statement.',
    },
    [ErrorCodeApi.TAX_OPT_OUT_NOT_ALLOWED]: {
        http_code: 400,
        old_code: 'TAX_OPT_OUT_NOT_ALLOWED',
        detail: 'You are not allowed to opt-out from this tax type.',
    },
    [ErrorCodeApi.TAX_OPT_OUT_INVALID_OPTION]: {
        http_code: 400,
        old_code: 'TAX_OPT_OUT_INVALID_OPTION',
        detail: 'You entered an invalid option for this tax type.',
    },
    [ErrorCodeApi.TAX_OPT_OUT_EXTRA_DETAILS_REQUIRED]: {
        http_code: 400,
        old_code: 'TAX_OPT_OUT_EXTRA_DETAILS_REQUIRED',
        detail: 'Missing extra details for tax opt-out option.',
    },
    [ErrorCodeApi.TAX_OPT_OUT_NOT_FOUND]: {
        http_code: 404,
        old_code: 'TAX_OPT_OUT_NOT_FOUND',
        detail: 'Tax opt out reason not found.',
    },
    [ErrorCodeApi.TAX_OPT_OUT_DUPLICATE]: {
        http_code: 409,
        old_code: 'TAX_OPT_OUT_DUPLICATE',
        detail: 'You already opted out of this tax type.',
    },
    [ErrorCodeApi.TAX_OPT_OUT_REVERT_NOT_ALLOWED]: {
        http_code: 400,
        old_code: 'TAX_OPT_OUT_REVERT_NOT_ALLOWED',
        detail: 'You are not allowed to revert opt-out reason from this tax type.',
    },
    [ErrorCodeApi.PAYMENT_AGREEMENT_ID_NOT_FOUND]: {
        http_code: 400,
        old_code: 'PAYMENT_AGREEMENT_ID_NOT_FOUND',
        detail: 'Agreement ID does not exist.',
    },
    [ErrorCodeApi.PAYMENT_AGREEMENT_ID_NOT_CANCELLABLE]: {
        http_code: 400,
        old_code: 'PAYMENT_AGREEMENT_ID_NOT_CANCELLABLE',
        detail: 'Agreement ID can not be cancelled.',
    },
    [ErrorCodeApi.PAYMENT_AGREEMENT_REQUIRED_FOR_ACTIVE_SUBSCRIPTION]: {
        http_code: 400,
        old_code: 'PAYMENT_AGREEMENT_REQUIRED_FOR_ACTIVE_SUBSCRIPTION',
        detail: 'You have an active membership subscription which requires a payment method.',
    },
    [ErrorCodeApi.PAYMENT_AGREEMENT_REQUIRED_FOR_ACTIVE_HOURLY_CONTRACT]: {
        http_code: 400,
        old_code: 'PAYMENT_AGREEMENT_REQUIRED_FOR_ACTIVE_HOURLY_CONTRACT',
        detail: 'You have an active hourly contract which requires a payment method.',
    },
    [ErrorCodeApi.PAYMENT_AGREEMENT_REQUIRED_FOR_FAILED_INVOICE]: {
        http_code: 400,
        old_code: 'PAYMENT_AGREEMENT_REQUIRED_FOR_FAILED_INVOICE',
        detail: 'You have an hourly contract with failed invoice which requires a payment method.',
    },
    [ErrorCodeApi.PAYMENT_BIN_COUNTRY_BLOCKED]: {
        http_code: 403,
        old_code: 'PAYMENT_BIN_COUNTRY_BLOCKED',
        detail: 'We are not currently accepting payments from cards issued in your country.',
    },
    [ErrorCodeApi.PAYMENT_BIN_BLOCKED]: {
        http_code: 403,
        old_code: 'PAYMENT_BIN_BLOCKED',
        detail: 'We are not currently accepting payments with your credit card.',
    },
    [ErrorCodeApi.PAYMENT_CART_ALREADY_HAS_APPROVAL_REQUEST]: {
        http_code: 400,
        old_code: 'CART_ALREADY_HAS_APPROVAL_REQUEST',
        detail: 'You have already requested approval of this cart.',
    },
    [ErrorCodeApi.PAYMENT_CART_APPROVAL_DOES_NOT_EXIST]: {
        http_code: 400,
        old_code: 'CART_APPROVAL_DOES_NOT_EXIST',
        detail: 'A cart approval was not found.',
    },
    [ErrorCodeApi.PAYMENT_BIN_MISSING]: {
        http_code: 403,
        old_code: 'PAYMENT_BIN_MISSING',
        detail: 'The credit card you entered is not supported and cannot be processed.',
    },
    [ErrorCodeApi.APPLICATION_CAPTCHA_INVALID]: {
        http_code: 400,
        old_code: 'INVALID_CAPTCHA',
        detail: 'The captcha is invalid. Please try again.',
    },
    [ErrorCodeApi.APPLICATION_EMAIL_INVALID]: {
        http_code: 400,
        old_code: 'APPLICATION_EMAIL_INVALID',
        detail: 'The email provided does not belong to any Freelancer account.',
    },
    [ErrorCodeApi.APPLICATION_DUPLICATE]: {
        http_code: 400,
        old_code: 'APPLICATION_DUPLICATE',
        detail: 'You already sent an application for review.',
    },
    [ErrorCodeApi.APPLICATION_ATTACHMENT_TOO_BIG]: {
        http_code: 400,
        old_code: 'APPLICATION_ATTACHMENT_TOO_BIG',
        detail: 'The attachment provided exceeds the maximum file size of 10 MB.',
    },
    [ErrorCodeApi.APPLICATION_ATTACHMENT_INVALID]: {
        http_code: 400,
        old_code: 'APPLICATION_ATTACHMENT_INVALID',
        detail: 'Invalid file type for attachment provided.',
    },
    [ErrorCodeApi.SALES_TAX_NOT_FOUND]: {
        http_code: 404,
        old_code: 'SALES_TAX_NOT_FOUND',
        detail: 'Sales tax setting not found.',
    },
    [ErrorCodeApi.SALES_TAX_COUNTRY_DUPLICATE]: {
        http_code: 400,
        old_code: 'SALES_TAX_COUNTRY_DUPLICATE',
        detail: 'Sales tax setting with that country code already exists.',
    },
    [ErrorCodeApi.MESSAGING_THREAD_DUPLICATE]: {
        http_code: 409,
        old_code: 'DUPLICATE_THREAD',
        detail: 'Thread already exists.',
    },
    [ErrorCodeApi.CURRENCY_NOT_FOUND]: {
        http_code: 404,
        old_code: 'CURRENCY_NOT_FOUND',
        detail: 'Currency does not exist.',
    },
    [ErrorCodeApi.CONTENT_CUSTOMIZATION_INVALID]: {
        http_code: 400,
        old_code: 'CONTENT_CUSTOMIZATION_INVALID',
        detail: 'Content customization contains malformatted rich text.',
    },
    [ErrorCodeApi.CONTENT_CUSTOMIZATION_FILE_NOT_FOUND]: {
        http_code: 404,
        old_code: 'CONTENT_CUSTOMIZATION_FILE_NOT_FOUND',
        detail: 'Content customization file does not exist in the file server.',
    },
    [ErrorCodeApi.CONTENT_CUSTOMIZATION_FILE_EXCEEDS_LIMIT]: {
        http_code: 400,
        old_code: 'CONTENT_CUSTOMIZATION_ALREADY_EXISTS',
        detail: 'Content customization contains too many video or image elements.',
    },
    [ErrorCodeApi.CONTENT_CUSTOMIZATION_ALREADY_EXISTS]: {
        http_code: 409,
        old_code: 'CONTENT_CUSTOMIZATION_ALREADY_EXISTS',
        detail: 'Content customization already exists for this context.',
    },
    [ErrorCodeApi.CONTENT_CUSTOMIZATION_NOT_FOUND]: {
        http_code: 404,
        old_code: 'CONTENT_CUSTOMIZATION_NOT_FOUND',
        detail: "Content customization doesn't exist.",
    },
    [ErrorCodeApi.PROJECT_BUDGET_MIN_MAX_INVALID]: {
        http_code: 400,
        old_code: 'PROJECT_BUDGET_MIN_MAX_INVALID',
        detail: 'Project budget minimum must be smaller than maximum.',
    },
    [ErrorCodeApi.PROJECT_BUDGET_VALUE_MISSING]: {
        http_code: 400,
        old_code: 'PROJECT_BUDGET_VALUE_MISSING',
        detail: 'Both Project budget minimum and maximum are required.',
    },
    [ErrorCodeApi.PROJECT_BUDGET_VALUE_TYPE_INVALID]: {
        http_code: 400,
        old_code: 'PROJECT_BUDGET_VALUE_TYPE_INVALID',
        detail: 'Both Project budget minimum and maximum values should be numbers.',
    },
    [ErrorCodeApi.USER_NOT_IN_PFP]: {
        http_code: 400,
        old_code: 'USER_NOT_IN_PFP',
        detail: 'You are not in the Preferred Freelancer Program.',
    },
    [ErrorCodeApi.PFP_SKILL_NOT_FOUND]: {
        http_code: 404,
        old_code: 'PFP_SKILL_NOT_FOUND',
        detail: 'Preferred Freelancer Program skill does not exist.',
    },
    [ErrorCodeApi.PFP_SKILL_INVALID]: {
        http_code: 400,
        old_code: 'PFP_SKILL_INVALID',
        detail: 'This skill is not allowed to be used for the Preferred Freelancer Program.',
    },
    [ErrorCodeApi.PFP_SKILL_DUPLICATE]: {
        http_code: 409,
        old_code: 'PFP_SKILL_DUPLICATE',
        detail: 'This skill is already added.',
    },
    [ErrorCodeApi.TRANSLATIONS_FILTER_INVALID_LIMIT]: {
        http_code: 400,
        old_code: 'TRANSLATIONS_FILTER_INVALID_LIMIT',
        detail: 'You have requested too many objects. Lower your limit.',
    },
    [ErrorCodeApi.OPERATING_AREA_NOT_FOUND]: {
        http_code: 404,
        old_code: 'OPERATING_AREA_NOT_FOUND',
        detail: 'Operating area does not exist.',
    },
    [ErrorCodeApi.EQUIPMENT_GROUP_NOT_FOUND]: {
        http_code: 400,
        old_code: 'INVALID_REQUEST',
        detail: 'No equipment group mapping matched this query.',
    },
    [ErrorCodeApi.PROJECT_SOURCE_NOT_FOUND]: {
        http_code: 404,
        old_code: 'PROJECT_SOURCE_NOT_FOUND',
        detail: 'Project source does not exist.',
    },
    [ErrorCodeApi.LINKED_EXTERNAL_PROJECT_UPDATE_NOT_ALLOWED]: {
        http_code: 403,
        old_code: 'LINKED_EXTERNAL_PROJECT_UPDATE_NOT_ALLOWED',
        detail: 'You are not allowed to edit a linked external project.',
    },
    [ErrorCodeApi.LINKED_EXTERNAL_PROJECT_INVALID]: {
        http_code: 400,
        old_code: 'LINKED_EXTERNAL_PROJECT_INVALID',
        detail: 'The linked external project is invalid.',
    },
    [ErrorCodeApi.LINKED_EXTERNAL_PROJECT_ALREADY_EXISTS]: {
        http_code: 400,
        old_code: 'LINKED_EXTERNAL_PROJECT_ALREADY_EXISTS',
        detail: 'A linked external project already exists in the same pool.',
    },
    [ErrorCodeApi.USER_CUSTOM_EMAIL_LIMIT_REACHED]: {
        http_code: 400,
        old_code: 'USER_CUSTOM_EMAIL_LIMIT_REACHED',
        detail: 'You reached the limit of user custom emails for this context.',
    },
    [ErrorCodeApi.USER_CUSTOM_EMAIL_TEMPLATE_DATA_INVALID]: {
        http_code: 400,
        old_code: 'USER_CUSTOM_EMAIL_TEMPLATE_DATA_INVALID',
        detail: 'The email template data for this user custom email is invalid.',
    },
    [ErrorCodeApi.USER_CUSTOM_EMAIL_RECIPIENT_INVALID]: {
        http_code: 400,
        old_code: 'USER_CUSTOM_EMAIL_RECIPIENT_INVALID',
        detail: 'The recipient email address for this user custom email is invalid.',
    },
    [ErrorCodeApi.WIRE_ACCOUNT_VALIDATION_FAIL]: {
        http_code: 400,
        old_code: 'WIRE_ACCOUNT_VALIDATION_FAIL',
        detail: 'Wire payout account details are invalid',
    },
    [ErrorCodeApi.CORPORATE_TEAM_REGISTRATION_DUPLICATE]: {
        http_code: 400,
        old_code: 'CORPORATE_TEAM_REGISTRATION_DUPLICATE',
        detail: 'You already registered for the corporate teams beta.',
    },
    [ErrorCodeApi.CORPORATE_TEAM_REGISTRATION_NOT_ALLOWED]: {
        http_code: 403,
        old_code: 'CORPORATE_TEAM_REGISTRATION_NOT_ALLOWED',
        detail: 'You are not allowed to register.',
    },
    [ErrorCodeApi.CORPORATE_TEAM_REGISTRATION_INVALID]: {
        http_code: 400,
        old_code: 'CORPORATE_TEAM_REGISTRATION_INVALID',
        detail: 'One of the invitees is invalid.',
    },
    [ErrorCodeApi.BID_PITCH_NOT_FOUND]: {
        http_code: 404,
        old_code: 'BID_PITCH_NOT_FOUND',
        detail: 'Bid pitch not found.',
    },
    [ErrorCodeApi.CHARGE_PROJECT_FEE_INSUFFICIENT_FUND]: {
        http_code: 402,
        old_code: 'CHARGE_PROJECT_FEE_INSUFFICIENT_FUND',
        detail: 'Insufficient remaining fund for project fee.',
    },
    [ErrorCodeApi.USER_DOCUMENT_SUBMISSION_DUPLICATE]: {
        http_code: 400,
        old_code: 'USER_DOCUMENT_SUBMISSION_DUPLICATE',
        detail: 'You have already submitted a document.',
    },
    [ErrorCodeApi.USER_DOCUMENT_SUBMISSION_NOT_FOUND]: {
        http_code: 404,
        old_code: 'USER_DOCUMENT_SUBMISSION_NOT_FOUND',
        detail: 'User document submission not found.',
    },
    [ErrorCodeApi.DOCUMENT_TYPE_NOT_FOUND]: {
        http_code: 404,
        old_code: 'DOCUMENT_TYPE_NOT_FOUND',
        detail: 'Document type not found.',
    },
    [ErrorCodeApi.DOCUMENT_TYPE_FILE_NOT_FOUND]: {
        http_code: 404,
        old_code: 'DOCUMENT_TYPE_FILE_NOT_FOUND',
        detail: 'Document type file not found.',
    },
    [ErrorCodeApi.DOCUMENT_TYPE_FIELD_NOT_FOUND]: {
        http_code: 404,
        old_code: 'DOCUMENT_TYPE_FIELD_NOT_FOUND',
        detail: 'Document type field not found.',
    },
    [ErrorCodeApi.VERIFICATION_PROCESS_TYPE_NOT_FOUND]: {
        http_code: 404,
        old_code: 'VERIFICATION_PROCESS_TYPE_NOT_FOUND',
        detail: 'Verification process type not found.',
    },
    [ErrorCodeApi.CARD_AUTHENTICATION_REQUIRED]: {
        http_code: 403,
        old_code: 'CARD_AUTHENTICATION_REQUIRED',
        detail: 'You are required to authenticate your card before taking this action.',
    },
    [ErrorCodeApi.USER_VERIFICATION_PROCESS_NOT_FOUND]: {
        http_code: 404,
        old_code: 'USER_VERIFICATION_PROCESS_NOT_FOUND',
        detail: 'User verification process not found.',
    },
    [ErrorCodeApi.USER_VERIFICATION_PROCESS_ALREADY_ACTIVE]: {
        http_code: 409,
        old_code: 'USER_VERIFICATION_PROCESS_ALREADY_ACTIVE',
        detail: 'User verification process is already active',
    },
    [ErrorCodeApi.USER_DOCUMENT_SUBMISSION_ALREADY_ACTIVE]: {
        http_code: 409,
        old_code: 'USER_DOCUMENT_SUBMISSION_ALREADY_ACTIVE',
        detail: 'User document submission is already active',
    },
    [ErrorCodeApi.DELIVERY_ITEMS_BELONG_TO_OTHER_PROJECT]: {
        http_code: 403,
        old_code: 'DELIVERY_ITEMS_BELONG_TO_OTHER_PROJECT',
        detail: 'You cannot edit delivery items that do not belong to this project.',
    },
    [ErrorCodeApi.DELIVERY_ITEMS_INVALID]: {
        http_code: 400,
        old_code: 'DELIVERY_ITEMS_INVALID',
        detail: 'Delivery items are invalid.',
    },
    [ErrorCodeApi.PROJECT_HAS_ACTIVE_BIDS]: {
        http_code: 403,
        old_code: 'PROJECT_HAS_ACTIVE_BIDS',
        detail: "The project can't be edited because it has active bids.",
    },
    [ErrorCodeApi.PAYOUT_LIMIT_EXEMPTION_DUPLICATE]: {
        http_code: 403,
        old_code: 'PAYOUT_LIMIT_EXEMPTION_DUPLICATE',
        detail: 'User has an existing active payout limit exemption',
    },
    [ErrorCodeApi.PAYOUT_LIMIT_EXEMPTION_NOT_FOUND]: {
        http_code: 404,
        old_code: 'PAYOUT_LIMIT_EXEMPTION_NOT_FOUND',
        detail: 'Payout limit exemption does not exist',
    },
    [ErrorCodeApi.PAYMENT_SHARING_INVALID_DATE_TIME_RANGE]: {
        http_code: 400,
        old_code: 'PAYMENT_SHARING_INVALID_DATE_TIME_RANGE',
        detail: 'Invalid date/time range.',
    },
    [ErrorCodeApi.BLACKLISTED_WORD_FOUND]: {
        http_code: 400,
        old_code: 'BLACKLISTED_WORD_FOUND',
        detail: 'Blacklisted word found in the openAI response.',
    },
    [ErrorCodeApi.USER_AVAILABILITY_NOT_FOUND]: {
        http_code: 404,
        old_code: 'USER_AVAILABILITY_NOT_FOUND',
        detail: 'User availability not found',
    },
    [ErrorCodeApi.USER_AVAILABILITY_INVALID_DATE_RANGE]: {
        http_code: 400,
        old_code: 'USER_AVAILABILITY_INVALID_DATE_RANGE',
        detail: 'The provided user availability date range is invalid.',
    },
    [ErrorCodeApi.RECRUITER_UPGRADE_DUPLICATE]: {
        http_code: 400,
        old_code: 'RECRUITER_UPGRADE_DUPLICATE',
        detail: 'The project already has a Recruiter upgrade.',
    },
    [ErrorCodeApi.FREE_RECRUITER_UPGRADE_NOT_ALLOWED]: {
        http_code: 403,
        old_code: 'FREE_RECRUITER_UPGRADE_NOT_ALLOWED',
        detail: 'This project is not eligible for a Free Recruiter upgrade.',
    },
    [ErrorCodeApi.NEXT_PROJECT_RECOMMENDATIONS_INVALID_PROJECT]: {
        http_code: 400,
        old_code: 'NEXT_PROJECT_RECOMMENDATIONS_INVALID_PROJECT',
        detail: 'The project does not have the required attributes.',
    },
    [ErrorCodeApi.NEXT_PROJECT_RECOMMENDATIONS_INVALID_OPENAI_RESPONSE_FORMAT]: {
        http_code: 500,
        old_code: 'NEXT_PROJECT_RECOMMENDATIONS_INVALID_OPENAI_RESPONSE_FORMAT',
        detail: 'The format of the response from OpenAI is not usable.',
    },
    [ErrorCodeApi.PROFILE_LIMIT_REACHED]: {
        http_code: 400,
        old_code: 'PROFILE_LIMIT_REACHED',
        detail: 'You have reached the limit for creating new profiles.',
    },
    [ErrorCodeApi.DEFAULT_PROFILE_ALREADY_EXISTS]: {
        http_code: 409,
        old_code: 'DEFAULT_PROFILE_ALREADY_EXISTS',
        detail: 'A default profile already exists for this user.',
    },
    [ErrorCodeApi.PROFILE_NAME_ALREADY_EXISTS]: {
        http_code: 409,
        old_code: 'PROFILE_NAME_ALREADY_EXISTS',
        detail: 'A profile with this name already exists for this user.',
    },
    [ErrorCodeApi.SUGGESTED_MESSAGE_CURRENT_USER_NOT_SUPPORT_AGENT]: {
        http_code: 403,
        old_code: 'SUGGESTED_MESSAGE_CURRENT_USER_NOT_SUPPORT_AGENT',
        detail: 'You must be a support agent to perform this action.',
    },
    [ErrorCodeApi.SUGGESTED_MESSAGE_WRONG_CONTEXT_TYPE]: {
        http_code: 400,
        old_code: 'SUGGESTED_MESSAGE_WRONG_CONTEXT_TYPE',
        detail: 'Suggested messages can only be generated for support chat threads on projects.',
    },
    [ErrorCodeApi.SUGGESTED_MESSAGE_ENTERPRISE_NOT_SUPPORTED]: {
        http_code: 400,
        old_code: 'SUGGESTED_MESSAGE_ENTERPRISE_NOT_SUPPORTED',
        detail: 'Suggested messages are currently not supported for this enterprise.',
    },
    [ErrorCodeApi.SUGGESTED_MESSAGE_THREAD_NOT_FOUND]: {
        http_code: 404,
        old_code: 'SUGGESTED_MESSAGE_THREAD_NOT_FOUND',
        detail: 'The thread does not exist.',
    },
    [ErrorCodeApi.SUGGESTED_MESSAGE_SUPPORT_TYPE_NOT_SUPPORTED]: {
        http_code: 400,
        old_code: 'SUGGESTED_MESSAGE_SUPPORT_TYPE_NOT_SUPPORTED',
        detail: 'Suggested messages are currently not supported for this support type.',
    },
    [ErrorCodeApi.PROJECT_SEO_DELOITTE_AUTH_REQUIRED]: {
        http_code: 401,
        old_code: 'PROJECT_SEO_DELOITTE_AUTH_REQUIRED',
        detail: 'You need to log in deloitte to continue.',
    },
    [ErrorCodeApi.PCB_USER_IS_ALREADY_BANNED]: {
        http_code: 400,
        old_code: 'PCB_USER_IS_ALREADY_BANNED',
        detail: 'User is already banned.',
    },
    [ErrorCodeApi.PCB_USER_IS_ALREADY_UNBANNED]: {
        http_code: 400,
        old_code: 'PCB_USER_IS_ALREADY_UNBANNED',
        detail: 'User is already unbanned.',
    },
    [ErrorCodeApi.CONTEST_HANDOVER_UNDER_DISPUTE]: {
        http_code: 400,
        old_code: 'HANDOVER_UNDER_DISPUTE',
        detail: 'You can not perform this action as the handover is currently under dispute.',
    },
    [ErrorCodeApi.CONTEST_HANDOVER_CONFIRMED]: {
        http_code: 400,
        old_code: 'HANDOVER_CONFIRMED',
        detail: 'You have already confirmed.',
    },
    [ErrorCodeApi.CONTEST_HANDOVER_CONTRACT_NOT_SIGNED]: {
        http_code: 400,
        old_code: 'HANDOVER_CONTRACT_NOT_SIGNED',
        detail: 'You must sign the contract before confirmation.',
    },
    [ErrorCodeApi.CONTEST_HANDOVER_NO_FILES_UPLOADED]: {
        http_code: 400,
        old_code: 'HANDOVER_NO_FILES_UPLOADED',
        detail: 'No files have been uploaded yet!',
    },
    [ErrorCodeApi.CONTEST_HANDOVER_FILES_NOT_CONFIRMED]: {
        http_code: 400,
        old_code: 'HANDOVER_FILES_NOT_CONFIRMED',
        detail: 'You can not accept files before the seller confirmed that files uploading finished',
    },
    [ErrorCodeApi.CONTEST_HANDOVER_RELEASE_PRIZE_FORBIDDEN]: {
        http_code: 403,
        old_code: 'HANDOVER_RELEASE_PRIZE_FORBIDDEN',
        detail: 'You are not allowed to release the prize due to account security reasons.',
    },
    [ErrorCodeApi.CONTEST_ENTRY_INVALID_ID]: {
        http_code: 400,
        old_code: 'INVALID_ENTRY_ID',
        detail: 'You must supply the id of the entry you want to update.',
    },
    [ErrorCodeApi.CONTEST_HANDOVER_ENTRY_NOT_WON]: {
        http_code: 400,
        old_code: 'HANDOVER_ENTRY_NOT_WON',
        detail: 'You can only close won entries.',
    },
    [ErrorCodeApi.CONTEST_HANDOVER_ACCESS_DENIED]: {
        http_code: 403,
        old_code: 'HANDOVER_ACCESS_DENIED',
        detail: 'You are not allowed to access this handover',
    },
    [ErrorCodeApi.CONTEST_HANDOVER_FILE_NOT_OWNER]: {
        http_code: 403,
        old_code: 'HANDLER_ERROR',
        detail: 'You are not the owner of this file.',
    },
    [ErrorCodeApi.OFFER_PRICE_CHANGED]: {
        http_code: 400,
        old_code: 'BAD_REQUEST',
        detail: 'The offer price has changed.',
    },
    [ErrorCodeApi.AI_PROMPT_INVALID_TEMPLATE]: {
        http_code: 400,
        old_code: 'AI_PROMPT_INVALID_TEMPLATE',
        detail: 'The provided template is invalid.',
    },
    [ErrorCodeApi.AI_PROMPT_NOT_FOUND]: {
        http_code: 400,
        old_code: 'AI_PROMPT_NOT_FOUND',
        detail: 'AI Prompt not found.',
    },
    [ErrorCodeApi.BIDDER_FROM_SANCTIONED_NATION]: {
        http_code: 403,
        old_code: 'SANCTIONED_NATION',
        detail: 'Users from sanctioned nations are not allowed to place a bid.',
    },
    [ErrorCodeApi.PREFERRED_AGENT_UNSUPPORTED_SUPPORT_TYPE]: {
        http_code: 400,
        old_code: 'PREFERRED_AGENT_UNSUPPORTED_SUPPORT_TYPE',
        detail: 'Unsupported support type for Preferred Support Agent.',
    },
    [ErrorCodeApi.PREFERRED_AGENT_ASSIGNMENT_NOT_FOUND]: {
        http_code: 404,
        old_code: 'PREFERRED_AGENT_ASSIGNMENT_NOT_FOUND',
        detail: 'Preferred Support Agent for user and support type not found.',
    },
    [ErrorCodeApi.PREFERRED_AGENT_LOADSHIFT_ASSIGNED]: {
        http_code: 400,
        old_code: 'PREFERRED_AGENT_LOADSHIFT_ASSIGNED',
        detail: 'Preferred Support Agent already exists for this user in Loadshift queues.',
    },
    [ErrorCodeApi.PROJECT_COLLABORATION_GROUP_CHAT_INVITATION_ERROR]: {
        http_code: 400,
        old_code: 'PROJECT_COLLABORATION_GROUP_CHAT_INVITATION_ERROR',
        detail: 'Error while inviting users to the project collaboration group chat.',
    },
    [ErrorCodeApi.USER_ACCOUNT_ATO_SERR_REQUIREMENT_NOT_MET]: {
        http_code: 400,
        old_code: 'USER_ACCOUNT_ATO_SERR_REQUIREMENT_NOT_MET',
        detail: 'You must provide ATO SERR information to perform this action.',
    },
    [ErrorCodeApi.FINANCIAL_REPORTING_RECORD_ALREADY_EXISTS]: {
        http_code: 400,
        old_code: 'FINANCIAL_REPORTING_RECORD_ALREADY_EXISTS',
        detail: 'Financial reporting record already exists.',
    },
    [ErrorCodeApi.SHOWCASE_CANNOT_FETCH_MIGRATED_IDS_FOR_USER]: {
        http_code: 500,
        old_code: 'SHOWCASE_CANNOT_FETCH_MIGRATED_IDS_FOR_USER',
        detail: 'Cannot fetch migrated showcase ids for user.',
    },
    [ErrorCodeApi.SHOWCASE_CANNOT_FETCH_SHOWCASE_IDS_FOR_USER]: {
        http_code: 500,
        old_code: 'SHOWCASE_CANNOT_FETCH_SHOWCASE_IDS_FOR_USER',
        detail: 'Cannot fetch showcase ids for user.',
    },
    [ErrorCodeApi.SHOWCASE_FAILED_TO_ADD_SHOWCASE_ITEM_JOBS]: {
        http_code: 500,
        old_code: 'FAILED_TO_ADD_SHOWCASE_ITEM_JOBS',
        detail: 'Failed to add showcase item jobs.',
    },
    [ErrorCodeApi.SHOWCASE_ERROR_DELETING_SHOWCASE]: {
        http_code: 500,
        old_code: 'SHOWCASE_ERROR_DELETING_SHOWCASE',
        detail: 'Error deleting showcase.',
    },
    [ErrorCodeApi.SHOWCASE_SAMPLE_TEXT_TOO_LONG]: {
        http_code: 400,
        old_code: 'SHOWCASE_SAMPLE_TEXT_TOO_LONG',
        detail: 'sample_text is too long.',
    },
    [ErrorCodeApi.SHOWCASE_SAMPLE_TEXT_INVALID]: {
        http_code: 400,
        old_code: 'SHOWCASE_SAMPLE_TEXT_INVALID',
        detail: 'Type of sample_text should be string.',
    },
    [ErrorCodeApi.RECEIVER_ALREADY_IN_CALL]: {
        http_code: 409,
        old_code: 'RECEIVER_ALREADY_IN_CALL',
        detail: 'Receivers are currently in an active call.',
    },
    [ErrorCodeApi.INVALID_VIDEOCHAT_ID]: {
        http_code: 400,
        old_code: 'INVALID_VIDEOCHAT_ID',
        detail: 'Videochat_id already used.',
    },
    [ErrorCodeApi.CHALLENGE_ELEMENT_LINKED_SOURCE_ALREADY_EXISTS]: {
        http_code: 409,
        old_code: 'CHALLENGE_ELEMENT_LINKED_SOURCE_ALREADY_EXISTS',
        detail: 'Failed to add challenge element. Duplicate linked source found.',
    },
    [ErrorCodeApi.CALLER_ALREADY_IN_CALL]: {
        http_code: 409,
        old_code: 'CALLER_ALREADY_IN_CALL',
        detail: 'Caller is currently in an active call.',
    },
    [ErrorCodeApi.DOCUMENT_NOT_FOUND]: {
        http_code: 404,
        old_code: 'DOCUMENT_NOT_FOUND',
        detail: 'No document found.',
    },
    [ErrorCodeApi.DOCUMENT_OPERATION_FAILED]: {
        http_code: 500,
        old_code: 'DOCUMENT_OPERATION_FAILED',
        detail: 'Failed to perform document operation.',
    },
    [ErrorCodeApi.VECTOR_SEARCH_FAILED]: {
        http_code: 500,
        old_code: 'VECTOR_SEARCH_FAILED',
        detail: 'Failed to perform vector search query.',
    },
    [ErrorCodeApi.EMBEDDINGS_NOT_RETURNED]: {
        http_code: 500,
        old_code: 'EMBEDDINGS_NOT_RETURNED',
        detail: 'No embeddings returned from the vectorization process.',
    },
    [ErrorCodeApi.DATA_VECTORIZE_FAILED]: {
        http_code: 500,
        old_code: 'DATA_VECTORIZE_FAILED',
        detail: 'Data vectorization failed.',
    },
    [ErrorCodeApi.NO_DECOMPOSED_QUERY_RETURNED]: {
        http_code: 500,
        old_code: 'NO_DECOMPOSED_QUERY_RETURNED',
        detail: 'No decomposition returned from vector search query decomposition AI task.',
    },
    [ErrorCodeApi.SUPPORT_SESSION_THREAD_NOT_FOUND]: {
        http_code: 404,
        old_code: 'SUPPORT_SESSION_THREAD_NOT_FOUND',
        detail: 'The thread does not exist.',
    },
    [ErrorCodeApi.PROTOTYPER_LIMIT_REACHED]: {
        http_code: 403,
        old_code: 'PROTOTYPER_LIMIT_REACHED',
        detail: "You've reached the maximum number of Prototypes you can create.",
    },
    [ErrorCodeApi.ABN_SERVICE_FAILED]: {
        http_code: 500,
        old_code: 'ABN_SERVICE_FAILED',
        detail: 'Failed to retrieve ABN information from abr service api.',
    },
    [ErrorCodeApi.REVIEW_USER_NEGATIVE_BALANCE]: {
        http_code: 403,
        old_code: 'REVIEW_USER_NEGATIVE_BALANCE',
        detail: 'Your freelancer account has been temporarily suspended, please deposit funds to clear your negative balance.',
    },
};
